import { defineComponent as Ia, computed as _, watch as le, h as pr, inject as ue, onMounted as Ue, onUpdated as Us, onBeforeUnmount as Ea, reactive as _n, readonly as kn, resolveComponent as L, openBlock as y, createElementBlock as M, createVNode as E, withCtx as P, createTextVNode as fe, toDisplayString as K, normalizeClass as me, createElementVNode as w, renderSlot as Ne, createBlock as W, createSlots as Mo, withDirectives as Zt, normalizeStyle as Ie, vShow as xa, createStaticVNode as ka, Fragment as ke, createCommentVNode as q, renderList as nt, getCurrentScope as Da, onScopeDispose as Ma, toRef as Pa, customRef as Hs, ref as H, toValue as Le, watchEffect as Vs, getCurrentInstance as Po, resolveDynamicComponent as yn, unref as V, effectScope as Fs, nextTick as Pe, shallowRef as hr, toRaw as zs, markRaw as Ws, defineAsyncComponent as G, Suspense as Gs, useCssVars as La, withModifiers as oo, toRefs as Lo, isRef as Ys, provide as vn, onUnmounted as Ra, withKeys as fr } from "vue";
import gr from "axios";
import Zs, { useVuelidate as Ba } from "@vuelidate/core";
import ja from "vuedraggable";
const Ua = Symbol("wormhole");
function Ha() {
  const e = ue(Ua);
  if (!e)
    throw new Error(`
    [portal-vue]: Necessary Injection not found. Make sur you installed the plugin properly.`);
  return e;
}
const Va = typeof window < "u";
function Xs(e, t) {
  return e.map((n, o) => [o, n]).sort(function(n, o) {
    return t(n[1], o[1]) || n[0] - o[0];
  }).map((n) => n[1]);
}
function Ks(e, t) {
  const n = Ha();
  function o() {
    if (!Va)
      return;
    const { to: r, name: i, order: s } = e;
    t.default ? n.open({
      to: r,
      from: i,
      order: s,
      content: t.default
    }) : a();
  }
  function a(r) {
    n.close({
      to: r ?? e.to,
      from: e.name
    });
  }
  Ue(() => {
    e.disabled || o();
  }), Us(() => {
    e.disabled ? a() : o();
  }), Ea(() => {
    a();
  }), le(
    () => e.to,
    (r, i) => {
      e.disabled || (i && i !== r && a(i), o());
    }
  );
}
const qs = Ia({
  compatConfig: { MODE: 3 },
  name: "portal",
  props: {
    disabled: { type: Boolean },
    name: { type: [String, Symbol], default: () => Symbol() },
    order: { type: Number },
    slotProps: { type: Object, default: () => ({}) },
    to: {
      type: String,
      default: () => String(Math.round(Math.random() * 1e7))
    }
  },
  setup(e, { slots: t }) {
    return Ks(e, t), () => e.disabled && t.default ? t.default(e.slotProps) : null;
  }
}), Qs = (e, { slots: t }) => {
  var n;
  return (n = t.default) == null ? void 0 : n.call(t);
}, ro = Ia({
  compatConfig: { MODE: 3 },
  name: "portalTarget",
  props: {
    multiple: { type: Boolean, default: !1 },
    name: { type: String, required: !0 },
    slotProps: { type: Object, default: () => ({}) }
  },
  emits: ["change"],
  setup(e, { emit: t, slots: n }) {
    const o = Ha(), a = _(
      () => {
        const r = o.getContentForTarget(
          e.name,
          e.multiple
        ), i = n.wrapper, s = r.map((c) => c.content(e.slotProps)), l = i ? s.flatMap(
          (c) => c.length ? i(c) : []
        ) : s.flat(1);
        return {
          vnodes: l,
          vnodesFn: () => l
        };
      }
    );
    return le(
      a,
      ({ vnodes: r }) => {
        const i = r.length > 0, s = o.transports.get(e.name), l = s ? [...s.keys()] : [];
        t("change", { hasContent: i, sources: l });
      },
      { flush: "post" }
    ), () => {
      var r;
      return a.value.vnodes.length ? [
        pr("div", {
          style: "display: none",
          key: "__portal-vue-hacky-scoped-slot-repair__"
        }),
        pr(Qs, a.value.vnodesFn)
      ] : (r = n.default) == null ? void 0 : r.call(n);
    };
  }
});
function Js(e = !0) {
  const t = _n(/* @__PURE__ */ new Map());
  function n(i) {
    if (!Va)
      return;
    const { to: s, from: l, content: c, order: u = 1 / 0 } = i;
    if (!s || !l || !c)
      return;
    t.has(s) || t.set(s, /* @__PURE__ */ new Map());
    const d = t.get(s), p = {
      to: s,
      from: l,
      content: c,
      order: u
    };
    d.set(l, p);
  }
  function o(i) {
    const { to: s, from: l } = i;
    if (!s || !l)
      return;
    const c = t.get(s);
    !c || (c.delete(l), c.size || t.delete(s));
  }
  function a(i, s) {
    const l = t.get(i);
    if (!l)
      return [];
    const c = Array.from((l == null ? void 0 : l.values()) || []);
    return s ? Xs(
      c,
      (u, d) => u.order - d.order
    ) : [c.pop()];
  }
  const r = {
    open: n,
    close: o,
    transports: t,
    getContentForTarget: a
  };
  return e ? kn(r) : r;
}
const el = Js();
function tl(e, t = {}) {
  t.portalName !== !1 && e.component(t.portalName || "Portal", qs), t.portalTargetName !== !1 && e.component(t.portalTargetName || "PortalTarget", ro);
  const n = t.wormhole ?? el;
  e.provide(Ua, n);
}
const ve = "BASE_COLUMN", Xt = "LAYOUT_NODE_SINGLE_COLUMN", Kt = "LAYOUT_NODE_DOUBLE_COLUMN", qt = "LAYOUT_NODE_TRIPLE_COLUMN", Qt = "LAYOUT_NODE_QUADRUPLE_COLUMN", St = "LAYOUT_NODE_FULL_WIDTH_COLUMN", Jt = "LAYOUT_NODE_LEFT_SIDEBAR", en = "LAYOUT_NODE_RIGHT_SIDEBAR", Se = "LAYOUT_NODE_SHARED_CONTENT", Nt = "CONTENT_NODE_TEXT", mn = "CONTENT_NODE_HEADING", Dn = "CONTENT_NODE_IMAGE", ao = "CONTENT_NODE_CODE", io = "CONTENT_NODE_SPACER", Cn = "CONTENT_NODE_GALLERY", so = "CONTENT_NODE_VIDEO", lo = "CONTENT_NODE_SEPARATOR", co = "CONTENT_NODE_BUTTON", uo = "CONTENT_NODE_FORM", po = "CONTENT_NODE_QUOTE", wn = "CONTENT_NODE_SLIDER", $n = "CONTENT_NODE_CARD", ho = "CONTENT_NODE_TABLE", Ye = "CONTENT_NODE_ACCORDION", Re = "CONTENT_NODE_PANEL", Sn = "CONTENT_NODE_LIST", Nn = "CONTENT_NODE_NAVIGATION", tn = "CONTENT_NODE_SHARED_CONTENT_ERROR", ct = "layout", dt = "content", Ro = "sub_content", vr = "default", LS = "light", RS = "dark", Bo = [
  {
    name: "One Column",
    icon: "OneColumnIcon",
    type: Xt
  },
  {
    name: "Two Columns",
    icon: "TwoColumnsIcon",
    type: Kt
  },
  {
    name: "Three Columns",
    icon: "ThreeColumnsIcon",
    type: qt
  },
  {
    name: "Four Columns",
    icon: "FourColumnsIcon",
    type: Qt
  },
  {
    name: "Left Sidebar",
    icon: "LeftSidebarIcon",
    type: Jt
  },
  {
    name: "Right Sidebar",
    icon: "RightSidebarIcon",
    type: en
  },
  {
    name: "Full Width",
    icon: "FullWidthIcon",
    type: St
  }
].map((e) => ({ ...e, group: ct })), Mn = [
  {
    name: "Heading",
    icon: "HeadingIcon",
    type: mn
  },
  {
    name: "Text",
    icon: "TextIcon",
    type: Nt
  },
  {
    name: "Image",
    icon: "ImageIcon",
    type: Dn
  },
  {
    name: "Gallery",
    icon: "GalleryIcon",
    type: Cn
  },
  {
    name: "Slider",
    icon: "SliderIcon",
    type: wn
  },
  {
    name: "Code",
    icon: "EmbedIcon",
    type: ao
  },
  {
    name: "Video",
    icon: "VideoIcon",
    type: so
  },
  {
    name: "Accordion",
    icon: "AccordionIcon",
    type: Ye
  },
  {
    name: "Spacer",
    icon: "SpacerIcon",
    type: io
  },
  {
    name: "Separator",
    icon: "SeparatorIcon",
    type: lo
  },
  {
    name: "Card",
    icon: "CardIcon",
    type: $n
  },
  {
    name: "Table",
    icon: "TableIcon",
    type: ho
  },
  {
    name: "Quote",
    icon: "QuoteIcon",
    type: po
  },
  {
    name: "Form",
    icon: "FormIcon",
    type: uo
  },
  {
    name: "Button",
    icon: "ButtonIcon",
    type: co
  },
  {
    name: "List",
    type: Sn
  },
  {
    name: "Navigation",
    icon: "NavigationIcon",
    type: Nn
  },
  {
    name: "SharedContentError",
    icon: "",
    type: tn
  }
].map((e) => ({ ...e, group: dt, component: `${e.name}Node` })), Fa = [
  {
    name: "Accordion Panel",
    component: "AccordionPanelNode",
    type: Re
  }
].map((e) => ({ ...e, group: Ro })), nl = [
  Sn
], ol = [
  tn
], Gt = {
  BLACK: "#000000",
  WHITE: "#ffffff",
  DARK: "#333333"
};
var pn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ze(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function rl() {
  this.__data__ = [], this.size = 0;
}
var al = rl;
function il(e, t) {
  return e === t || e !== e && t !== t;
}
var Pn = il, sl = Pn;
function ll(e, t) {
  for (var n = e.length; n--; )
    if (sl(e[n][0], t))
      return n;
  return -1;
}
var Ln = ll, cl = Ln, dl = Array.prototype, ul = dl.splice;
function pl(e) {
  var t = this.__data__, n = cl(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : ul.call(t, n, 1), --this.size, !0;
}
var hl = pl, fl = Ln;
function gl(e) {
  var t = this.__data__, n = fl(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var vl = gl, ml = Ln;
function bl(e) {
  return ml(this.__data__, e) > -1;
}
var _l = bl, yl = Ln;
function Cl(e, t) {
  var n = this.__data__, o = yl(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var wl = Cl, $l = al, Sl = hl, Nl = vl, Al = _l, Tl = wl;
function xt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
xt.prototype.clear = $l;
xt.prototype.delete = Sl;
xt.prototype.get = Nl;
xt.prototype.has = Al;
xt.prototype.set = Tl;
var Rn = xt, Ol = Rn;
function Il() {
  this.__data__ = new Ol(), this.size = 0;
}
var El = Il;
function xl(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var kl = xl;
function Dl(e) {
  return this.__data__.get(e);
}
var Ml = Dl;
function Pl(e) {
  return this.__data__.has(e);
}
var Ll = Pl, Rl = typeof pn == "object" && pn && pn.Object === Object && pn, za = Rl, Bl = za, jl = typeof self == "object" && self && self.Object === Object && self, Ul = Bl || jl || Function("return this")(), He = Ul, Hl = He, Vl = Hl.Symbol, Bn = Vl, mr = Bn, Wa = Object.prototype, Fl = Wa.hasOwnProperty, zl = Wa.toString, Ht = mr ? mr.toStringTag : void 0;
function Wl(e) {
  var t = Fl.call(e, Ht), n = e[Ht];
  try {
    e[Ht] = void 0;
    var o = !0;
  } catch {
  }
  var a = zl.call(e);
  return o && (t ? e[Ht] = n : delete e[Ht]), a;
}
var Gl = Wl, Yl = Object.prototype, Zl = Yl.toString;
function Xl(e) {
  return Zl.call(e);
}
var Kl = Xl, br = Bn, ql = Gl, Ql = Kl, Jl = "[object Null]", ec = "[object Undefined]", _r = br ? br.toStringTag : void 0;
function tc(e) {
  return e == null ? e === void 0 ? ec : Jl : _r && _r in Object(e) ? ql(e) : Ql(e);
}
var kt = tc;
function nc(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Xe = nc;
const jn = /* @__PURE__ */ Ze(Xe);
var oc = kt, rc = Xe, ac = "[object AsyncFunction]", ic = "[object Function]", sc = "[object GeneratorFunction]", lc = "[object Proxy]";
function cc(e) {
  if (!rc(e))
    return !1;
  var t = oc(e);
  return t == ic || t == sc || t == ac || t == lc;
}
var jo = cc, dc = He, uc = dc["__core-js_shared__"], pc = uc, qn = pc, yr = function() {
  var e = /[^.]+$/.exec(qn && qn.keys && qn.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function hc(e) {
  return !!yr && yr in e;
}
var fc = hc, gc = Function.prototype, vc = gc.toString;
function mc(e) {
  if (e != null) {
    try {
      return vc.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Ga = mc, bc = jo, _c = fc, yc = Xe, Cc = Ga, wc = /[\\^$.*+?()[\]{}|]/g, $c = /^\[object .+?Constructor\]$/, Sc = Function.prototype, Nc = Object.prototype, Ac = Sc.toString, Tc = Nc.hasOwnProperty, Oc = RegExp(
  "^" + Ac.call(Tc).replace(wc, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ic(e) {
  if (!yc(e) || _c(e))
    return !1;
  var t = bc(e) ? Oc : $c;
  return t.test(Cc(e));
}
var Ec = Ic;
function xc(e, t) {
  return e == null ? void 0 : e[t];
}
var kc = xc, Dc = Ec, Mc = kc;
function Pc(e, t) {
  var n = Mc(e, t);
  return Dc(n) ? n : void 0;
}
var vt = Pc, Lc = vt, Rc = He, Bc = Lc(Rc, "Map"), Uo = Bc, jc = vt, Uc = jc(Object, "create"), Un = Uc, Cr = Un;
function Hc() {
  this.__data__ = Cr ? Cr(null) : {}, this.size = 0;
}
var Vc = Hc;
function Fc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var zc = Fc, Wc = Un, Gc = "__lodash_hash_undefined__", Yc = Object.prototype, Zc = Yc.hasOwnProperty;
function Xc(e) {
  var t = this.__data__;
  if (Wc) {
    var n = t[e];
    return n === Gc ? void 0 : n;
  }
  return Zc.call(t, e) ? t[e] : void 0;
}
var Kc = Xc, qc = Un, Qc = Object.prototype, Jc = Qc.hasOwnProperty;
function ed(e) {
  var t = this.__data__;
  return qc ? t[e] !== void 0 : Jc.call(t, e);
}
var td = ed, nd = Un, od = "__lodash_hash_undefined__";
function rd(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = nd && t === void 0 ? od : t, this;
}
var ad = rd, id = Vc, sd = zc, ld = Kc, cd = td, dd = ad;
function Dt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Dt.prototype.clear = id;
Dt.prototype.delete = sd;
Dt.prototype.get = ld;
Dt.prototype.has = cd;
Dt.prototype.set = dd;
var ud = Dt, wr = ud, pd = Rn, hd = Uo;
function fd() {
  this.size = 0, this.__data__ = {
    hash: new wr(),
    map: new (hd || pd)(),
    string: new wr()
  };
}
var gd = fd;
function vd(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var md = vd, bd = md;
function _d(e, t) {
  var n = e.__data__;
  return bd(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Hn = _d, yd = Hn;
function Cd(e) {
  var t = yd(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var wd = Cd, $d = Hn;
function Sd(e) {
  return $d(this, e).get(e);
}
var Nd = Sd, Ad = Hn;
function Td(e) {
  return Ad(this, e).has(e);
}
var Od = Td, Id = Hn;
function Ed(e, t) {
  var n = Id(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var xd = Ed, kd = gd, Dd = wd, Md = Nd, Pd = Od, Ld = xd;
function Mt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Mt.prototype.clear = kd;
Mt.prototype.delete = Dd;
Mt.prototype.get = Md;
Mt.prototype.has = Pd;
Mt.prototype.set = Ld;
var Ho = Mt, Rd = Rn, Bd = Uo, jd = Ho, Ud = 200;
function Hd(e, t) {
  var n = this.__data__;
  if (n instanceof Rd) {
    var o = n.__data__;
    if (!Bd || o.length < Ud - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new jd(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Vd = Hd, Fd = Rn, zd = El, Wd = kl, Gd = Ml, Yd = Ll, Zd = Vd;
function Pt(e) {
  var t = this.__data__ = new Fd(e);
  this.size = t.size;
}
Pt.prototype.clear = zd;
Pt.prototype.delete = Wd;
Pt.prototype.get = Gd;
Pt.prototype.has = Yd;
Pt.prototype.set = Zd;
var Ya = Pt, Xd = vt, Kd = function() {
  try {
    var e = Xd(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Za = Kd, $r = Za;
function qd(e, t, n) {
  t == "__proto__" && $r ? $r(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Vo = qd, Qd = Vo, Jd = Pn;
function eu(e, t, n) {
  (n !== void 0 && !Jd(e[t], n) || n === void 0 && !(t in e)) && Qd(e, t, n);
}
var Xa = eu;
function tu(e) {
  return function(t, n, o) {
    for (var a = -1, r = Object(t), i = o(t), s = i.length; s--; ) {
      var l = i[e ? s : ++a];
      if (n(r[l], l, r) === !1)
        break;
    }
    return t;
  };
}
var nu = tu, ou = nu, ru = ou(), Ka = ru, An = { exports: {} };
An.exports;
(function(e, t) {
  var n = He, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, r = a && a.exports === o, i = r ? n.Buffer : void 0, s = i ? i.allocUnsafe : void 0;
  function l(c, u) {
    if (u)
      return c.slice();
    var d = c.length, p = s ? s(d) : new c.constructor(d);
    return c.copy(p), p;
  }
  e.exports = l;
})(An, An.exports);
var qa = An.exports, au = He, iu = au.Uint8Array, su = iu, Sr = su;
function lu(e) {
  var t = new e.constructor(e.byteLength);
  return new Sr(t).set(new Sr(e)), t;
}
var Fo = lu, cu = Fo;
function du(e, t) {
  var n = t ? cu(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Qa = du;
function uu(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var Ja = uu, pu = Xe, Nr = Object.create, hu = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!pu(t))
      return {};
    if (Nr)
      return Nr(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), fu = hu;
function gu(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var ei = gu, vu = ei, mu = vu(Object.getPrototypeOf, Object), zo = mu, bu = Object.prototype;
function _u(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || bu;
  return e === n;
}
var Vn = _u, yu = fu, Cu = zo, wu = Vn;
function $u(e) {
  return typeof e.constructor == "function" && !wu(e) ? yu(Cu(e)) : {};
}
var ti = $u;
function Su(e) {
  return e != null && typeof e == "object";
}
var rt = Su, Nu = kt, Au = rt, Tu = "[object Arguments]";
function Ou(e) {
  return Au(e) && Nu(e) == Tu;
}
var Iu = Ou, Ar = Iu, Eu = rt, ni = Object.prototype, xu = ni.hasOwnProperty, ku = ni.propertyIsEnumerable, Du = Ar(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ar : function(e) {
  return Eu(e) && xu.call(e, "callee") && !ku.call(e, "callee");
}, Wo = Du, Mu = Array.isArray, at = Mu, Pu = 9007199254740991;
function Lu(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Pu;
}
var oi = Lu, Ru = jo, Bu = oi;
function ju(e) {
  return e != null && Bu(e.length) && !Ru(e);
}
var an = ju, Uu = an, Hu = rt;
function Vu(e) {
  return Hu(e) && Uu(e);
}
var Fu = Vu, Tn = { exports: {} };
function zu() {
  return !1;
}
var Wu = zu;
Tn.exports;
(function(e, t) {
  var n = He, o = Wu, a = t && !t.nodeType && t, r = a && !0 && e && !e.nodeType && e, i = r && r.exports === a, s = i ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || o;
  e.exports = c;
})(Tn, Tn.exports);
var Fn = Tn.exports, Gu = kt, Yu = zo, Zu = rt, Xu = "[object Object]", Ku = Function.prototype, qu = Object.prototype, ri = Ku.toString, Qu = qu.hasOwnProperty, Ju = ri.call(Object);
function ep(e) {
  if (!Zu(e) || Gu(e) != Xu)
    return !1;
  var t = Yu(e);
  if (t === null)
    return !0;
  var n = Qu.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && ri.call(n) == Ju;
}
var tp = ep, np = kt, op = oi, rp = rt, ap = "[object Arguments]", ip = "[object Array]", sp = "[object Boolean]", lp = "[object Date]", cp = "[object Error]", dp = "[object Function]", up = "[object Map]", pp = "[object Number]", hp = "[object Object]", fp = "[object RegExp]", gp = "[object Set]", vp = "[object String]", mp = "[object WeakMap]", bp = "[object ArrayBuffer]", _p = "[object DataView]", yp = "[object Float32Array]", Cp = "[object Float64Array]", wp = "[object Int8Array]", $p = "[object Int16Array]", Sp = "[object Int32Array]", Np = "[object Uint8Array]", Ap = "[object Uint8ClampedArray]", Tp = "[object Uint16Array]", Op = "[object Uint32Array]", re = {};
re[yp] = re[Cp] = re[wp] = re[$p] = re[Sp] = re[Np] = re[Ap] = re[Tp] = re[Op] = !0;
re[ap] = re[ip] = re[bp] = re[sp] = re[_p] = re[lp] = re[cp] = re[dp] = re[up] = re[pp] = re[hp] = re[fp] = re[gp] = re[vp] = re[mp] = !1;
function Ip(e) {
  return rp(e) && op(e.length) && !!re[np(e)];
}
var Ep = Ip;
function xp(e) {
  return function(t) {
    return e(t);
  };
}
var Go = xp, On = { exports: {} };
On.exports;
(function(e, t) {
  var n = za, o = t && !t.nodeType && t, a = o && !0 && e && !e.nodeType && e, r = a && a.exports === o, i = r && n.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(On, On.exports);
var Yo = On.exports, kp = Ep, Dp = Go, Tr = Yo, Or = Tr && Tr.isTypedArray, Mp = Or ? Dp(Or) : kp, Zo = Mp;
function Pp(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var ai = Pp, Lp = Vo, Rp = Pn, Bp = Object.prototype, jp = Bp.hasOwnProperty;
function Up(e, t, n) {
  var o = e[t];
  (!(jp.call(e, t) && Rp(o, n)) || n === void 0 && !(t in e)) && Lp(e, t, n);
}
var ii = Up, Hp = ii, Vp = Vo;
function Fp(e, t, n, o) {
  var a = !n;
  n || (n = {});
  for (var r = -1, i = t.length; ++r < i; ) {
    var s = t[r], l = o ? o(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), a ? Vp(n, s, l) : Hp(n, s, l);
  }
  return n;
}
var sn = Fp;
function zp(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var Wp = zp, Gp = 9007199254740991, Yp = /^(?:0|[1-9]\d*)$/;
function Zp(e, t) {
  var n = typeof e;
  return t = t ?? Gp, !!t && (n == "number" || n != "symbol" && Yp.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var si = Zp, Xp = Wp, Kp = Wo, qp = at, Qp = Fn, Jp = si, eh = Zo, th = Object.prototype, nh = th.hasOwnProperty;
function oh(e, t) {
  var n = qp(e), o = !n && Kp(e), a = !n && !o && Qp(e), r = !n && !o && !a && eh(e), i = n || o || a || r, s = i ? Xp(e.length, String) : [], l = s.length;
  for (var c in e)
    (t || nh.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Jp(c, l))) && s.push(c);
  return s;
}
var li = oh;
function rh(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var ah = rh, ih = Xe, sh = Vn, lh = ah, ch = Object.prototype, dh = ch.hasOwnProperty;
function uh(e) {
  if (!ih(e))
    return lh(e);
  var t = sh(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !dh.call(e, o)) || n.push(o);
  return n;
}
var ph = uh, hh = li, fh = ph, gh = an;
function vh(e) {
  return gh(e) ? hh(e, !0) : fh(e);
}
var ln = vh, mh = sn, bh = ln;
function _h(e) {
  return mh(e, bh(e));
}
var yh = _h, Ir = Xa, Ch = qa, wh = Qa, $h = Ja, Sh = ti, Er = Wo, xr = at, Nh = Fu, Ah = Fn, Th = jo, Oh = Xe, Ih = tp, Eh = Zo, kr = ai, xh = yh;
function kh(e, t, n, o, a, r, i) {
  var s = kr(e, n), l = kr(t, n), c = i.get(l);
  if (c) {
    Ir(e, n, c);
    return;
  }
  var u = r ? r(s, l, n + "", e, t, i) : void 0, d = u === void 0;
  if (d) {
    var p = xr(l), h = !p && Ah(l), C = !p && !h && Eh(l);
    u = l, p || h || C ? xr(s) ? u = s : Nh(s) ? u = $h(s) : h ? (d = !1, u = Ch(l, !0)) : C ? (d = !1, u = wh(l, !0)) : u = [] : Ih(l) || Er(l) ? (u = s, Er(s) ? u = xh(s) : (!Oh(s) || Th(s)) && (u = Sh(l))) : d = !1;
  }
  d && (i.set(l, u), a(u, l, o, r, i), i.delete(l)), Ir(e, n, u);
}
var Dh = kh, Mh = Ya, Ph = Xa, Lh = Ka, Rh = Dh, Bh = Xe, jh = ln, Uh = ai;
function ci(e, t, n, o, a) {
  e !== t && Lh(t, function(r, i) {
    if (a || (a = new Mh()), Bh(r))
      Rh(e, t, i, n, ci, o, a);
    else {
      var s = o ? o(Uh(e, i), r, i + "", e, t, a) : void 0;
      s === void 0 && (s = r), Ph(e, i, s);
    }
  }, jh);
}
var Hh = ci;
function Vh(e) {
  return e;
}
var Xo = Vh;
function Fh(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var zh = Fh, Wh = zh, Dr = Math.max;
function Gh(e, t, n) {
  return t = Dr(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, a = -1, r = Dr(o.length - t, 0), i = Array(r); ++a < r; )
      i[a] = o[t + a];
    a = -1;
    for (var s = Array(t + 1); ++a < t; )
      s[a] = o[a];
    return s[t] = n(i), Wh(e, this, s);
  };
}
var Yh = Gh;
function Zh(e) {
  return function() {
    return e;
  };
}
var Xh = Zh, Kh = Xh, Mr = Za, qh = Xo, Qh = Mr ? function(e, t) {
  return Mr(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Kh(t),
    writable: !0
  });
} : qh, Jh = Qh, ef = 800, tf = 16, nf = Date.now;
function of(e) {
  var t = 0, n = 0;
  return function() {
    var o = nf(), a = tf - (o - n);
    if (n = o, a > 0) {
      if (++t >= ef)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var rf = of, af = Jh, sf = rf, lf = sf(af), cf = lf, df = Xo, uf = Yh, pf = cf;
function hf(e, t) {
  return pf(uf(e, t, df), e + "");
}
var ff = hf, gf = Pn, vf = an, mf = si, bf = Xe;
function _f(e, t, n) {
  if (!bf(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? vf(n) && mf(t, n.length) : o == "string" && t in n) ? gf(n[t], e) : !1;
}
var yf = _f, Cf = ff, wf = yf;
function $f(e) {
  return Cf(function(t, n) {
    var o = -1, a = n.length, r = a > 1 ? n[a - 1] : void 0, i = a > 2 ? n[2] : void 0;
    for (r = e.length > 3 && typeof r == "function" ? (a--, r) : void 0, i && wf(n[0], n[1], i) && (r = a < 3 ? void 0 : r, a = 1), t = Object(t); ++o < a; ) {
      var s = n[o];
      s && e(t, s, o, r);
    }
    return t;
  });
}
var Sf = $f, Nf = Hh, Af = Sf, Tf = Af(function(e, t, n) {
  Nf(e, t, n);
}), Of = Tf;
const di = /* @__PURE__ */ Ze(Of), If = (e) => Bo.reduce((t, n) => (t[n.type] = {
  marginAllowed: !!(e != null && e.marginAllowed),
  paddingAllowed: !!(e != null && e.paddingAllowed),
  backgroundColorAllowed: !!(e != null && e.backgroundColorAllowed),
  backgroundImageAllowed: !!(e != null && e.backgroundImageAllowed)
}, t), {}), bt = () => ({
  editor: void 0,
  colorPalette: void 0,
  enabledOptions: void 0,
  extensions: void 0,
  removeExtensions: void 0,
  addExtensions: void 0,
  allowLinks: !0,
  disableFontSizeEditing: !1
});
class Pr {
  constructor(t = {}) {
    var a, r, i, s, l, c, u;
    const n = {
      locale: "en",
      id: null,
      api: {
        localUploader: !0,
        images: "/v1/assets",
        forms: "",
        secondaryOrgId: null,
        // This is a hack to get around different API responses while FAAS is implemented
        projectParent: "cms"
      },
      customProperties: {
        nodesIncluded: [],
        nodesExcluded: [],
        experimentalFeatures: {
          roundedLayouts: !0
        },
        global: {
          customAttributesAllowed: !0,
          backgroundColorAllowed: !0,
          backgroundImageAllowed: !0,
          marginAllowed: !0,
          paddingAllowed: !0,
          confirmOnDeleteDialogAllowed: !0,
          focusNewNodeOnCreate: !0,
          maxNestingLevelsAllowed: 4,
          rootElementsWidth: "85%",
          rootElementsMaxWidth: "1920px",
          sharedContentAllowed: !1,
          showConfirmOnDeleteDialog: !1,
          headerSlotOptional: !1,
          footerSlotOptional: !1,
          showHeaderSlot: !1,
          showFooterSlot: !1,
          undoLimit: 100
        },
        RTEBar: {
          disabled: !1,
          fontSizes: void 0,
          removeDefaultActions: void 0,
          removeOptions: void 0,
          linkModalOptions: { allowRelative: !0 }
        },
        ...If((a = t == null ? void 0 : t.customProperties) == null ? void 0 : a.global),
        CONTENT_NODE_HEADING: bt(),
        CONTENT_NODE_TEXT: bt(),
        CONTENT_NODE_TABLE: bt(),
        CONTENT_NODE_CARD: {
          decorativeImageAllowed: !0,
          heading: bt(),
          text: bt(),
          uploadLimitMb: 10
        },
        CONTENT_NODE_IMAGE: {
          acceptedFileTypes: [
            "image/png",
            "image/jpeg"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          lightboxAllowed: !0,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_CODE: {
          allowScripts: !0
        },
        CONTENT_NODE_SPACER: {
          minHeight: 20,
          maxHeight: 1e3
        },
        CONTENT_NODE_GALLERY: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          captionsAllowed: !0,
          decorativeImageAllowed: !0,
          focalPointAllowed: !0,
          lightboxAllowed: !0,
          minColumnsAllowed: 1,
          maxColumnsAllowed: 10,
          maxImagesAllowed: 20,
          resizableImageAllowed: !0,
          uploadLimitMb: 10
        },
        CONTENT_NODE_VIDEO: {},
        CONTENT_NODE_SEPARATOR: {
          maxThickness: 10
        },
        CONTENT_NODE_BUTTON: {
          icons: {
            global_icons: [],
            custom_icons: []
          },
          textareaMaxLength: 40
        },
        CONTENT_NODE_FORM: {},
        CONTENT_NODE_QUOTE: {},
        CONTENT_NODE_SLIDER: {
          acceptedFileTypes: [
            "image/png",
            "image/jpg",
            "image/jpeg",
            "image/gif"
          ],
          decorativeImageAllowed: !0,
          maxImagesAllowed: 30,
          transitionSpeedMin: 3,
          transitionSpeedMax: 6,
          uploadLimitMb: 10
        },
        CONTENT_NODE_ACCORDION: {},
        CONTENT_NODE_PANEL: {},
        CONTENT_NODE_LIST: {
          legacyListOptions: {
            ...bt(),
            enabledOptions: ["bold", "italic", "strike", "color", "add-link"]
          }
        },
        CONTENT_NODE_NAVIGATION: {
          siteMenu: []
        }
      },
      sharedContent: {
        content: {},
        createSharedContentAllowed: !0,
        editSharedContentAllowed: !0,
        detachSharedContentAllowed: !0,
        onContentCreated: ((r = t.sharedContent) == null ? void 0 : r.onContentCreated) || null,
        onSaveContentEdited: ((i = t.sharedContent) == null ? void 0 : i.onSaveContentEdited) || null,
        onCancelContentEdited: ((s = t.sharedContent) == null ? void 0 : s.onCancelContentEdited) || null,
        onContentDetached: ((l = t.sharedContent) == null ? void 0 : l.onContentDetached) || null,
        onOpenSettings: ((c = t.sharedContent) == null ? void 0 : c.onOpenSettings) || null,
        onSharedContentDeleted: ((u = t.sharedContent) == null ? void 0 : u.onSharedContentDeleted) || null
      },
      legacyAdapters: {
        pageToBuilder: null
      },
      assets: {},
      theme: {
        headingColor: null,
        linkColor: null,
        mainColor: null,
        primaryColor: null,
        secondaryColor: null
      },
      structure: {
        id: "root",
        name: "Root",
        type: ve,
        properties: {
          backgroundColor: {
            toggle: !1,
            value: ""
          },
          backgroundImage: {
            toggle: !1,
            image: null
          },
          margin: {
            value: 0
          },
          padding: {
            value: 0
          },
          borderRadius: {
            value: 0
          }
        },
        nodes: []
      }
    }, o = di({}, n, t);
    Object.keys(o).forEach((d) => {
      this[`_${d}`] = o[d];
    });
  }
  get assets() {
    return this._assets;
  }
  set assets(t) {
    this._assets = t;
  }
  get id() {
    return this._id;
  }
  get structure() {
    return this._structure;
  }
  get api() {
    return this._api;
  }
  get sharedContent() {
    return this._sharedContent;
  }
  set sharedContent(t) {
    this._sharedContent = t;
  }
  get theme() {
    return this._theme;
  }
  set theme(t) {
    this._theme = t;
  }
  get icons() {
    return this._assets.icons;
  }
  get customProperties() {
    return this._customProperties;
  }
  get legacyAdapters() {
    return this._legacyAdapters;
  }
  get locale() {
    return this._locale;
  }
}
const Ef = (e) => ({
  activeNode: null,
  editingSharedContent: {
    node: null,
    boundingRect: null,
    originalContent: null
  },
  builder: null,
  editor: null,
  isLinkModalOpen: !1,
  isCodeModalOpen: !1,
  nodeDragging: null,
  showCustomAttributesSidebar: !1,
  userAgent: "windows",
  addAsset(t) {
    this.builder.assets = {
      ...this.builder.assets,
      ...t
    };
  },
  setActiveNode(t) {
    this.showCustomAttributesSidebar = !1, this.activeNode = t;
  },
  clearActiveNode() {
    this.showCustomAttributesSidebar = !1, this.activeNode = null;
  },
  clearEditor() {
    this.editor = {
      editor: {},
      editorKey: "",
      enabledOptions: [],
      removeOptions: [],
      colorPalette: {}
    };
  },
  removeFavorite({ id: t }) {
    this.builder.favorites = this.builder.favorites.filter((n) => n.id !== t);
  },
  emitToConsumingApp(t, n) {
    e(t, n);
  }
}), xf = ({ customProperties: e, structure: t, theme: n }) => {
  const o = "#004b8d", a = "#8369cb", r = "#ad98e6", i = "#B1CB69", s = "#0000ee", l = "#2a5a5a", { properties: c } = t, { backgroundColorAllowed: u } = e.global, d = n.mainColor || Gt.DARK, p = n.headingColor || Gt.DARK, h = n.linkColor || s;
  return {
    // THEME VARIABLES
    "--color-favorite": i,
    "--color-heading": p,
    "--color-link": h,
    "--color-main": d,
    "--color-main-10": `${d}10`,
    "--color-main-20": `${d}20`,
    "--color-main-30": `${d}30`,
    "--font-family": "'Neue Haas Grotesk Disp', 'Inter', 'Helvetica Neue', Arial, sans-serif",
    // BUILDER VARIABLES
    "--builder-background-color": u && c.backgroundColor.toggle && c.backgroundColor.value,
    "--color-layout": o,
    "--color-content": a,
    "--color-sub-content": r,
    "--color-shared-content": l,
    // PB CUSTOM COLOR VARIABLES
    "--pb-black": "#000000",
    "--pb-black-10": "#0000001a",
    "--pb-black-20": "#00000033",
    "--pb-grey-35": "#cccccc",
    "--pb-purple-45": "#ab91dd",
    "--pb-transparent": "#ffffff00",
    "--pb-white-10": "#ffffff1a",
    "--pb-white-90": "#ffffffe6",
    "--pb-code-background-color": "#091E4214",
    // LAYOUT VARIABLES
    "--layout-outline": "1px dashed hsla(0, 0%, 49%, 0.5)",
    "--lightbox-background": "rgba(0, 0, 0, .85)",
    // SIDEBAR VARIABLES
    "--sidebar-width": "240px",
    "--block-container-max-height": "800px"
  };
}, X = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, a] of t)
    n[o] = a;
  return n;
}, kf = {
  name: "ColorPicker",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showContrastChecker: {
      type: Boolean,
      default: !1
    }
  },
  inject: ["state"],
  computed: {
    colorValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    themePalette() {
      var t, n, o, a, r, i;
      return [
        void 0,
        (n = (t = this.state) == null ? void 0 : t.builder.theme) == null ? void 0 : n.primaryColor,
        (a = (o = this.state) == null ? void 0 : o.builder.theme) == null ? void 0 : a.secondaryColor,
        (i = (r = this.state) == null ? void 0 : r.builder.theme) == null ? void 0 : i.mainColor
      ].filter(Boolean);
    }
  }
}, Df = { class: "inline-control space-between gap-10" };
function Mf(e, t, n, o, a, r) {
  const i = L("a-form-color-input"), s = L("a-button");
  return y(), M("div", Df, [
    E(i, {
      class: "background-color-input",
      "model-value": r.colorValue,
      palette: r.themePalette,
      "no-contrast-checker": !n.showContrastChecker,
      onChange: t[0] || (t[0] = (l) => r.colorValue = l),
      width: "160px"
    }, null, 8, ["model-value", "palette", "no-contrast-checker"]),
    E(s, {
      class: "clear-button",
      variant: "link",
      onClick: t[1] || (t[1] = (l) => e.$emit("clear"))
    }, {
      default: P(() => [
        fe(K(e.$t("builder.clear")), 1)
      ]),
      _: 1
    })
  ]);
}
const Pf = /* @__PURE__ */ X(kf, [["render", Mf], ["__scopeId", "data-v-c66c94e6"]]), Lf = {
  name: "NodeControl",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Rf = { class: "control-header" }, Bf = { class: "control-title" }, jf = { class: "control-content" };
function Uf(e, t, n, o, a, r) {
  return y(), M("div", {
    class: me(["node-control", { disabled: n.disabled }])
  }, [
    w("div", Rf, [
      w("div", Bf, [
        Ne(e.$slots, "title", {}, void 0, !0)
      ]),
      Ne(e.$slots, "control", {}, void 0, !0)
    ]),
    w("div", jf, [
      Ne(e.$slots, "content", {}, void 0, !0)
    ])
  ], 2);
}
const ht = /* @__PURE__ */ X(Lf, [["render", Uf], ["__scopeId", "data-v-256bf46a"]]), Hf = {
  name: "BackgroundColorControl",
  components: {
    ColorPicker: Pf,
    NodeControl: ht
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    backgroundColor: {
      get() {
        var e, t, n;
        return ((n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.value) || null;
      },
      set(e) {
        this.$emit("update", "value", e);
      }
    },
    toggle: {
      get() {
        var e, t, n;
        return ((n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) == null ? void 0 : n.toggle) || !1;
      },
      set(e) {
        this.$emit("update", "toggle", e);
      }
    }
  }
};
function Vf(e, t, n, o, a, r) {
  const i = L("a-toggle"), s = L("ColorPicker"), l = L("NodeControl");
  return y(), W(l, null, Mo({
    title: P(() => [
      w("h4", null, K(e.$t("builder.backgroundColor.title")), 1)
    ]),
    control: P(() => [
      E(i, {
        id: "background-color-toggle",
        modelValue: r.toggle,
        "onUpdate:modelValue": t[0] || (t[0] = (c) => r.toggle = c)
      }, null, 8, ["modelValue"])
    ]),
    _: 2
  }, [
    r.toggle ? {
      name: "content",
      fn: P(() => [
        E(s, {
          modelValue: r.backgroundColor,
          "onUpdate:modelValue": t[1] || (t[1] = (c) => r.backgroundColor = c),
          "show-contrast-checker": !1,
          onClear: t[2] || (t[2] = (c) => r.backgroundColor = null)
        }, null, 8, ["modelValue"])
      ]),
      key: "0"
    } : void 0
  ]), 1024);
}
const ui = /* @__PURE__ */ X(Hf, [["render", Vf]]), Lr = (e) => /* eslint-disable-next-line no-useless-escape */ /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(e), Ff = (e) => {
  if (e !== "" && e !== void 0 && !Lr(e))
    return new Promise((t, n) => {
      const o = new FileReader();
      o.readAsDataURL(e), o.onloadend = (a) => {
        t(o.result);
      }, o.onerror = (a) => {
        n(a);
      };
    });
  if (Lr(e))
    return Promise.resolve(e);
}, pi = (e, t, n = 10) => {
  var a;
  if (!e.size || !e.type)
    return !1;
  const o = !((a = e.name) != null && a.includes(".")) || !t.includes(e.type);
  return Ko(e, n) || o || e.type === "";
}, Ko = (e, t = 10) => e.size / 1e6 > t, zf = (e) => ({
  [e.content.assetId]: {
    url: e.assetUrl,
    file: e.content.imageFile
  }
}), BS = (e, t) => {
  const n = Object.keys(t)[0];
  return !e.hasOwnProperty(n);
};
function Wf(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Gf = Wf, Yf = ei, Zf = Yf(Object.keys, Object), Xf = Zf, Kf = Vn, qf = Xf, Qf = Object.prototype, Jf = Qf.hasOwnProperty;
function eg(e) {
  if (!Kf(e))
    return qf(e);
  var t = [];
  for (var n in Object(e))
    Jf.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var hi = eg, tg = li, ng = hi, og = an;
function rg(e) {
  return og(e) ? tg(e) : ng(e);
}
var zn = rg, ag = sn, ig = zn;
function sg(e, t) {
  return e && ag(t, ig(t), e);
}
var lg = sg, cg = sn, dg = ln;
function ug(e, t) {
  return e && cg(t, dg(t), e);
}
var pg = ug;
function hg(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, a = 0, r = []; ++n < o; ) {
    var i = e[n];
    t(i, n, e) && (r[a++] = i);
  }
  return r;
}
var fg = hg;
function gg() {
  return [];
}
var fi = gg, vg = fg, mg = fi, bg = Object.prototype, _g = bg.propertyIsEnumerable, Rr = Object.getOwnPropertySymbols, yg = Rr ? function(e) {
  return e == null ? [] : (e = Object(e), vg(Rr(e), function(t) {
    return _g.call(e, t);
  }));
} : mg, qo = yg, Cg = sn, wg = qo;
function $g(e, t) {
  return Cg(e, wg(e), t);
}
var Sg = $g;
function Ng(e, t) {
  for (var n = -1, o = t.length, a = e.length; ++n < o; )
    e[a + n] = t[n];
  return e;
}
var gi = Ng, Ag = gi, Tg = zo, Og = qo, Ig = fi, Eg = Object.getOwnPropertySymbols, xg = Eg ? function(e) {
  for (var t = []; e; )
    Ag(t, Og(e)), e = Tg(e);
  return t;
} : Ig, vi = xg, kg = sn, Dg = vi;
function Mg(e, t) {
  return kg(e, Dg(e), t);
}
var Pg = Mg, Lg = gi, Rg = at;
function Bg(e, t, n) {
  var o = t(e);
  return Rg(e) ? o : Lg(o, n(e));
}
var mi = Bg, jg = mi, Ug = qo, Hg = zn;
function Vg(e) {
  return jg(e, Hg, Ug);
}
var Fg = Vg, zg = mi, Wg = vi, Gg = ln;
function Yg(e) {
  return zg(e, Gg, Wg);
}
var Zg = Yg, Xg = vt, Kg = He, qg = Xg(Kg, "DataView"), Qg = qg, Jg = vt, ev = He, tv = Jg(ev, "Promise"), nv = tv, ov = vt, rv = He, av = ov(rv, "Set"), bi = av, iv = vt, sv = He, lv = iv(sv, "WeakMap"), cv = lv, fo = Qg, go = Uo, vo = nv, mo = bi, bo = cv, _i = kt, Lt = Ga, Br = "[object Map]", dv = "[object Object]", jr = "[object Promise]", Ur = "[object Set]", Hr = "[object WeakMap]", Vr = "[object DataView]", uv = Lt(fo), pv = Lt(go), hv = Lt(vo), fv = Lt(mo), gv = Lt(bo), lt = _i;
(fo && lt(new fo(new ArrayBuffer(1))) != Vr || go && lt(new go()) != Br || vo && lt(vo.resolve()) != jr || mo && lt(new mo()) != Ur || bo && lt(new bo()) != Hr) && (lt = function(e) {
  var t = _i(e), n = t == dv ? e.constructor : void 0, o = n ? Lt(n) : "";
  if (o)
    switch (o) {
      case uv:
        return Vr;
      case pv:
        return Br;
      case hv:
        return jr;
      case fv:
        return Ur;
      case gv:
        return Hr;
    }
  return t;
});
var Wn = lt, vv = Object.prototype, mv = vv.hasOwnProperty;
function bv(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && mv.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var _v = bv, yv = Fo;
function Cv(e, t) {
  var n = t ? yv(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var wv = Cv, $v = /\w*$/;
function Sv(e) {
  var t = new e.constructor(e.source, $v.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Nv = Sv, Fr = Bn, zr = Fr ? Fr.prototype : void 0, Wr = zr ? zr.valueOf : void 0;
function Av(e) {
  return Wr ? Object(Wr.call(e)) : {};
}
var Tv = Av, Ov = Fo, Iv = wv, Ev = Nv, xv = Tv, kv = Qa, Dv = "[object Boolean]", Mv = "[object Date]", Pv = "[object Map]", Lv = "[object Number]", Rv = "[object RegExp]", Bv = "[object Set]", jv = "[object String]", Uv = "[object Symbol]", Hv = "[object ArrayBuffer]", Vv = "[object DataView]", Fv = "[object Float32Array]", zv = "[object Float64Array]", Wv = "[object Int8Array]", Gv = "[object Int16Array]", Yv = "[object Int32Array]", Zv = "[object Uint8Array]", Xv = "[object Uint8ClampedArray]", Kv = "[object Uint16Array]", qv = "[object Uint32Array]";
function Qv(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case Hv:
      return Ov(e);
    case Dv:
    case Mv:
      return new o(+e);
    case Vv:
      return Iv(e, n);
    case Fv:
    case zv:
    case Wv:
    case Gv:
    case Yv:
    case Zv:
    case Xv:
    case Kv:
    case qv:
      return kv(e, n);
    case Pv:
      return new o();
    case Lv:
    case jv:
      return new o(e);
    case Rv:
      return Ev(e);
    case Bv:
      return new o();
    case Uv:
      return xv(e);
  }
}
var Jv = Qv, em = Wn, tm = rt, nm = "[object Map]";
function om(e) {
  return tm(e) && em(e) == nm;
}
var rm = om, am = rm, im = Go, Gr = Yo, Yr = Gr && Gr.isMap, sm = Yr ? im(Yr) : am, lm = sm, cm = Wn, dm = rt, um = "[object Set]";
function pm(e) {
  return dm(e) && cm(e) == um;
}
var hm = pm, fm = hm, gm = Go, Zr = Yo, Xr = Zr && Zr.isSet, vm = Xr ? gm(Xr) : fm, mm = vm, bm = Ya, _m = Gf, ym = ii, Cm = lg, wm = pg, $m = qa, Sm = Ja, Nm = Sg, Am = Pg, Tm = Fg, Om = Zg, Im = Wn, Em = _v, xm = Jv, km = ti, Dm = at, Mm = Fn, Pm = lm, Lm = Xe, Rm = mm, Bm = zn, jm = ln, Um = 1, Hm = 2, Vm = 4, yi = "[object Arguments]", Fm = "[object Array]", zm = "[object Boolean]", Wm = "[object Date]", Gm = "[object Error]", Ci = "[object Function]", Ym = "[object GeneratorFunction]", Zm = "[object Map]", Xm = "[object Number]", wi = "[object Object]", Km = "[object RegExp]", qm = "[object Set]", Qm = "[object String]", Jm = "[object Symbol]", e0 = "[object WeakMap]", t0 = "[object ArrayBuffer]", n0 = "[object DataView]", o0 = "[object Float32Array]", r0 = "[object Float64Array]", a0 = "[object Int8Array]", i0 = "[object Int16Array]", s0 = "[object Int32Array]", l0 = "[object Uint8Array]", c0 = "[object Uint8ClampedArray]", d0 = "[object Uint16Array]", u0 = "[object Uint32Array]", oe = {};
oe[yi] = oe[Fm] = oe[t0] = oe[n0] = oe[zm] = oe[Wm] = oe[o0] = oe[r0] = oe[a0] = oe[i0] = oe[s0] = oe[Zm] = oe[Xm] = oe[wi] = oe[Km] = oe[qm] = oe[Qm] = oe[Jm] = oe[l0] = oe[c0] = oe[d0] = oe[u0] = !0;
oe[Gm] = oe[Ci] = oe[e0] = !1;
function bn(e, t, n, o, a, r) {
  var i, s = t & Um, l = t & Hm, c = t & Vm;
  if (n && (i = a ? n(e, o, a, r) : n(e)), i !== void 0)
    return i;
  if (!Lm(e))
    return e;
  var u = Dm(e);
  if (u) {
    if (i = Em(e), !s)
      return Sm(e, i);
  } else {
    var d = Im(e), p = d == Ci || d == Ym;
    if (Mm(e))
      return $m(e, s);
    if (d == wi || d == yi || p && !a) {
      if (i = l || p ? {} : km(e), !s)
        return l ? Am(e, wm(i, e)) : Nm(e, Cm(i, e));
    } else {
      if (!oe[d])
        return a ? e : {};
      i = xm(e, d, s);
    }
  }
  r || (r = new bm());
  var h = r.get(e);
  if (h)
    return h;
  r.set(e, i), Rm(e) ? e.forEach(function(v) {
    i.add(bn(v, t, n, v, e, r));
  }) : Pm(e) && e.forEach(function(v, S) {
    i.set(S, bn(v, t, n, S, e, r));
  });
  var C = c ? l ? Om : Tm : l ? jm : Bm, f = u ? void 0 : C(e);
  return _m(f || e, function(v, S) {
    f && (S = v, v = e[S]), ym(i, S, bn(v, t, n, S, e, r));
  }), i;
}
var p0 = bn, h0 = p0, f0 = 1, g0 = 4;
function v0(e) {
  return h0(e, f0 | g0);
}
var m0 = v0;
const ft = /* @__PURE__ */ Ze(m0);
var b0 = kt, _0 = rt, y0 = "[object Symbol]";
function C0(e) {
  return typeof e == "symbol" || _0(e) && b0(e) == y0;
}
var Qo = C0, w0 = at, $0 = Qo, S0 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, N0 = /^\w*$/;
function A0(e, t) {
  if (w0(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || $0(e) ? !0 : N0.test(e) || !S0.test(e) || t != null && e in Object(t);
}
var T0 = A0, $i = Ho, O0 = "Expected a function";
function Jo(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(O0);
  var n = function() {
    var o = arguments, a = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(a))
      return r.get(a);
    var i = e.apply(this, o);
    return n.cache = r.set(a, i) || r, i;
  };
  return n.cache = new (Jo.Cache || $i)(), n;
}
Jo.Cache = $i;
var I0 = Jo, E0 = I0, x0 = 500;
function k0(e) {
  var t = E0(e, function(o) {
    return n.size === x0 && n.clear(), o;
  }), n = t.cache;
  return t;
}
var D0 = k0, M0 = D0, P0 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, L0 = /\\(\\)?/g, R0 = M0(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(P0, function(n, o, a, r) {
    t.push(a ? r.replace(L0, "$1") : o || n);
  }), t;
}), B0 = R0;
function j0(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, a = Array(o); ++n < o; )
    a[n] = t(e[n], n, e);
  return a;
}
var U0 = j0, Kr = Bn, H0 = U0, V0 = at, F0 = Qo, z0 = 1 / 0, qr = Kr ? Kr.prototype : void 0, Qr = qr ? qr.toString : void 0;
function Si(e) {
  if (typeof e == "string")
    return e;
  if (V0(e))
    return H0(e, Si) + "";
  if (F0(e))
    return Qr ? Qr.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -z0 ? "-0" : t;
}
var W0 = Si, G0 = W0;
function Y0(e) {
  return e == null ? "" : G0(e);
}
var cn = Y0, Z0 = at, X0 = T0, K0 = B0, q0 = cn;
function Q0(e, t) {
  return Z0(e) ? e : X0(e, t) ? [e] : K0(q0(e));
}
var J0 = Q0, e1 = Qo, t1 = 1 / 0;
function n1(e) {
  if (typeof e == "string" || e1(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -t1 ? "-0" : t;
}
var o1 = n1, r1 = J0, a1 = o1;
function i1(e, t) {
  t = r1(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[a1(t[n++])];
  return n && n == o ? e : void 0;
}
var s1 = i1, l1 = s1;
function c1(e, t, n) {
  var o = e == null ? void 0 : l1(e, t);
  return o === void 0 ? n : o;
}
var d1 = c1;
const er = /* @__PURE__ */ Ze(d1);
var u1 = Ka, p1 = zn;
function h1(e, t) {
  return e && u1(e, t, p1);
}
var f1 = h1, g1 = Xo;
function v1(e) {
  return typeof e == "function" ? e : g1;
}
var m1 = v1, b1 = f1, _1 = m1;
function y1(e, t) {
  return e && b1(e, _1(t));
}
var C1 = y1;
const Gn = /* @__PURE__ */ Ze(C1), he = () => ({
  anchorTag: "",
  customClasses: []
}), qe = (e = {}) => ({
  ...e.roundedLayouts && {
    borderRadius: {
      value: 0
    }
  },
  backgroundColor: {
    toggle: !1,
    value: null
  },
  backgroundImage: {
    toggle: !1,
    image: null
  },
  margin: {
    linked: !0,
    value: 10,
    top: 10,
    bottom: 10,
    left: 10,
    right: 10
  },
  padding: {
    linked: !0,
    value: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  ...he()
}), w1 = () => ({
  name: "Base Column",
  type: ve,
  nodes: []
}), te = () => crypto.randomUUID(), ye = (e, t = {}) => {
  if (!e)
    return null;
  switch (e.type) {
    case ve:
      return {
        ...w1()
      };
    case Xt:
      return {
        id: te(),
        name: "One Column",
        type: Xt,
        properties: { ...qe(t) },
        nodes: [ye({ type: ve })]
      };
    case Kt:
      return {
        id: te(),
        name: "Two Columns",
        type: Kt,
        properties: { ...qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case qt:
      return {
        id: te(),
        name: "Three Columns",
        type: qt,
        properties: { ...qe(t) },
        nodes: new Array(3).fill(null).map((n) => ye({ type: ve }))
      };
    case Qt:
      return {
        id: te(),
        name: "Four Columns",
        type: Qt,
        properties: { ...qe(t) },
        nodes: new Array(4).fill(null).map((n) => ye({ type: ve }))
      };
    case St:
      return {
        id: te(),
        name: "Full Width",
        type: St,
        properties: {
          ...qe(t),
          margin: {
            linked: !1,
            value: 0,
            top: 10,
            bottom: 10,
            left: 0,
            right: 0
          }
        },
        nodes: [ye({ type: ve })]
      };
    case Jt:
      return {
        id: te(),
        name: "Left Sidebar",
        type: Jt,
        properties: { ...qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case en:
      return {
        id: te(),
        name: "Right Sidebar",
        type: en,
        properties: { ...qe(t) },
        nodes: new Array(2).fill(null).map((n) => ye({ type: ve }))
      };
    case Se:
      if (!e.sharedContentId) {
        console.error("Node must have a sharedContentId UUID property");
        return;
      }
      return {
        id: te(),
        name: "Shared content",
        type: Se,
        properties: {
          ...qe(t),
          margin: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          },
          padding: {
            linked: !0,
            value: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          }
        },
        sharedContentId: e.sharedContentId,
        nodes: [ye({ type: ve })]
      };
  }
}, ut = (e, t = {}) => {
  if (!e)
    return null;
  const { id: n, type: o, content: a, parentId: r } = e;
  switch (o) {
    case mn:
      return {
        id: n || te(),
        name: "Heading",
        type: mn,
        content: {
          html: (a == null ? void 0 : a.html) || ""
        },
        properties: {
          ...he()
        }
      };
    case Nt:
      return {
        id: n || te(),
        name: "Text",
        type: Nt,
        content: {
          html: (a == null ? void 0 : a.html) || ""
        },
        properties: {
          ...he()
        }
      };
    case Dn:
      return {
        ...new Ge()
      };
    case Cn:
      return {
        id: te(),
        name: "Gallery",
        type: Cn,
        content: {
          images: []
        },
        properties: {
          columnsCount: 4,
          isLightbox: !1,
          showCaptions: !1,
          captionsAlignment: "center",
          ...he()
        }
      };
    case so:
      return {
        id: te(),
        name: "Video",
        type: so,
        content: {
          embeddableUrl: ""
        },
        properties: {
          columnPercentage: 100,
          isResized: !1,
          videoAlignment: "center",
          ...he()
        }
      };
    case ao:
      return {
        id: te(),
        name: "Code",
        type: ao,
        content: {
          html: ""
        },
        properties: {
          hasScriptTag: !1,
          ...he()
        }
      };
    case io:
      return {
        id: te(),
        name: "Spacer",
        type: io,
        properties: {
          height: 20,
          isTransparent: !1,
          backgroundColor: Gt.WHITE,
          ...he()
        }
      };
    case lo:
      return {
        id: te(),
        name: "Separator",
        type: lo,
        properties: {
          thickness: 1,
          width: 100,
          color: "",
          style: "solid",
          ...he()
        }
      };
    case po:
      return {
        id: te(),
        name: "Quote",
        type: po,
        content: {
          quote: "",
          author: "",
          source: ""
        },
        properties: {
          design: "design-1",
          color: t.mainColor || Gt.BLACK,
          ...he()
        }
      };
    case wn:
      return {
        id: te(),
        name: "Slider",
        type: wn,
        content: {
          images: []
        },
        properties: {
          showDots: !0,
          dotsPosition: "top",
          showArrows: !0,
          arrowsPosition: "top",
          isAutoplay: !0,
          transitionSpeed: 3,
          ...he()
        }
      };
    case $n:
      return {
        id: te(),
        name: "Card",
        type: $n,
        content: {
          heading: ut({ type: mn }),
          text: ut({ type: Nt }),
          image: new Ge()
        },
        properties: {
          design: "box-shadow",
          showHeadline: !0,
          showImage: !0,
          imagePosition: "left",
          wrapText: !1,
          ...he()
        }
      };
    case uo:
      return {
        id: te(),
        name: "Form",
        type: uo,
        content: {
          formId: null
        },
        properties: {
          showOneQuestionAtATime: !1,
          ...he()
        }
      };
    case co:
      return {
        id: te(),
        name: "Button",
        type: co,
        content: {
          buttons: [A1()]
        },
        properties: {
          type: "regular",
          theme: "light",
          size: "regular",
          pillShape: !1,
          alignment: "left",
          style: "1",
          hasIcons: !1,
          ...he()
        }
      };
    case ho:
      return {
        id: te(),
        name: "Table",
        type: ho,
        content: {
          html: ""
        },
        properties: {
          theme: vr,
          alternatingColors: !0,
          ...he()
        }
      };
    case Ye:
      const i = {
        id: te(),
        name: "Accordion",
        type: Ye,
        nodes: [],
        properties: {
          theme: vr,
          iconStyle: "plus",
          allowMultipleOpenPanels: !0,
          ...he()
        }
      }, s = {
        ...ye({ type: ve }),
        nodes: [
          ut({
            type: Re,
            parentId: i.id
          })
        ]
      };
      return i.nodes.push(s), i;
    case Re:
      return {
        id: te(),
        name: "Accordion Panel",
        type: Re,
        properties: {
          text: "",
          panelExpanded: !0,
          defaultToExpanded: !1,
          ...he()
        },
        parentAccordionId: r,
        nodes: [ye({ type: ve })]
      };
    case Sn:
      return {
        id: te(),
        name: "List",
        type: Sn,
        content: {
          items: [T1()]
        },
        properties: {
          design: "simple",
          format: "disc",
          ...he()
        }
      };
    case Nn:
      return {
        id: te(),
        name: "Navigation",
        type: Nn,
        content: {
          selectedPageId: null,
          selectedChildrenIds: []
        },
        properties: {
          design: "style-1",
          color: t.mainColor || Gt.BLACK
        }
      };
    case tn:
      return {
        id: n || te(),
        name: "Shared Component Error",
        type: tn
      };
  }
}, ot = (e) => !!Bo.find((t) => t.type === e.type), Ni = (e) => !!Mn.find((t) => t.type === e.type), Ai = (e) => e.type === ve, jS = (e) => {
  switch (e.type) {
    case Kt:
    case qt:
    case Jt:
    case en:
    case Qt:
      return !0;
    default:
      return !1;
  }
}, $1 = (e) => !!Fa.find((t) => t.type === e.type), S1 = (e, t) => t ? e.type === ve && e.nodes.length === 0 : !1, N1 = (e) => ot(e) ? ct : Ni(e) ? dt : $1(e) ? Ro : "", nn = (e = {}, t = 0, n = null) => {
  var i;
  if (!((i = e.nodes) != null && i.length))
    return { ...ft(e), id: te() };
  const o = te(), a = e.type === Ye ? o : n, r = (e.nodes || []).map((s) => nn(s, t + 1, a)) || [];
  return {
    ...ft(e),
    id: o,
    nodes: r,
    ...e.type === Re && { parentAccordionId: n }
  };
}, US = (e) => ut(e), HS = () => new Ge(), A1 = () => ({
  id: te(),
  title: "",
  icon: null,
  iconId: null,
  link: "",
  newTab: !1
}), T1 = () => ({
  id: te(),
  content: ut({ type: Nt }),
  details: ut({ type: Nt })
}), O1 = ({ customProperties: e = null }) => e ? Mn.some((t) => {
  var r, i, s, l, c;
  const n = (i = (r = e[t.type]) == null ? void 0 : r.colorPalette) == null ? void 0 : i.enabled, o = (c = (l = (s = e[t.type]) == null ? void 0 : s.colorPalette) == null ? void 0 : l.colors) == null ? void 0 : c.length;
  return e.hasOwnProperty(t.type) && n && !!o;
}) : !1, We = (e, t) => {
  if (er(e, "id") === t)
    return e;
  let n = null, o = (e == null ? void 0 : e.nodes) || {};
  return Gn(o, (a) => {
    if (jn(a) && (n = We(a, t), n))
      return !1;
  }), n;
}, ze = (e, t, n = null) => {
  if (e.id === t) {
    const o = n == null ? void 0 : n.nodes.indexOf(e);
    return { parent: n, index: o };
  }
  if (e.nodes && Array.isArray(e.nodes))
    for (let o = 0; o < e.nodes.length; o++) {
      const a = e.nodes[o], r = ze(a, t, e);
      if (r)
        return r;
    }
  return null;
}, Ti = (e, t, n = null, o = null, a = -1) => {
  if (e.id === t) {
    const r = (n == null ? void 0 : n.type) === "BASE_COLUMN" ? o : n, i = (n == null ? void 0 : n.type) === "BASE_COLUMN" ? a : n == null ? void 0 : n.nodes.indexOf(e);
    return { parent: r, grandparent: o, index: i };
  }
  if (e.nodes && Array.isArray(e.nodes))
    for (let r = 0; r < e.nodes.length; r++) {
      const i = e.nodes[r], s = Ti(
        i,
        t,
        e,
        n,
        r
      );
      if (s)
        return s;
    }
  return null;
}, Jr = (e) => e.type === Re, Oi = (e) => {
  if (er(e, "type") === Ye)
    return !0;
  let t = !1, n = e.nodes || {};
  return Gn(n, (o) => {
    if (jn(o) && (t = Oi(o), t))
      return !1;
  }), t;
}, Ii = (e, t) => {
  if (er(e, "type") === t)
    return !0;
  let n = !1, o = e.nodes || {};
  return Gn(o, (a) => {
    if (jn(a) && (n = Ii(a, t), n))
      return !1;
  }), n;
}, I1 = (e = {}) => Object.values(e).some((t) => !!t);
class Ge {
  constructor(t = {}) {
    const n = {
      id: te(),
      name: "Image",
      type: Dn,
      content: {
        assetId: "",
        altText: "",
        caption: "",
        imageFile: null,
        // We need to remove this at some point since its not being used outside of builder
        link: ""
      },
      properties: {
        actionOnClick: "no-action",
        captionAlignment: "center",
        columnPercentage: 100,
        focalPointPosition: {
          x: 50,
          y: 50
        },
        imageAlignment: "center",
        isDecorative: !1,
        isResized: !1,
        naturalWidth: null,
        naturalHeight: null,
        newTab: !1,
        preferredWidth: null,
        preferredHeight: null,
        resizeMode: "actual-size",
        showCaption: null,
        // Necessary to distinguish from old pages that havent been adapted
        backgroundPosition: "fill",
        tilePercentage: 100,
        rotation: 0,
        // Not used right now, just left overs from an old idea
        anchorTag: "",
        customClasses: [""]
      }
    }, o = di(n, t);
    Object.assign(this, o);
  }
}
const E1 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20%3e%3cpath%20d='M4%2017.2105V10.2105C4%209.65823%204.44772%209.21051%205%209.21051H7.38197C7.76074%209.21051%208.107%208.99651%208.27639%208.65772L8.72361%207.7633C8.893%207.42451%209.23926%207.21051%209.61803%207.21051H14.382C14.7607%207.21051%2015.107%207.42451%2015.2764%207.7633L15.7236%208.65772C15.893%208.99651%2016.2393%209.21051%2016.618%209.21051H19C19.5523%209.21051%2020%209.65823%2020%2010.2105V17.2105C20%2017.7628%2019.5523%2018.2105%2019%2018.2105H5C4.44772%2018.2105%204%2017.7628%204%2017.2105Z'%20stroke='var(--primary-dark)'%20/%3e%3ccircle%20cx='12'%20cy='13.2105'%20r='3'%20stroke='var(---primary-dark)'%20/%3e%3c/svg%3e";
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function ea(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Ei(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ea(Object(n), !0).forEach(function(o) {
      M1(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ea(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function x1(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t || "default");
    if (typeof o != "object")
      return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function xi(e) {
  var t = x1(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function _o(e) {
  "@babel/helpers - typeof";
  return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _o(e);
}
function k1(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ta(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, xi(o.key), o);
  }
}
function D1(e, t, n) {
  return t && ta(e.prototype, t), n && ta(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function M1(e, t, n) {
  return t = xi(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ki(e) {
  return P1(e) || L1(e) || R1(e) || B1();
}
function P1(e) {
  if (Array.isArray(e))
    return yo(e);
}
function L1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function R1(e, t) {
  if (e) {
    if (typeof e == "string")
      return yo(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return yo(e, t);
  }
}
function yo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
function B1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Yn = typeof window < "u" && typeof window.document < "u", je = Yn ? window : {}, tr = Yn && je.document.documentElement ? "ontouchstart" in je.document.documentElement : !1, nr = Yn ? "PointerEvent" in je : !1, ae = "cropper", or = "all", Di = "crop", Mi = "move", Pi = "zoom", it = "e", st = "w", _t = "s", Qe = "n", Vt = "ne", Ft = "nw", zt = "se", Wt = "sw", Co = "".concat(ae, "-crop"), na = "".concat(ae, "-disabled"), Ce = "".concat(ae, "-hidden"), oa = "".concat(ae, "-hide"), j1 = "".concat(ae, "-invisible"), In = "".concat(ae, "-modal"), wo = "".concat(ae, "-move"), on = "".concat(ae, "Action"), hn = "".concat(ae, "Preview"), rr = "crop", Li = "move", Ri = "none", $o = "crop", So = "cropend", No = "cropmove", Ao = "cropstart", ra = "dblclick", U1 = tr ? "touchstart" : "mousedown", H1 = tr ? "touchmove" : "mousemove", V1 = tr ? "touchend touchcancel" : "mouseup", aa = nr ? "pointerdown" : U1, ia = nr ? "pointermove" : H1, sa = nr ? "pointerup pointercancel" : V1, la = "ready", ca = "resize", da = "wheel", To = "zoom", ua = "image/jpeg", F1 = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, z1 = /^data:/, W1 = /^data:image\/jpeg;base64,/, G1 = /^img|canvas$/i, Bi = 200, ji = 100, pa = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: rr,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Bi,
  minContainerHeight: ji,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Y1 = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Z1 = Number.isNaN || je.isNaN;
function Q(e) {
  return typeof e == "number" && !Z1(e);
}
var ha = function(t) {
  return t > 0 && t < 1 / 0;
};
function Qn(e) {
  return typeof e > "u";
}
function gt(e) {
  return _o(e) === "object" && e !== null;
}
var X1 = Object.prototype.hasOwnProperty;
function wt(e) {
  if (!gt(e))
    return !1;
  try {
    var t = e.constructor, n = t.prototype;
    return t && n && X1.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function _e(e) {
  return typeof e == "function";
}
var K1 = Array.prototype.slice;
function Ui(e) {
  return Array.from ? Array.from(e) : K1.call(e);
}
function de(e, t) {
  return e && _e(t) && (Array.isArray(e) || Q(e.length) ? Ui(e).forEach(function(n, o) {
    t.call(e, n, o, e);
  }) : gt(e) && Object.keys(e).forEach(function(n) {
    t.call(e, e[n], n, e);
  })), e;
}
var ie = Object.assign || function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    o[a - 1] = arguments[a];
  return gt(t) && o.length > 0 && o.forEach(function(r) {
    gt(r) && Object.keys(r).forEach(function(i) {
      t[i] = r[i];
    });
  }), t;
}, q1 = /\.\d*(?:0|9){12}\d*$/;
function At(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return q1.test(e) ? Math.round(e * t) / t : e;
}
var Q1 = /^width|height|left|top|marginLeft|marginTop$/;
function Je(e, t) {
  var n = e.style;
  de(t, function(o, a) {
    Q1.test(a) && Q(o) && (o = "".concat(o, "px")), n[a] = o;
  });
}
function J1(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function pe(e, t) {
  if (t) {
    if (Q(e.length)) {
      de(e, function(o) {
        pe(o, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(t) < 0 && (e.className = "".concat(n, " ").concat(t)) : e.className = t;
  }
}
function Be(e, t) {
  if (t) {
    if (Q(e.length)) {
      de(e, function(n) {
        Be(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function $t(e, t, n) {
  if (t) {
    if (Q(e.length)) {
      de(e, function(o) {
        $t(o, t, n);
      });
      return;
    }
    n ? pe(e, t) : Be(e, t);
  }
}
var eb = /([a-z\d])([A-Z])/g;
function ar(e) {
  return e.replace(eb, "$1-$2").toLowerCase();
}
function Oo(e, t) {
  return gt(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(ar(t)));
}
function rn(e, t, n) {
  gt(n) ? e[t] = n : e.dataset ? e.dataset[t] = n : e.setAttribute("data-".concat(ar(t)), n);
}
function tb(e, t) {
  if (gt(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(ar(t)));
}
var Hi = /\s\s*/, Vi = function() {
  var e = !1;
  if (Yn) {
    var t = !1, n = function() {
    }, o = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(r) {
        t = r;
      }
    });
    je.addEventListener("test", n, o), je.removeEventListener("test", n, o);
  }
  return e;
}();
function xe(e, t, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Hi).forEach(function(r) {
    if (!Vi) {
      var i = e.listeners;
      i && i[r] && i[r][n] && (a = i[r][n], delete i[r][n], Object.keys(i[r]).length === 0 && delete i[r], Object.keys(i).length === 0 && delete e.listeners);
    }
    e.removeEventListener(r, a, o);
  });
}
function Oe(e, t, n) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Hi).forEach(function(r) {
    if (o.once && !Vi) {
      var i = e.listeners, s = i === void 0 ? {} : i;
      a = function() {
        delete s[r][n], e.removeEventListener(r, a, o);
        for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
          u[d] = arguments[d];
        n.apply(e, u);
      }, s[r] || (s[r] = {}), s[r][n] && e.removeEventListener(r, s[r][n], o), s[r][n] = a, e.listeners = s;
    }
    e.addEventListener(r, a, o);
  });
}
function Tt(e, t, n) {
  var o;
  return _e(Event) && _e(CustomEvent) ? o = new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (o = document.createEvent("CustomEvent"), o.initCustomEvent(t, !0, !0, n)), e.dispatchEvent(o);
}
function Fi(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var Jn = je.location, nb = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function fa(e) {
  var t = e.match(nb);
  return t !== null && (t[1] !== Jn.protocol || t[2] !== Jn.hostname || t[3] !== Jn.port);
}
function ga(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function Yt(e) {
  var t = e.rotate, n = e.scaleX, o = e.scaleY, a = e.translateX, r = e.translateY, i = [];
  Q(a) && a !== 0 && i.push("translateX(".concat(a, "px)")), Q(r) && r !== 0 && i.push("translateY(".concat(r, "px)")), Q(t) && t !== 0 && i.push("rotate(".concat(t, "deg)")), Q(n) && n !== 1 && i.push("scaleX(".concat(n, ")")), Q(o) && o !== 1 && i.push("scaleY(".concat(o, ")"));
  var s = i.length ? i.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function ob(e) {
  var t = Ei({}, e), n = 0;
  return de(e, function(o, a) {
    delete t[a], de(t, function(r) {
      var i = Math.abs(o.startX - r.startX), s = Math.abs(o.startY - r.startY), l = Math.abs(o.endX - r.endX), c = Math.abs(o.endY - r.endY), u = Math.sqrt(i * i + s * s), d = Math.sqrt(l * l + c * c), p = (d - u) / u;
      Math.abs(p) > Math.abs(n) && (n = p);
    });
  }), n;
}
function fn(e, t) {
  var n = e.pageX, o = e.pageY, a = {
    endX: n,
    endY: o
  };
  return t ? a : Ei({
    startX: n,
    startY: o
  }, a);
}
function rb(e) {
  var t = 0, n = 0, o = 0;
  return de(e, function(a) {
    var r = a.startX, i = a.startY;
    t += r, n += i, o += 1;
  }), t /= o, n /= o, {
    pageX: t,
    pageY: n
  };
}
function et(e) {
  var t = e.aspectRatio, n = e.height, o = e.width, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", r = ha(o), i = ha(n);
  if (r && i) {
    var s = n * t;
    a === "contain" && s > o || a === "cover" && s < o ? n = o / t : o = n * t;
  } else
    r ? n = o / t : i && (o = n * t);
  return {
    width: o,
    height: n
  };
}
function ab(e) {
  var t = e.width, n = e.height, o = e.degree;
  if (o = Math.abs(o) % 180, o === 90)
    return {
      width: n,
      height: t
    };
  var a = o % 90 * Math.PI / 180, r = Math.sin(a), i = Math.cos(a), s = t * i + n * r, l = t * r + n * i;
  return o > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function ib(e, t, n, o) {
  var a = t.aspectRatio, r = t.naturalWidth, i = t.naturalHeight, s = t.rotate, l = s === void 0 ? 0 : s, c = t.scaleX, u = c === void 0 ? 1 : c, d = t.scaleY, p = d === void 0 ? 1 : d, h = n.aspectRatio, C = n.naturalWidth, f = n.naturalHeight, v = o.fillColor, S = v === void 0 ? "transparent" : v, T = o.imageSmoothingEnabled, m = T === void 0 ? !0 : T, O = o.imageSmoothingQuality, I = O === void 0 ? "low" : O, g = o.maxWidth, N = g === void 0 ? 1 / 0 : g, D = o.maxHeight, U = D === void 0 ? 1 / 0 : D, F = o.minWidth, A = F === void 0 ? 0 : F, $ = o.minHeight, x = $ === void 0 ? 0 : $, B = document.createElement("canvas"), R = B.getContext("2d"), z = et({
    aspectRatio: h,
    width: N,
    height: U
  }), J = et({
    aspectRatio: h,
    width: A,
    height: x
  }, "cover"), ne = Math.min(z.width, Math.max(J.width, C)), ce = Math.min(z.height, Math.max(J.height, f)), Ae = et({
    aspectRatio: a,
    width: N,
    height: U
  }), Te = et({
    aspectRatio: a,
    width: A,
    height: x
  }, "cover"), $e = Math.min(Ae.width, Math.max(Te.width, r)), Me = Math.min(Ae.height, Math.max(Te.height, i)), Ke = [-$e / 2, -Me / 2, $e, Me];
  return B.width = At(ne), B.height = At(ce), R.fillStyle = S, R.fillRect(0, 0, ne, ce), R.save(), R.translate(ne / 2, ce / 2), R.rotate(l * Math.PI / 180), R.scale(u, p), R.imageSmoothingEnabled = m, R.imageSmoothingQuality = I, R.drawImage.apply(R, [e].concat(ki(Ke.map(function(jt) {
    return Math.floor(At(jt));
  })))), R.restore(), B;
}
var zi = String.fromCharCode;
function sb(e, t, n) {
  var o = "";
  n += t;
  for (var a = t; a < n; a += 1)
    o += zi(e.getUint8(a));
  return o;
}
var lb = /^data:.*,/;
function cb(e) {
  var t = e.replace(lb, ""), n = atob(t), o = new ArrayBuffer(n.length), a = new Uint8Array(o);
  return de(a, function(r, i) {
    a[i] = n.charCodeAt(i);
  }), o;
}
function db(e, t) {
  for (var n = [], o = 8192, a = new Uint8Array(e); a.length > 0; )
    n.push(zi.apply(null, Ui(a.subarray(0, o)))), a = a.subarray(o);
  return "data:".concat(t, ";base64,").concat(btoa(n.join("")));
}
function ub(e) {
  var t = new DataView(e), n;
  try {
    var o, a, r;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var i = t.byteLength, s = 2; s + 1 < i; ) {
        if (t.getUint8(s) === 255 && t.getUint8(s + 1) === 225) {
          a = s;
          break;
        }
        s += 1;
      }
    if (a) {
      var l = a + 4, c = a + 10;
      if (sb(t, l, 4) === "Exif") {
        var u = t.getUint16(c);
        if (o = u === 18761, (o || u === 19789) && t.getUint16(c + 2, o) === 42) {
          var d = t.getUint32(c + 4, o);
          d >= 8 && (r = c + d);
        }
      }
    }
    if (r) {
      var p = t.getUint16(r, o), h, C;
      for (C = 0; C < p; C += 1)
        if (h = r + C * 12 + 2, t.getUint16(h, o) === 274) {
          h += 8, n = t.getUint16(h, o), t.setUint16(h, 1, o);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function pb(e) {
  var t = 0, n = 1, o = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      o = -1;
      break;
    case 5:
      t = 90, o = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, n = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: o
  };
}
var hb = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var t = this.element, n = this.options, o = this.container, a = this.cropper, r = Number(n.minContainerWidth), i = Number(n.minContainerHeight);
    pe(a, Ce), Be(t, Ce);
    var s = {
      width: Math.max(o.offsetWidth, r >= 0 ? r : Bi),
      height: Math.max(o.offsetHeight, i >= 0 ? i : ji)
    };
    this.containerData = s, Je(a, {
      width: s.width,
      height: s.height
    }), pe(t, Ce), Be(a, Ce);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var t = this.containerData, n = this.imageData, o = this.options.viewMode, a = Math.abs(n.rotate) % 180 === 90, r = a ? n.naturalHeight : n.naturalWidth, i = a ? n.naturalWidth : n.naturalHeight, s = r / i, l = t.width, c = t.height;
    t.height * s > t.width ? o === 3 ? l = t.height * s : c = t.width / s : o === 3 ? c = t.width / s : l = t.height * s;
    var u = {
      aspectRatio: s,
      naturalWidth: r,
      naturalHeight: i,
      width: l,
      height: c
    };
    this.canvasData = u, this.limited = o === 1 || o === 2, this.limitCanvas(!0, !0), u.width = Math.min(Math.max(u.width, u.minWidth), u.maxWidth), u.height = Math.min(Math.max(u.height, u.minHeight), u.maxHeight), u.left = (t.width - u.width) / 2, u.top = (t.height - u.height) / 2, u.oldLeft = u.left, u.oldTop = u.top, this.initialCanvasData = ie({}, u);
  },
  limitCanvas: function(t, n) {
    var o = this.options, a = this.containerData, r = this.canvasData, i = this.cropBoxData, s = o.viewMode, l = r.aspectRatio, c = this.cropped && i;
    if (t) {
      var u = Number(o.minCanvasWidth) || 0, d = Number(o.minCanvasHeight) || 0;
      s > 1 ? (u = Math.max(u, a.width), d = Math.max(d, a.height), s === 3 && (d * l > u ? u = d * l : d = u / l)) : s > 0 && (u ? u = Math.max(u, c ? i.width : 0) : d ? d = Math.max(d, c ? i.height : 0) : c && (u = i.width, d = i.height, d * l > u ? u = d * l : d = u / l));
      var p = et({
        aspectRatio: l,
        width: u,
        height: d
      });
      u = p.width, d = p.height, r.minWidth = u, r.minHeight = d, r.maxWidth = 1 / 0, r.maxHeight = 1 / 0;
    }
    if (n)
      if (s > (c ? 0 : 1)) {
        var h = a.width - r.width, C = a.height - r.height;
        r.minLeft = Math.min(0, h), r.minTop = Math.min(0, C), r.maxLeft = Math.max(0, h), r.maxTop = Math.max(0, C), c && this.limited && (r.minLeft = Math.min(i.left, i.left + (i.width - r.width)), r.minTop = Math.min(i.top, i.top + (i.height - r.height)), r.maxLeft = i.left, r.maxTop = i.top, s === 2 && (r.width >= a.width && (r.minLeft = Math.min(0, h), r.maxLeft = Math.max(0, h)), r.height >= a.height && (r.minTop = Math.min(0, C), r.maxTop = Math.max(0, C))));
      } else
        r.minLeft = -r.width, r.minTop = -r.height, r.maxLeft = a.width, r.maxTop = a.height;
  },
  renderCanvas: function(t, n) {
    var o = this.canvasData, a = this.imageData;
    if (n) {
      var r = ab({
        width: a.naturalWidth * Math.abs(a.scaleX || 1),
        height: a.naturalHeight * Math.abs(a.scaleY || 1),
        degree: a.rotate || 0
      }), i = r.width, s = r.height, l = o.width * (i / o.naturalWidth), c = o.height * (s / o.naturalHeight);
      o.left -= (l - o.width) / 2, o.top -= (c - o.height) / 2, o.width = l, o.height = c, o.aspectRatio = i / s, o.naturalWidth = i, o.naturalHeight = s, this.limitCanvas(!0, !1);
    }
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCanvas(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, Je(this.canvas, ie({
      width: o.width,
      height: o.height
    }, Yt({
      translateX: o.left,
      translateY: o.top
    }))), this.renderImage(t), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(t) {
    var n = this.canvasData, o = this.imageData, a = o.naturalWidth * (n.width / n.naturalWidth), r = o.naturalHeight * (n.height / n.naturalHeight);
    ie(o, {
      width: a,
      height: r,
      left: (n.width - a) / 2,
      top: (n.height - r) / 2
    }), Je(this.image, ie({
      width: o.width,
      height: o.height
    }, Yt(ie({
      translateX: o.left,
      translateY: o.top
    }, o)))), t && this.output();
  },
  initCropBox: function() {
    var t = this.options, n = this.canvasData, o = t.aspectRatio || t.initialAspectRatio, a = Number(t.autoCropArea) || 0.8, r = {
      width: n.width,
      height: n.height
    };
    o && (n.height * o > n.width ? r.height = r.width / o : r.width = r.height * o), this.cropBoxData = r, this.limitCropBox(!0, !0), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), r.width = Math.max(r.minWidth, r.width * a), r.height = Math.max(r.minHeight, r.height * a), r.left = n.left + (n.width - r.width) / 2, r.top = n.top + (n.height - r.height) / 2, r.oldLeft = r.left, r.oldTop = r.top, this.initialCropBoxData = ie({}, r);
  },
  limitCropBox: function(t, n) {
    var o = this.options, a = this.containerData, r = this.canvasData, i = this.cropBoxData, s = this.limited, l = o.aspectRatio;
    if (t) {
      var c = Number(o.minCropBoxWidth) || 0, u = Number(o.minCropBoxHeight) || 0, d = s ? Math.min(a.width, r.width, r.width + r.left, a.width - r.left) : a.width, p = s ? Math.min(a.height, r.height, r.height + r.top, a.height - r.top) : a.height;
      c = Math.min(c, a.width), u = Math.min(u, a.height), l && (c && u ? u * l > c ? u = c / l : c = u * l : c ? u = c / l : u && (c = u * l), p * l > d ? p = d / l : d = p * l), i.minWidth = Math.min(c, d), i.minHeight = Math.min(u, p), i.maxWidth = d, i.maxHeight = p;
    }
    n && (s ? (i.minLeft = Math.max(0, r.left), i.minTop = Math.max(0, r.top), i.maxLeft = Math.min(a.width, r.left + r.width) - i.width, i.maxTop = Math.min(a.height, r.top + r.height) - i.height) : (i.minLeft = 0, i.minTop = 0, i.maxLeft = a.width - i.width, i.maxTop = a.height - i.height));
  },
  renderCropBox: function() {
    var t = this.options, n = this.containerData, o = this.cropBoxData;
    (o.width > o.maxWidth || o.width < o.minWidth) && (o.left = o.oldLeft), (o.height > o.maxHeight || o.height < o.minHeight) && (o.top = o.oldTop), o.width = Math.min(Math.max(o.width, o.minWidth), o.maxWidth), o.height = Math.min(Math.max(o.height, o.minHeight), o.maxHeight), this.limitCropBox(!1, !0), o.left = Math.min(Math.max(o.left, o.minLeft), o.maxLeft), o.top = Math.min(Math.max(o.top, o.minTop), o.maxTop), o.oldLeft = o.left, o.oldTop = o.top, t.movable && t.cropBoxMovable && rn(this.face, on, o.width >= n.width && o.height >= n.height ? Mi : or), Je(this.cropBox, ie({
      width: o.width,
      height: o.height
    }, Yt({
      translateX: o.left,
      translateY: o.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), Tt(this.element, $o, this.getData());
  }
}, fb = {
  initPreview: function() {
    var t = this.element, n = this.crossOrigin, o = this.options.preview, a = n ? this.crossOriginUrl : this.url, r = t.alt || "The image to preview", i = document.createElement("img");
    if (n && (i.crossOrigin = n), i.src = a, i.alt = r, this.viewBox.appendChild(i), this.viewBoxImage = i, !!o) {
      var s = o;
      typeof o == "string" ? s = t.ownerDocument.querySelectorAll(o) : o.querySelector && (s = [o]), this.previews = s, de(s, function(l) {
        var c = document.createElement("img");
        rn(l, hn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), n && (c.crossOrigin = n), c.src = a, c.alt = r, c.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(c);
      });
    }
  },
  resetPreview: function() {
    de(this.previews, function(t) {
      var n = Oo(t, hn);
      Je(t, {
        width: n.width,
        height: n.height
      }), t.innerHTML = n.html, tb(t, hn);
    });
  },
  preview: function() {
    var t = this.imageData, n = this.canvasData, o = this.cropBoxData, a = o.width, r = o.height, i = t.width, s = t.height, l = o.left - n.left - t.left, c = o.top - n.top - t.top;
    !this.cropped || this.disabled || (Je(this.viewBoxImage, ie({
      width: i,
      height: s
    }, Yt(ie({
      translateX: -l,
      translateY: -c
    }, t)))), de(this.previews, function(u) {
      var d = Oo(u, hn), p = d.width, h = d.height, C = p, f = h, v = 1;
      a && (v = p / a, f = r * v), r && f > h && (v = h / r, C = a * v, f = h), Je(u, {
        width: C,
        height: f
      }), Je(u.getElementsByTagName("img")[0], ie({
        width: i * v,
        height: s * v
      }, Yt(ie({
        translateX: -l * v,
        translateY: -c * v
      }, t))));
    }));
  }
}, gb = {
  bind: function() {
    var t = this.element, n = this.options, o = this.cropper;
    _e(n.cropstart) && Oe(t, Ao, n.cropstart), _e(n.cropmove) && Oe(t, No, n.cropmove), _e(n.cropend) && Oe(t, So, n.cropend), _e(n.crop) && Oe(t, $o, n.crop), _e(n.zoom) && Oe(t, To, n.zoom), Oe(o, aa, this.onCropStart = this.cropStart.bind(this)), n.zoomable && n.zoomOnWheel && Oe(o, da, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && Oe(o, ra, this.onDblclick = this.dblclick.bind(this)), Oe(t.ownerDocument, ia, this.onCropMove = this.cropMove.bind(this)), Oe(t.ownerDocument, sa, this.onCropEnd = this.cropEnd.bind(this)), n.responsive && Oe(window, ca, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var t = this.element, n = this.options, o = this.cropper;
    _e(n.cropstart) && xe(t, Ao, n.cropstart), _e(n.cropmove) && xe(t, No, n.cropmove), _e(n.cropend) && xe(t, So, n.cropend), _e(n.crop) && xe(t, $o, n.crop), _e(n.zoom) && xe(t, To, n.zoom), xe(o, aa, this.onCropStart), n.zoomable && n.zoomOnWheel && xe(o, da, this.onWheel, {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && xe(o, ra, this.onDblclick), xe(t.ownerDocument, ia, this.onCropMove), xe(t.ownerDocument, sa, this.onCropEnd), n.responsive && xe(window, ca, this.onResize);
  }
}, vb = {
  resize: function() {
    if (!this.disabled) {
      var t = this.options, n = this.container, o = this.containerData, a = n.offsetWidth / o.width, r = n.offsetHeight / o.height, i = Math.abs(a - 1) > Math.abs(r - 1) ? a : r;
      if (i !== 1) {
        var s, l;
        t.restore && (s = this.getCanvasData(), l = this.getCropBoxData()), this.render(), t.restore && (this.setCanvasData(de(s, function(c, u) {
          s[u] = c * i;
        })), this.setCropBoxData(de(l, function(c, u) {
          l[u] = c * i;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === Ri || this.setDragMode(J1(this.dragBox, Co) ? Li : rr);
  },
  wheel: function(t) {
    var n = this, o = Number(this.options.wheelZoomRatio) || 0.1, a = 1;
    this.disabled || (t.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      n.wheeling = !1;
    }, 50), t.deltaY ? a = t.deltaY > 0 ? 1 : -1 : t.wheelDelta ? a = -t.wheelDelta / 120 : t.detail && (a = t.detail > 0 ? 1 : -1), this.zoom(-a * o, t)));
  },
  cropStart: function(t) {
    var n = t.buttons, o = t.button;
    if (!(this.disabled || (t.type === "mousedown" || t.type === "pointerdown" && t.pointerType === "mouse") && // No primary button (Usually the left button)
    (Q(n) && n !== 1 || Q(o) && o !== 0 || t.ctrlKey))) {
      var a = this.options, r = this.pointers, i;
      t.changedTouches ? de(t.changedTouches, function(s) {
        r[s.identifier] = fn(s);
      }) : r[t.pointerId || 0] = fn(t), Object.keys(r).length > 1 && a.zoomable && a.zoomOnTouch ? i = Pi : i = Oo(t.target, on), F1.test(i) && Tt(this.element, Ao, {
        originalEvent: t,
        action: i
      }) !== !1 && (t.preventDefault(), this.action = i, this.cropping = !1, i === Di && (this.cropping = !0, pe(this.dragBox, In)));
    }
  },
  cropMove: function(t) {
    var n = this.action;
    if (!(this.disabled || !n)) {
      var o = this.pointers;
      t.preventDefault(), Tt(this.element, No, {
        originalEvent: t,
        action: n
      }) !== !1 && (t.changedTouches ? de(t.changedTouches, function(a) {
        ie(o[a.identifier] || {}, fn(a, !0));
      }) : ie(o[t.pointerId || 0] || {}, fn(t, !0)), this.change(t));
    }
  },
  cropEnd: function(t) {
    if (!this.disabled) {
      var n = this.action, o = this.pointers;
      t.changedTouches ? de(t.changedTouches, function(a) {
        delete o[a.identifier];
      }) : delete o[t.pointerId || 0], n && (t.preventDefault(), Object.keys(o).length || (this.action = ""), this.cropping && (this.cropping = !1, $t(this.dragBox, In, this.cropped && this.options.modal)), Tt(this.element, So, {
        originalEvent: t,
        action: n
      }));
    }
  }
}, mb = {
  change: function(t) {
    var n = this.options, o = this.canvasData, a = this.containerData, r = this.cropBoxData, i = this.pointers, s = this.action, l = n.aspectRatio, c = r.left, u = r.top, d = r.width, p = r.height, h = c + d, C = u + p, f = 0, v = 0, S = a.width, T = a.height, m = !0, O;
    !l && t.shiftKey && (l = d && p ? d / p : 1), this.limited && (f = r.minLeft, v = r.minTop, S = f + Math.min(a.width, o.width, o.left + o.width), T = v + Math.min(a.height, o.height, o.top + o.height));
    var I = i[Object.keys(i)[0]], g = {
      x: I.endX - I.startX,
      y: I.endY - I.startY
    }, N = function(U) {
      switch (U) {
        case it:
          h + g.x > S && (g.x = S - h);
          break;
        case st:
          c + g.x < f && (g.x = f - c);
          break;
        case Qe:
          u + g.y < v && (g.y = v - u);
          break;
        case _t:
          C + g.y > T && (g.y = T - C);
          break;
      }
    };
    switch (s) {
      case or:
        c += g.x, u += g.y;
        break;
      case it:
        if (g.x >= 0 && (h >= S || l && (u <= v || C >= T))) {
          m = !1;
          break;
        }
        N(it), d += g.x, d < 0 && (s = st, d = -d, c -= d), l && (p = d / l, u += (r.height - p) / 2);
        break;
      case Qe:
        if (g.y <= 0 && (u <= v || l && (c <= f || h >= S))) {
          m = !1;
          break;
        }
        N(Qe), p -= g.y, u += g.y, p < 0 && (s = _t, p = -p, u -= p), l && (d = p * l, c += (r.width - d) / 2);
        break;
      case st:
        if (g.x <= 0 && (c <= f || l && (u <= v || C >= T))) {
          m = !1;
          break;
        }
        N(st), d -= g.x, c += g.x, d < 0 && (s = it, d = -d, c -= d), l && (p = d / l, u += (r.height - p) / 2);
        break;
      case _t:
        if (g.y >= 0 && (C >= T || l && (c <= f || h >= S))) {
          m = !1;
          break;
        }
        N(_t), p += g.y, p < 0 && (s = Qe, p = -p, u -= p), l && (d = p * l, c += (r.width - d) / 2);
        break;
      case Vt:
        if (l) {
          if (g.y <= 0 && (u <= v || h >= S)) {
            m = !1;
            break;
          }
          N(Qe), p -= g.y, u += g.y, d = p * l;
        } else
          N(Qe), N(it), g.x >= 0 ? h < S ? d += g.x : g.y <= 0 && u <= v && (m = !1) : d += g.x, g.y <= 0 ? u > v && (p -= g.y, u += g.y) : (p -= g.y, u += g.y);
        d < 0 && p < 0 ? (s = Wt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Ft, d = -d, c -= d) : p < 0 && (s = zt, p = -p, u -= p);
        break;
      case Ft:
        if (l) {
          if (g.y <= 0 && (u <= v || c <= f)) {
            m = !1;
            break;
          }
          N(Qe), p -= g.y, u += g.y, d = p * l, c += r.width - d;
        } else
          N(Qe), N(st), g.x <= 0 ? c > f ? (d -= g.x, c += g.x) : g.y <= 0 && u <= v && (m = !1) : (d -= g.x, c += g.x), g.y <= 0 ? u > v && (p -= g.y, u += g.y) : (p -= g.y, u += g.y);
        d < 0 && p < 0 ? (s = zt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Vt, d = -d, c -= d) : p < 0 && (s = Wt, p = -p, u -= p);
        break;
      case Wt:
        if (l) {
          if (g.x <= 0 && (c <= f || C >= T)) {
            m = !1;
            break;
          }
          N(st), d -= g.x, c += g.x, p = d / l;
        } else
          N(_t), N(st), g.x <= 0 ? c > f ? (d -= g.x, c += g.x) : g.y >= 0 && C >= T && (m = !1) : (d -= g.x, c += g.x), g.y >= 0 ? C < T && (p += g.y) : p += g.y;
        d < 0 && p < 0 ? (s = Vt, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = zt, d = -d, c -= d) : p < 0 && (s = Ft, p = -p, u -= p);
        break;
      case zt:
        if (l) {
          if (g.x >= 0 && (h >= S || C >= T)) {
            m = !1;
            break;
          }
          N(it), d += g.x, p = d / l;
        } else
          N(_t), N(it), g.x >= 0 ? h < S ? d += g.x : g.y >= 0 && C >= T && (m = !1) : d += g.x, g.y >= 0 ? C < T && (p += g.y) : p += g.y;
        d < 0 && p < 0 ? (s = Ft, p = -p, d = -d, u -= p, c -= d) : d < 0 ? (s = Wt, d = -d, c -= d) : p < 0 && (s = Vt, p = -p, u -= p);
        break;
      case Mi:
        this.move(g.x, g.y), m = !1;
        break;
      case Pi:
        this.zoom(ob(i), t), m = !1;
        break;
      case Di:
        if (!g.x || !g.y) {
          m = !1;
          break;
        }
        O = Fi(this.cropper), c = I.startX - O.left, u = I.startY - O.top, d = r.minWidth, p = r.minHeight, g.x > 0 ? s = g.y > 0 ? zt : Vt : g.x < 0 && (c -= d, s = g.y > 0 ? Wt : Ft), g.y < 0 && (u -= p), this.cropped || (Be(this.cropBox, Ce), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    m && (r.width = d, r.height = p, r.left = c, r.top = u, this.action = s, this.renderCropBox()), de(i, function(D) {
      D.startX = D.endX, D.startY = D.endY;
    });
  }
}, bb = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && pe(this.dragBox, In), Be(this.cropBox, Ce), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = ie({}, this.initialImageData), this.canvasData = ie({}, this.initialCanvasData), this.cropBoxData = ie({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (ie(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Be(this.dragBox, In), pe(this.cropBox, Ce)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && t && (this.isImg && (this.element.src = t), n ? (this.url = t, this.image.src = t, this.ready && (this.viewBoxImage.src = t, de(this.previews, function(o) {
      o.getElementsByTagName("img")[0].src = t;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(t))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Be(this.cropper, na)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, pe(this.cropper, na)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var t = this.element;
    return t[ae] ? (t[ae] = void 0, this.isImg && this.replaced && (t.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.canvasData, a = o.left, r = o.top;
    return this.moveTo(Qn(t) ? t : a + Number(t), Qn(n) ? n : r + Number(n));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.canvasData, a = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.movable && (Q(t) && (o.left = t, a = !0), Q(n) && (o.top = n, a = !0), a && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(t, n) {
    var o = this.canvasData;
    return t = Number(t), t < 0 ? t = 1 / (1 - t) : t = 1 + t, this.zoomTo(o.width * t / o.naturalWidth, null, n);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(t, n, o) {
    var a = this.options, r = this.canvasData, i = r.width, s = r.height, l = r.naturalWidth, c = r.naturalHeight;
    if (t = Number(t), t >= 0 && this.ready && !this.disabled && a.zoomable) {
      var u = l * t, d = c * t;
      if (Tt(this.element, To, {
        ratio: t,
        oldRatio: i / l,
        originalEvent: o
      }) === !1)
        return this;
      if (o) {
        var p = this.pointers, h = Fi(this.cropper), C = p && Object.keys(p).length ? rb(p) : {
          pageX: o.pageX,
          pageY: o.pageY
        };
        r.left -= (u - i) * ((C.pageX - h.left - r.left) / i), r.top -= (d - s) * ((C.pageY - h.top - r.top) / s);
      } else
        wt(n) && Q(n.x) && Q(n.y) ? (r.left -= (u - i) * ((n.x - r.left) / i), r.top -= (d - s) * ((n.y - r.top) / s)) : (r.left -= (u - i) / 2, r.top -= (d - s) / 2);
      r.width = u, r.height = d, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(t) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(t));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(t) {
    return t = Number(t), Q(t) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = t % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(t) {
    var n = this.imageData.scaleY;
    return this.scale(t, Q(n) ? n : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(t) {
    var n = this.imageData.scaleX;
    return this.scale(Q(n) ? n : 1, t);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, o = this.imageData, a = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.scalable && (Q(t) && (o.scaleX = t, a = !0), Q(n) && (o.scaleY = n, a = !0), a && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = this.options, o = this.imageData, a = this.canvasData, r = this.cropBoxData, i;
    if (this.ready && this.cropped) {
      i = {
        x: r.left - a.left,
        y: r.top - a.top,
        width: r.width,
        height: r.height
      };
      var s = o.width / o.naturalWidth;
      if (de(i, function(u, d) {
        i[d] = u / s;
      }), t) {
        var l = Math.round(i.y + i.height), c = Math.round(i.x + i.width);
        i.x = Math.round(i.x), i.y = Math.round(i.y), i.width = c - i.x, i.height = l - i.y;
      }
    } else
      i = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return n.rotatable && (i.rotate = o.rotate || 0), n.scalable && (i.scaleX = o.scaleX || 1, i.scaleY = o.scaleY || 1), i;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(t) {
    var n = this.options, o = this.imageData, a = this.canvasData, r = {};
    if (this.ready && !this.disabled && wt(t)) {
      var i = !1;
      n.rotatable && Q(t.rotate) && t.rotate !== o.rotate && (o.rotate = t.rotate, i = !0), n.scalable && (Q(t.scaleX) && t.scaleX !== o.scaleX && (o.scaleX = t.scaleX, i = !0), Q(t.scaleY) && t.scaleY !== o.scaleY && (o.scaleY = t.scaleY, i = !0)), i && this.renderCanvas(!0, !0);
      var s = o.width / o.naturalWidth;
      Q(t.x) && (r.left = t.x * s + a.left), Q(t.y) && (r.top = t.y * s + a.top), Q(t.width) && (r.width = t.width * s), Q(t.height) && (r.height = t.height * s), this.setCropBoxData(r);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? ie({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? ie({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var t = this.canvasData, n = {};
    return this.ready && de(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(o) {
      n[o] = t[o];
    }), n;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(t) {
    var n = this.canvasData, o = n.aspectRatio;
    return this.ready && !this.disabled && wt(t) && (Q(t.left) && (n.left = t.left), Q(t.top) && (n.top = t.top), Q(t.width) ? (n.width = t.width, n.height = t.width / o) : Q(t.height) && (n.height = t.height, n.width = t.height * o), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var t = this.cropBoxData, n;
    return this.ready && this.cropped && (n = {
      left: t.left,
      top: t.top,
      width: t.width,
      height: t.height
    }), n || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(t) {
    var n = this.cropBoxData, o = this.options.aspectRatio, a, r;
    return this.ready && this.cropped && !this.disabled && wt(t) && (Q(t.left) && (n.left = t.left), Q(t.top) && (n.top = t.top), Q(t.width) && t.width !== n.width && (a = !0, n.width = t.width), Q(t.height) && t.height !== n.height && (r = !0, n.height = t.height), o && (a ? n.height = n.width / o : r && (n.width = n.height * o)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var n = this.canvasData, o = ib(this.image, this.imageData, n, t);
    if (!this.cropped)
      return o;
    var a = this.getData(t.rounded), r = a.x, i = a.y, s = a.width, l = a.height, c = o.width / Math.floor(n.naturalWidth);
    c !== 1 && (r *= c, i *= c, s *= c, l *= c);
    var u = s / l, d = et({
      aspectRatio: u,
      width: t.maxWidth || 1 / 0,
      height: t.maxHeight || 1 / 0
    }), p = et({
      aspectRatio: u,
      width: t.minWidth || 0,
      height: t.minHeight || 0
    }, "cover"), h = et({
      aspectRatio: u,
      width: t.width || (c !== 1 ? o.width : s),
      height: t.height || (c !== 1 ? o.height : l)
    }), C = h.width, f = h.height;
    C = Math.min(d.width, Math.max(p.width, C)), f = Math.min(d.height, Math.max(p.height, f));
    var v = document.createElement("canvas"), S = v.getContext("2d");
    v.width = At(C), v.height = At(f), S.fillStyle = t.fillColor || "transparent", S.fillRect(0, 0, C, f);
    var T = t.imageSmoothingEnabled, m = T === void 0 ? !0 : T, O = t.imageSmoothingQuality;
    S.imageSmoothingEnabled = m, O && (S.imageSmoothingQuality = O);
    var I = o.width, g = o.height, N = r, D = i, U, F, A, $, x, B;
    N <= -s || N > I ? (N = 0, U = 0, A = 0, x = 0) : N <= 0 ? (A = -N, N = 0, U = Math.min(I, s + N), x = U) : N <= I && (A = 0, U = Math.min(s, I - N), x = U), U <= 0 || D <= -l || D > g ? (D = 0, F = 0, $ = 0, B = 0) : D <= 0 ? ($ = -D, D = 0, F = Math.min(g, l + D), B = F) : D <= g && ($ = 0, F = Math.min(l, g - D), B = F);
    var R = [N, D, U, F];
    if (x > 0 && B > 0) {
      var z = C / s;
      R.push(A * z, $ * z, x * z, B * z);
    }
    return S.drawImage.apply(S, [o].concat(ki(R.map(function(J) {
      return Math.floor(At(J));
    })))), v;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(t) {
    var n = this.options;
    return !this.disabled && !Qn(t) && (n.aspectRatio = Math.max(0, t) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(t) {
    var n = this.options, o = this.dragBox, a = this.face;
    if (this.ready && !this.disabled) {
      var r = t === rr, i = n.movable && t === Li;
      t = r || i ? t : Ri, n.dragMode = t, rn(o, on, t), $t(o, Co, r), $t(o, wo, i), n.cropBoxMovable || (rn(a, on, t), $t(a, Co, r), $t(a, wo, i));
    }
    return this;
  }
}, _b = je.Cropper, Wi = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (k1(this, e), !t || !G1.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = ie({}, pa, wt(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return D1(e, [{
    key: "init",
    value: function() {
      var n = this.element, o = n.tagName.toLowerCase(), a;
      if (!n[ae]) {
        if (n[ae] = this, o === "img") {
          if (this.isImg = !0, a = n.getAttribute("src") || "", this.originalUrl = a, !a)
            return;
          a = n.src;
        } else
          o === "canvas" && window.HTMLCanvasElement && (a = n.toDataURL());
        this.load(a);
      }
    }
  }, {
    key: "load",
    value: function(n) {
      var o = this;
      if (n) {
        this.url = n, this.imageData = {};
        var a = this.element, r = this.options;
        if (!r.rotatable && !r.scalable && (r.checkOrientation = !1), !r.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (z1.test(n)) {
          W1.test(n) ? this.read(cb(n)) : this.clone();
          return;
        }
        var i = new XMLHttpRequest(), s = this.clone.bind(this);
        this.reloading = !0, this.xhr = i, i.onabort = s, i.onerror = s, i.ontimeout = s, i.onprogress = function() {
          i.getResponseHeader("content-type") !== ua && i.abort();
        }, i.onload = function() {
          o.read(i.response);
        }, i.onloadend = function() {
          o.reloading = !1, o.xhr = null;
        }, r.checkCrossOrigin && fa(n) && a.crossOrigin && (n = ga(n)), i.open("GET", n, !0), i.responseType = "arraybuffer", i.withCredentials = a.crossOrigin === "use-credentials", i.send();
      }
    }
  }, {
    key: "read",
    value: function(n) {
      var o = this.options, a = this.imageData, r = ub(n), i = 0, s = 1, l = 1;
      if (r > 1) {
        this.url = db(n, ua);
        var c = pb(r);
        i = c.rotate, s = c.scaleX, l = c.scaleY;
      }
      o.rotatable && (a.rotate = i), o.scalable && (a.scaleX = s, a.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var n = this.element, o = this.url, a = n.crossOrigin, r = o;
      this.options.checkCrossOrigin && fa(o) && (a || (a = "anonymous"), r = ga(o)), this.crossOrigin = a, this.crossOriginUrl = r;
      var i = document.createElement("img");
      a && (i.crossOrigin = a), i.src = r || o, i.alt = n.alt || "The image to crop", this.image = i, i.onload = this.start.bind(this), i.onerror = this.stop.bind(this), pe(i, oa), n.parentNode.insertBefore(i, n.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var n = this, o = this.image;
      o.onload = null, o.onerror = null, this.sizing = !0;
      var a = je.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(je.navigator.userAgent), r = function(c, u) {
        ie(n.imageData, {
          naturalWidth: c,
          naturalHeight: u,
          aspectRatio: c / u
        }), n.initialImageData = ie({}, n.imageData), n.sizing = !1, n.sized = !0, n.build();
      };
      if (o.naturalWidth && !a) {
        r(o.naturalWidth, o.naturalHeight);
        return;
      }
      var i = document.createElement("img"), s = document.body || document.documentElement;
      this.sizingImage = i, i.onload = function() {
        r(i.width, i.height), a || s.removeChild(i);
      }, i.src = o.src, a || (i.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", s.appendChild(i));
    }
  }, {
    key: "stop",
    value: function() {
      var n = this.image;
      n.onload = null, n.onerror = null, n.parentNode.removeChild(n), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var n = this.element, o = this.options, a = this.image, r = n.parentNode, i = document.createElement("div");
        i.innerHTML = Y1;
        var s = i.querySelector(".".concat(ae, "-container")), l = s.querySelector(".".concat(ae, "-canvas")), c = s.querySelector(".".concat(ae, "-drag-box")), u = s.querySelector(".".concat(ae, "-crop-box")), d = u.querySelector(".".concat(ae, "-face"));
        this.container = r, this.cropper = s, this.canvas = l, this.dragBox = c, this.cropBox = u, this.viewBox = s.querySelector(".".concat(ae, "-view-box")), this.face = d, l.appendChild(a), pe(n, Ce), r.insertBefore(s, n.nextSibling), Be(a, oa), this.initPreview(), this.bind(), o.initialAspectRatio = Math.max(0, o.initialAspectRatio) || NaN, o.aspectRatio = Math.max(0, o.aspectRatio) || NaN, o.viewMode = Math.max(0, Math.min(3, Math.round(o.viewMode))) || 0, pe(u, Ce), o.guides || pe(u.getElementsByClassName("".concat(ae, "-dashed")), Ce), o.center || pe(u.getElementsByClassName("".concat(ae, "-center")), Ce), o.background && pe(s, "".concat(ae, "-bg")), o.highlight || pe(d, j1), o.cropBoxMovable && (pe(d, wo), rn(d, on, or)), o.cropBoxResizable || (pe(u.getElementsByClassName("".concat(ae, "-line")), Ce), pe(u.getElementsByClassName("".concat(ae, "-point")), Ce)), this.render(), this.ready = !0, this.setDragMode(o.dragMode), o.autoCrop && this.crop(), this.setData(o.data), _e(o.ready) && Oe(n, la, o.ready, {
          once: !0
        }), Tt(n, la);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var n = this.cropper.parentNode;
        n && n.removeChild(this.cropper), Be(this.element, Ce);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = _b, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(n) {
      ie(pa, wt(n) && n);
    }
  }]);
}();
ie(Wi.prototype, hb, fb, gb, vb, mb, bb);
const yb = {
  name: "FocalPoint",
  props: {
    modelValue: {
      type: Object,
      // default position to the focal point to start
      default: () => ({
        x: 50,
        y: 50
      })
    },
    src: {
      type: String,
      default: () => ""
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      pin: null,
      // local position for the focal point
      localFocalPoint: {
        x: 50,
        y: 50
      },
      // style for the container based on the loaded image
      focalContainerStyle: {
        height: 0,
        width: 0,
        left: 0,
        top: 0
      },
      pinPositioned: !1,
      isModified: !1
    };
  },
  computed: {
    pinStyle() {
      if (!this.pin)
        return null;
      const { width: e, height: t } = this.pin;
      if (!this.localFocalPoint)
        return {
          left: this.s(50, e),
          top: this.s(50, t)
        };
      const { x: n, y: o } = this.localFocalPoint;
      return {
        left: this.s(n, e),
        top: this.s(o, t)
      };
    }
  },
  watch: {
    modelValue(e) {
      this.localFocalPoint = e;
    }
  },
  mounted() {
    this.pin = this.$refs.pin.getBoundingClientRect(), this.modelValue && (this.localFocalPoint = { ...this.modelValue });
  },
  // Remove event listeners on destroy
  beforeUnmount() {
    window !== "undefined" && (window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp));
  },
  methods: {
    click(e) {
      this.isModified = !0, this.$emit("update:modelValue", this.getPercentage(e));
    },
    // Every position needs to be transformed to percentage
    getPercentage(e) {
      const { offsetX: t, offsetY: n } = e, { width: o, height: a } = this.$refs.focalContainer.getBoundingClientRect();
      return {
        x: this.calculatePercentage(t, o),
        y: this.calculatePercentage(n, a)
      };
    },
    // This helps for the drag event of the focal point
    handleContainerMouseMove(e) {
      this.localFocalPoint = this.getPercentage(e);
    },
    // Calculate mouse position on mouse up
    handlePointerMouseUp(e) {
      typeof window < "u" && (this.$refs.focalContainer.removeEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), window.removeEventListener("mouseup", this.handlePointerMouseUp), window.removeEventListener("blur", this.handlePointerMouseUp), this.$refs.pin.style.pointerEvents = "", this.$emit("input", this.localFocalPoint));
    },
    // Calculate mouse position on mouse down
    handlePointerMouseDown(e) {
      typeof window < "u" && (this.$refs.focalContainer.addEventListener(
        "mousemove",
        this.handleContainerMouseMove
      ), this.$refs.pin.style.pointerEvents = "none", window.addEventListener("mouseup", this.handlePointerMouseUp), window.addEventListener("blur", this.handlePointerMouseUp));
    },
    loadVirtualImage() {
      const { height: e, width: t } = this.getRenderedImageSize(this.$refs.image), { clientHeight: n = 0, clientWidth: o = 0 } = this.$refs.image.parentNode;
      this.focalContainerStyle = {
        height: e,
        width: t,
        left: (o - t) / 2,
        top: (n - e) / 2
      }, this.pinPositioned = !0;
    },
    getRenderedImageSize(e) {
      const {
        width: t,
        height: n,
        naturalWidth: o,
        naturalHeight: a
      } = e, r = o / a, i = t / n;
      let s, l;
      return r > i ? (l = t, s = t / r) : (l = n * r, s = n), { height: s, width: l };
    },
    calculatePercentage(e, t) {
      return Math.round(e * 100 / t);
    },
    s(e, t) {
      return `calc(${e}% - ${t / 2}px)`;
    },
    // Allow setting focal point from image cropper
    setFocalPoint(e) {
      e && e.x > -1 && e.y > -1 && (this.localFocalPoint = { ...e }), this.$emit("input", this.localFocalPoint);
    },
    // Allow returning focal point to center position from image cropper
    resetFocalPoint() {
      this.localFocalPoint = { x: 50, y: 50 }, this.$emit("input", this.localFocalPoint);
    }
  }
}, Cb = { class: "focal-point" }, wb = ["src"];
function $b(e, t, n, o, a, r) {
  return y(), M("div", Cb, [
    w("img", {
      ref: "image",
      src: n.src,
      name: "image",
      class: "virtual-image",
      onLoad: t[0] || (t[0] = (...i) => r.loadVirtualImage && r.loadVirtualImage(...i))
    }, null, 40, wb),
    Zt(w("div", {
      ref: "focalContainer",
      style: Ie({
        height: `${a.focalContainerStyle.height}px`,
        width: `${a.focalContainerStyle.width}px`,
        left: `${a.focalContainerStyle.left}px`,
        top: `${a.focalContainerStyle.top}px`,
        position: "absolute"
      }),
      onClick: t[2] || (t[2] = (...i) => r.click && r.click(...i))
    }, [
      w("div", {
        ref: "pin",
        style: Ie(r.pinStyle),
        class: "focal-point-pin",
        onMousedown: t[1] || (t[1] = (...i) => r.handlePointerMouseDown && r.handlePointerMouseDown(...i))
      }, [
        Ne(e.$slots, "pin")
      ], 36)
    ], 4), [
      [xa, n.focalPointAllowed]
    ])
  ]);
}
const Sb = /* @__PURE__ */ X(yb, [["render", $b]]), Nb = {}, Ab = {
  width: "33",
  height: "34",
  viewBox: "0 0 33 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Tb(e, t) {
  return y(), M("svg", Ab, t[0] || (t[0] = [
    ka('<circle cx="16.5" cy="17.2773" r="16" fill="black" fill-opacity="0.5" stroke="white"></circle><rect x="16" y="10.7734" width="1" height="5" rx="0.5" fill="white"></rect><rect x="16" y="18.7773" width="1" height="5" rx="0.5" fill="white"></rect><rect x="23" y="16.7773" width="1" height="5" rx="0.5" transform="rotate(90 23 16.7773)" fill="white"></rect><rect x="15" y="16.7773" width="1" height="5" rx="0.5" transform="rotate(90 15 16.7773)" fill="white"></rect>', 5)
  ]));
}
const Gi = /* @__PURE__ */ X(Nb, [["render", Tb]]), VS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gi
}, Symbol.toStringTag, { value: "Module" })), Ob = {
  components: {
    FocalPoint: Sb,
    FocalPointIcon: Gi
  },
  props: {
    image: {
      type: Object,
      required: !0
    },
    isCropping: {
      type: Boolean,
      required: !1
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    },
    containerStyle: {
      type: Object,
      default: () => ({})
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    isSelected: Boolean
  },
  data() {
    return {
      cropper: null,
      localFocalPoint: { x: 50, y: 50 },
      showFocusImage: !0
    };
  },
  watch: {
    isCropping(e) {
      e ? this.cropper.crop() : this.cropper.clear();
    },
    localFocalPoint(e, t) {
      (e.x !== t.x || e.y !== t.y) && this.$emit("focal-point-changed", e);
    }
  },
  mounted() {
    var e;
    (e = this.image) != null && e.properties.focalPointPosition && (this.localFocalPoint = this.image.properties.focalPointPosition), this.cropper = new Wi(this.$refs.img, {
      zoomable: !1,
      viewMode: 1,
      autoCropArea: 1,
      autoCrop: !1,
      background: !1,
      modal: !0,
      ready: () => {
        this.enableEditingIfCropperIsReady();
      },
      ...this.$attrs
    });
  },
  computed: {
    src() {
      return this.image.previewUrl;
    },
    alt() {
      return this.image.alt_text;
    }
  },
  methods: {
    enableEditingIfCropperIsReady() {
      this.$emit("set-natural-size", {
        width: this.cropper.initialImageData.naturalWidth,
        height: this.cropper.initialImageData.naturalHeight
      }), this.$emit("enable-editing", !0);
    },
    fn(e, ...t) {
      return this.cropper[e](...t);
    }
  }
}, Ib = { class: "image-container" }, Eb = { class: "focal-point-container" }, xb = ["src", "alt"];
function kb(e, t, n, o, a, r) {
  const i = L("FocalPointIcon"), s = L("FocalPoint");
  return y(), M("div", Ib, [
    Zt(w("div", Eb, [
      E(s, {
        modelValue: a.localFocalPoint,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => a.localFocalPoint = l),
        "is-selected": n.isSelected,
        src: r.src,
        "focal-point-allowed": n.focalPointAllowed
      }, {
        pin: P(() => [
          E(i)
        ]),
        _: 1
      }, 8, ["modelValue", "is-selected", "src", "focal-point-allowed"])
    ], 512), [
      [xa, !n.isCropping]
    ]),
    w("img", {
      ref: "img",
      class: "image",
      src: r.src,
      alt: r.alt
    }, null, 8, xb)
  ]);
}
const Db = /* @__PURE__ */ X(Ob, [["render", kb], ["__scopeId", "data-v-0642fe82"]]), Mb = {}, Pb = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Lb(e, t) {
  return y(), M("svg", Pb, t[0] || (t[0] = [
    w("path", {
      d: "M5.5 3.57143V1M5.5 7.42857V14.5H19M1 5.5H14.5V12.5714M14.5 16.4286V19",
      stroke: "var(--purple)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const Yi = /* @__PURE__ */ X(Mb, [["render", Lb]]), FS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yi
}, Symbol.toStringTag, { value: "Module" })), Rb = {
  name: "ImageEditorControls",
  components: {
    CropIcon: Yi
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    isCropping: Boolean,
    disableResetButton: Boolean
  }
}, Bb = { class: "image-controls" }, jb = ["accept"];
function Ub(e, t, n, o, a, r) {
  const i = L("a-button"), s = L("CropIcon"), l = L("a-icon");
  return y(), M("div", Bb, [
    n.isCropping ? (y(), M(ke, { key: 0 }, [
      E(i, {
        variant: "secondary",
        onClick: t[0] || (t[0] = (c) => e.$emit("confirm-crop"))
      }, {
        default: P(() => [
          fe(K(e.$t("builder.imageUploader.confirmCrop")), 1)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "cancel-crop",
        onClick: t[1] || (t[1] = (c) => e.$emit("cancel-crop"))
      }, {
        default: P(() => [
          fe(K(e.$t("builder.imageUploader.cancelCrop")), 1)
        ]),
        _: 1
      })
    ], 64)) : (y(), M(ke, { key: 1 }, [
      w("input", {
        ref: "replaceImageInput",
        hidden: "",
        class: "file-input",
        type: "file",
        accept: n.acceptedFileTypes,
        onChange: t[2] || (t[2] = (c) => e.$emit("replace-image", c))
      }, null, 40, jb),
      E(i, {
        variant: "secondary",
        onClick: t[3] || (t[3] = (c) => e.$refs.replaceImageInput.click())
      }, {
        default: P(() => [
          fe(K(e.$t("builder.imageUploader.replace")), 1)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "begin-crop",
        size: "small",
        "aria-label": "Crop Image",
        onClick: t[4] || (t[4] = (c) => e.$emit("begin-crop"))
      }, {
        default: P(() => [
          E(s)
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "rotate-left",
        size: "small",
        "aria-label": "Rotate Left",
        onClick: t[5] || (t[5] = (c) => e.$emit("rotate", -90))
      }, {
        default: P(() => [
          E(l, { icon: "24:arrow-counter-clockwise" })
        ]),
        _: 1
      }),
      E(i, {
        variant: "secondary",
        class: "rotate-right",
        size: "small",
        "aria-label": "Rotate Right",
        onClick: t[6] || (t[6] = (c) => e.$emit("rotate", 90))
      }, {
        default: P(() => [
          E(l, { icon: "24:arrow-clockwise" })
        ]),
        _: 1
      }),
      E(i, {
        disabled: n.disableResetButton,
        variant: "secondary",
        class: "reset-button",
        onClick: t[7] || (t[7] = (c) => e.$emit("reset-image"))
      }, {
        default: P(() => [
          fe(K(e.$t("builder.imageUploader.reset")), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 64))
  ]);
}
const Hb = /* @__PURE__ */ X(Rb, [["render", Ub], ["__scopeId", "data-v-a8e27e8f"]]), Vb = {}, Fb = {
  id: "info_icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};
function zb(e, t) {
  return y(), M("svg", Fb, t[0] || (t[0] = [
    w("circle", {
      class: "cls-1",
      cx: "7",
      cy: "7",
      r: "7"
    }, null, -1),
    w("path", {
      id: "i",
      class: "cls-2",
      d: "M1277.7,1701.09h1.86l0.99-5.1h-1.86Zm1.3-6.09h1.75l0.19-1.06h-1.86Z",
      transform: "translate(-1272 -1691)"
    }, null, -1)
  ]));
}
const Zi = /* @__PURE__ */ X(Vb, [["render", zb], ["__scopeId", "data-v-88c4d34d"]]), zS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Zi
}, Symbol.toStringTag, { value: "Module" })), Wb = {
  setup: (e) => ({
    v$: Ba({
      $registerAs: e.validationName
    })
  }),
  name: "ImageEditor",
  components: {
    InfoIcon: Zi,
    ImageCropper: Db,
    ImageEditorControls: Hb
  },
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    validationName: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    isSelected: Boolean
  },
  validations() {
    return {
      image: {
        content: {
          altText: {
            required: (e) => this.decorativeAllowed && this.image.properties.isDecorative || this.isBg ? !0 : (e == null ? void 0 : e.length) > 0
          }
        }
      }
    };
  },
  data() {
    return {
      isCropping: !1,
      originalImage: null,
      changedImageFile: !1
    };
  },
  mounted() {
    this.originalImage = ft(this.image);
  },
  computed: {
    image: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    showError() {
      return this.v$.$error;
    }
  },
  methods: {
    beginCrop() {
      this.isCropping = !0, this.$emit("begin-crop"), this.$refs.imageCropper.fn("crop");
    },
    async confirmCrop() {
      await this.storeCroppedData(), this.cancelCrop();
    },
    cancelCrop() {
      this.$refs.imageCropper.fn("clear"), this.$emit("end-crop"), this.isCropping = !1;
    },
    focalPointChanged(e) {
      this.changedImageFile = !0, e && (this.image.properties.focalPointPosition = e);
    },
    async storeCroppedData() {
      const { type: e = "image/jpeg", name: t = "croppedImage.jpeg" } = this.image.content.imageFile || {}, n = await new Promise(
        (a) => this.$refs.imageCropper.fn("getCroppedCanvas", { imageSmoothingEnabled: !1 }).toBlob(
          (r) => {
            a(r);
          },
          e,
          1
        )
      ), o = new File([n], t, { type: e });
      this.replaceCurrentImage(o);
    },
    replaceCurrentImage(e) {
      if (this.changedImageFile = !0, Ko(e)) {
        this.$emit("exceeds-upload-limit");
        return;
      }
      if (pi(e, this.acceptedFileTypes))
        return;
      this.applyNewNaturalSize();
      const t = URL.createObjectURL(e);
      this.$refs.imageCropper.fn("replace", t), URL.revokeObjectURL(this.image.previewUrl), this.image = new Ge({
        ...this.image,
        previewUrl: t,
        imageModified: !0,
        content: {
          ...this.image.content,
          imageFile: e
        },
        properties: {
          ...this.image.properties,
          focalPointPosition: { x: 50, y: 50 }
        }
      });
    },
    applyNewNaturalSize() {
      const e = this.$refs.imageCropper.fn("getCroppedCanvas").width, t = this.$refs.imageCropper.fn("getCroppedCanvas").height;
      this.image.properties.naturalWidth = e, this.image.properties.naturalHeight = t, this.image.properties.preferredWidth = e, this.image.properties.preferredHeight = t;
    },
    resetImage() {
      const { imageFile: e } = this.originalImage.content;
      this.focalPointChanged(this.originalImage.properties.focalPointPosition), this.replaceCurrentImage(e), this.changedImageFile = !1;
    },
    async rotate(e) {
      this.$emit("is-rotating", !0), this.$refs.imageCropper.fn("rotate", e), await this.storeCroppedData(), this.$emit("is-rotating", !1);
    },
    uploadNewImage(e) {
      const t = e.target.files[0];
      e.target.value = "", this.replaceCurrentImage(t);
    },
    setNaturalSize({ width: e, height: t }) {
      this.image.properties.naturalWidth = e, this.image.properties.naturalHeight = t, (this.image.properties.preferredWidth === null || this.image.properties.preferredHeight === null) && (this.image.properties.preferredWidth = e, this.image.properties.preferredHeight = t);
    }
  }
}, Gb = { key: 0 }, Yb = { class: "image-preview" }, Zb = { class: "text-inputs" }, Xb = {
  key: 0,
  class: "alt-text"
}, Kb = {
  key: 0,
  class: "decorative-input"
}, qb = {
  key: 1,
  class: "caption-text"
};
function Qb(e, t, n, o, a, r) {
  const i = L("ImageCropper"), s = L("ImageEditorControls"), l = L("a-form-input"), c = L("a-checkbox"), u = L("InfoIcon"), d = L("a-tooltip");
  return n.isSelected ? (y(), M("div", Gb, [
    w("div", Yb, [
      E(i, {
        ref: "imageCropper",
        image: r.image,
        "is-cropping": a.isCropping,
        "focal-point-allowed": n.focalPointAllowed,
        "is-selected": n.isSelected,
        onSetNaturalSize: r.setNaturalSize,
        onFocalPointChanged: r.focalPointChanged
      }, null, 8, ["image", "is-cropping", "focal-point-allowed", "is-selected", "onSetNaturalSize", "onFocalPointChanged"])
    ]),
    E(s, {
      "is-cropping": a.isCropping,
      "disable-reset-button": !a.changedImageFile,
      onBeginCrop: r.beginCrop,
      onCancelCrop: r.cancelCrop,
      onConfirmCrop: r.confirmCrop,
      onResetImage: r.resetImage,
      onReplaceImage: r.uploadNewImage,
      onRotate: r.rotate
    }, null, 8, ["is-cropping", "disable-reset-button", "onBeginCrop", "onCancelCrop", "onConfirmCrop", "onResetImage", "onReplaceImage", "onRotate"]),
    w("div", Zb, [
      n.isBg ? q("", !0) : (y(), M("div", Xb, [
        E(l, {
          id: "alt-text",
          modelValue: r.image.content.altText,
          "onUpdate:modelValue": t[0] || (t[0] = (p) => r.image.content.altText = p),
          disabled: r.image.properties.isDecorative,
          "show-error": r.showError,
          "error-message": e.$t("builder.imageUploader.altTextRequired"),
          label: e.$t("builder.imageUploader.altText"),
          placeholder: e.$t("builder.imageUploader.imageDescriptionPlaceholder"),
          required: ""
        }, null, 8, ["modelValue", "disabled", "show-error", "error-message", "label", "placeholder"]),
        n.decorativeAllowed ? (y(), M("div", Kb, [
          E(c, {
            checked: r.image.properties.isDecorative,
            "onUpdate:checked": t[1] || (t[1] = ({ checked: p }) => r.image.properties.isDecorative = p)
          }, {
            default: P(() => [
              fe(K(e.$t("builder.imageUploader.decorativeImage")), 1)
            ]),
            _: 1
          }, 8, ["checked"]),
          E(d, {
            label: e.$t("builder.imageUploader.decorativeImageTooltip"),
            position: "right",
            size: "small"
          }, {
            default: P(() => [
              E(u)
            ]),
            _: 1
          }, 8, ["label"])
        ])) : q("", !0)
      ])),
      n.captionsAllowed ? (y(), M("div", qb, [
        E(l, {
          id: "caption-text",
          modelValue: r.image.content.caption,
          "onUpdate:modelValue": t[2] || (t[2] = (p) => r.image.content.caption = p),
          label: e.$t("builder.imageUploader.caption"),
          placeholder: e.$t("builder.imageUploader.captionPlaceholder")
        }, null, 8, ["modelValue", "label", "placeholder"])
      ])) : q("", !0)
    ])
  ])) : q("", !0);
}
const Jb = /* @__PURE__ */ X(Wb, [["render", Qb], ["__scopeId", "data-v-a3b557c3"]]), e_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, t_ = ["fill"], Xi = {
  __name: "ImageIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", e_, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M957.988,1395.53c0,0.01-.005.02-0.007,0.04A1.5,1.5,0,0,1,956.5,1397H938.511a1.5,1.5,0,0,1-1.5-1.5v-14a1.5,1.5,0,0,1,1.5-1.5H956.5a1.5,1.5,0,0,1,1.5,1.5v14C958,1395.51,957.989,1395.52,957.988,1395.53Zm-19.977-.03a0.5,0.5,0,0,0,.5.5H956.5a0.5,0.5,0,0,0,.471-0.35l-4.549-5.46-3.619,2.71a0.494,0.494,0,0,1-.653-0.05l-3.662-5.67-6.472,5.55v2.77Zm18.984-14a0.5,0.5,0,0,0-.5-0.5H938.511a0.5,0.5,0,0,0-.5.5v9.91l6.173-5.29a0.5,0.5,0,0,1,.679.03l3.682,5.69,3.652-2.74a0.5,0.5,0,0,1,.684.08l4.114,4.94V1381.5Zm-6,4a1.5,1.5,0,1,1,1.5,1.5A1.5,1.5,0,0,1,951,1385.5Zm2,0a0.5,0.5,0,1,0-.5.5A0.5,0.5,0,0,0,953,1385.5Z",
        transform: "translate(-932.5 -1373.5)"
      }, null, 8, t_)
    ]));
  }
}, n_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xi
}, Symbol.toStringTag, { value: "Module" })), o_ = {
  name: "ImageThumbnails",
  components: {
    ImageIcon: Xi
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      required: !0
    },
    images: {
      type: Array,
      required: !0
    },
    currentImageIndex: {
      type: Number,
      default: 0
    },
    maxFilesAllowed: {
      type: Number,
      default: 1
    },
    maxImageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      BYTES_IN_MEGABYTE: 1e6
    };
  },
  methods: {
    newImageAdded(e) {
      var n, o, a, r;
      const t = ((n = e.dataTransfer) == null ? void 0 : n.files) || ((o = e.target) == null ? void 0 : o.files);
      if (t != null && t[0]) {
        if (t[0].size / this.BYTES_IN_MEGABYTE > this.maxImageSize) {
          this.$emit("exceeds-upload-limit");
          return;
        }
        ((a = e.dataTransfer) == null ? void 0 : a.files.length) === 0 || ((r = e.dataTransfer) == null ? void 0 : r.files.length) > this.maxFilesAllowed || (this.$emit("images-uploaded", t), this.$refs.newFileInput.value = "");
      }
    }
  }
}, r_ = { class: "all-images" }, a_ = ["accept"], i_ = ["src", "onClick"], s_ = { class: "add-new-image" };
function l_(e, t, n, o, a, r) {
  const i = L("ImageIcon"), s = L("a-button");
  return y(), M("div", r_, [
    w("input", {
      ref: "newFileInput",
      hidden: "",
      type: "file",
      accept: n.acceptedFileTypes,
      onChange: t[0] || (t[0] = (...l) => r.newImageAdded && r.newImageAdded(...l))
    }, null, 40, a_),
    (y(!0), M(ke, null, nt(n.images, (l, c) => (y(), M("div", {
      key: c,
      class: "image-thumbnail-container"
    }, [
      w("img", {
        src: l.previewUrl,
        class: me(["preview-image", {
          selected: n.currentImageIndex === c
        }]),
        onClick: (u) => e.$emit("select-image-index", c)
      }, null, 10, i_)
    ]))), 128)),
    n.images.length < n.maxFilesAllowed ? (y(), W(s, {
      key: 0,
      class: "new-image-button preview-image",
      variant: "none",
      onClick: t[1] || (t[1] = (l) => e.$refs.newFileInput.click())
    }, {
      default: P(() => [
        E(i),
        w("p", s_, K(e.$t("builder.imageUploader.addNewImage")), 1)
      ]),
      _: 1
    })) : q("", !0)
  ]);
}
const c_ = /* @__PURE__ */ X(o_, [["render", l_], ["__scopeId", "data-v-a0eaa06e"]]), d_ = {
  name: "ImageUploaderV3",
  components: {
    ImageEditor: Jb,
    ImageThumbnails: c_
  },
  props: {
    acceptedFileTypes: {
      type: Array,
      default: () => ["image/png", "image/jpg", "image/jpeg", "image/gif"]
    },
    images: {
      type: Array,
      required: !0
    },
    maxFiles: {
      type: Number,
      default: 1
    },
    initialImageIndex: {
      type: Number,
      default: 0
    },
    uploadApi: {
      type: String,
      required: !0
    },
    focalPointAllowed: {
      type: Boolean,
      default: !0
    },
    captionsAllowed: Boolean,
    decorativeAllowed: Boolean,
    isBg: Boolean,
    localUploader: Boolean,
    // TODO: Delete when implementing FAAS
    projectParent: {
      type: String,
      default: ""
    },
    isEditing: Boolean
  },
  setup: () => ({ v$: Zs() }),
  data() {
    return {
      currentImageIndex: 0,
      isCropping: !1,
      isRotating: !1,
      isUploading: !1,
      workingImages: []
    };
  },
  computed: {
    dialogHeader() {
      return this.isEditing ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  watch: {
    initialImageIndex(e) {
      this.selectImage(e);
    }
  },
  created() {
    this.workingImages = this.images.map((e) => {
      const t = ft(e);
      return {
        ...t,
        previewUrl: t.assetUrl || URL.createObjectURL(t.content.imageFile),
        imageModified: !1,
        isBg: this.isBg
      };
    }), this.selectImage(this.initialImageIndex);
  },
  methods: {
    addNewImageFile(e) {
      const t = e[0];
      if (this.fileHasValidationError(t))
        return;
      const n = URL.createObjectURL(t);
      this.workingImages.push(
        new Ge({
          imageModified: !1,
          previewUrl: n,
          content: {
            imageFile: t
          }
        })
      ), this.currentImageIndex = this.workingImages.length - 1;
    },
    async createCmsRequest(e) {
      const t = {
        create_px2560: !1,
        create_px1920: !1,
        create_px1600: !1,
        create_px1280: !1,
        create_px960: !1,
        create_px600: !1
      }, n = await Ff(e.content.imageFile);
      return gr.post(this.uploadApi, {
        asset: {
          file_base64: n,
          upload_options: t
        }
      });
    },
    createUploadRequests() {
      return this.workingImages.map((e) => {
        const t = new FormData();
        if (t.append("file", e.content.imageFile), e.content.assetId === "" || e.imageModified)
          switch (this.projectParent) {
            case "cms":
              return this.createCmsRequest(e);
            default:
              return gr.post(this.uploadApi, t, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
          }
        return Promise.resolve({
          data: { id: e.content.assetId },
          status: 201
        });
      });
    },
    fileHasValidationError(e) {
      const t = e.size / 1e6 > this.uploadLimit;
      return this.acceptedFileTypes.includes(e.type) ? t ? (console.error("File size exceeds limit"), !0) : !1 : (console.error("Unsupported File"), !0);
    },
    selectImage(e) {
      this.currentImageIndex = e >= 0 ? e : this.workingImages.length - 1;
    },
    async uploadImages() {
      if (this.v$.$touch(), this.v$.$error) {
        const n = [];
        this.workingImages.forEach((o, a) => {
          var r;
          (r = this.v$.$getResultsForChild(`image-${a}`)) != null && r.$error && n.push(a);
        }), this.currentImageIndex = n[0];
        return;
      }
      this.isUploading = !0;
      let e = null;
      if (!this.localUploader) {
        const n = this.createUploadRequests();
        if (e = await Promise.allSettled(n), e.some((o) => o.status === "rejected")) {
          this.isUploading = !1;
          return;
        }
      }
      const t = this.workingImages.map((n, o) => {
        var r, i;
        URL.revokeObjectURL(n.previewUrl);
        const a = this.localUploader ? URL.createObjectURL(this.workingImages[o].content.imageFile) : this.getImageAssetUrl(e[o]);
        return new Ge({
          ...n,
          assetUrl: a,
          content: {
            ...n.content,
            assetId: this.localUploader ? crypto.randomUUID() : (i = (r = e[o].value) == null ? void 0 : r.data) == null ? void 0 : i.id,
            assetUrl: a
          }
        });
      });
      this.$emit("images-changed", t), this.isUploading = !1;
    },
    // TODO: Delete when implementing FAAS
    getImageAssetUrl(e) {
      var t, n, o, a, r;
      if (this.projectParent === "engage")
        return ((n = (t = e.value) == null ? void 0 : t.data) == null ? void 0 : n.file) || "";
      if (this.projectParent === "cms")
        return ((r = (a = (o = e.value) == null ? void 0 : o.data) == null ? void 0 : a.file) == null ? void 0 : r.url) || "";
    }
  }
};
function u_(e, t, n, o, a, r) {
  const i = L("a-dialog-header"), s = L("ImageThumbnails"), l = L("ImageEditor"), c = L("a-dialog-content"), u = L("a-button"), d = L("a-dialog-footer"), p = L("a-dialog");
  return y(), W(p, {
    show: "",
    "no-close-on-overlay": "",
    size: "l",
    class: "image-editor",
    onClose: t[5] || (t[5] = (h) => e.$emit("close"))
  }, {
    default: P(() => [
      E(i, null, {
        default: P(() => [
          fe(K(r.dialogHeader), 1)
        ]),
        _: 1
      }),
      E(c, { class: "content" }, {
        default: P(() => [
          n.maxFiles > 1 ? (y(), W(s, {
            key: 0,
            "accepted-file-types": n.acceptedFileTypes,
            images: a.workingImages,
            "max-files-allowed": n.maxFiles,
            "current-image-index": a.currentImageIndex,
            onImagesUploaded: r.addNewImageFile,
            onSelectImageIndex: r.selectImage,
            onExceedsUploadLimit: t[0] || (t[0] = (h) => e.$emit("exceeds-upload-limit"))
          }, null, 8, ["accepted-file-types", "images", "max-files-allowed", "current-image-index", "onImagesUploaded", "onSelectImageIndex"])) : q("", !0),
          (y(!0), M(ke, null, nt(a.workingImages, (h, C) => (y(), M("div", { key: C }, [
            E(l, {
              modelValue: a.workingImages[C],
              "onUpdate:modelValue": (f) => a.workingImages[C] = f,
              "is-selected": C === a.currentImageIndex,
              "validation-name": `image-${C}`,
              "accepted-file-types": n.acceptedFileTypes,
              "captions-allowed": n.captionsAllowed,
              "decorative-allowed": n.decorativeAllowed,
              "is-bg": n.isBg,
              "focal-point-allowed": n.focalPointAllowed,
              onBeginCrop: t[1] || (t[1] = (f) => a.isCropping = !0),
              onEndCrop: t[2] || (t[2] = (f) => a.isCropping = !1),
              onIsRotating: t[3] || (t[3] = (f) => a.isRotating = f),
              onExceedsUploadLimit: t[4] || (t[4] = (f) => e.$emit("exceeds-upload-limit"))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "is-selected", "validation-name", "accepted-file-types", "captions-allowed", "decorative-allowed", "is-bg", "focal-point-allowed"])
          ]))), 128))
        ]),
        _: 1
      }),
      E(d, { class: "footer" }, {
        default: P(() => [
          E(u, {
            variant: "primary",
            disabled: a.isCropping || a.isRotating || a.isUploading,
            onClick: r.uploadImages
          }, {
            default: P(() => [
              fe(K(e.$t("builder.imageUploader.upload")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
const p_ = /* @__PURE__ */ X(d_, [["render", u_], ["__scopeId", "data-v-a134b2a1"]]), h_ = {
  name: "BackgroundImageControl",
  components: {
    ImageUploader: p_,
    NodeControl: ht
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    assets: {
      type: Object,
      required: !0,
      default: () => {
      }
    },
    uploadApi: {
      type: String,
      required: !0
    }
  },
  inject: ["state"],
  data() {
    return {
      options: [
        {
          label: this.$t("builder.backgroundImage.fill"),
          value: "fill"
        },
        {
          label: this.$t("builder.backgroundImage.tile"),
          value: "tile"
        },
        {
          label: this.$t("builder.backgroundImage.center"),
          value: "center"
        }
      ],
      acceptedFileTypes: "image/png, image/jpg, image/jpeg, image/gif",
      showImageUploader: !1,
      preloadedImage: null
    };
  },
  computed: {
    workingImage() {
      return [this.preloadedImage || this.image];
    },
    image: {
      get() {
        var e, t, n;
        return (n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundImage) == null ? void 0 : n.image;
      },
      set(e) {
        this.$emit("update", "image", e);
      }
    },
    backgroundPosition: {
      get() {
        var e, t;
        return ((t = (e = this.image) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundPosition) || "fill";
      },
      set(e) {
        this.image.properties.backgroundPosition = e;
      }
    },
    tilePercentage: {
      get() {
        var e, t;
        return ((t = (e = this.image) == null ? void 0 : e.properties) == null ? void 0 : t.tilePercentage) || 100;
      },
      set(e) {
        this.image.properties.tilePercentage = e;
      }
    },
    backgroundImage() {
      var e, t;
      return (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t.backgroundImage;
    },
    imagePreviewStyles() {
      var n, o, a, r, i, s, l, c, u, d, p, h;
      let e = {};
      switch ((o = (n = this.image) == null ? void 0 : n.properties) == null ? void 0 : o.backgroundPosition) {
        case "center":
          e = {
            "background-position": "center",
            "background-repeat": "no-repeat",
            "background-size": "contain"
          };
          break;
        case "fill":
          e = {
            "background-repeat": "no-repeat",
            "background-size": "cover",
            "background-position": `${((i = (r = (a = this.image) == null ? void 0 : a.properties) == null ? void 0 : r.focalPointPosition) == null ? void 0 : i.x) || 50}% ${((c = (l = (s = this.image) == null ? void 0 : s.properties) == null ? void 0 : l.focalPointPosition) == null ? void 0 : c.y) || 50}%`
          };
          break;
        case "tile":
          e = {
            "background-repeat": "repeat",
            "background-size": `${((d = (u = this.image) == null ? void 0 : u.properties) == null ? void 0 : d.tilePercentage) || 100}%`
          };
          break;
      }
      const t = (h = (p = this.image) == null ? void 0 : p.content) != null && h.assetId ? `url(${this.asset.url})` : `url("${E1}")`;
      return {
        ...e,
        backgroundImage: t
      };
    },
    asset() {
      var e, t;
      return this.assets[(t = (e = this.image) == null ? void 0 : e.content) == null ? void 0 : t.assetId] || "";
    },
    imageUploaderLabel() {
      var e, t;
      return (t = (e = this.image) == null ? void 0 : e.content) != null && t.assetId ? this.$t("builder.imageUploader.editImage") : this.$t("builder.imageUploader.uploadImage");
    }
  },
  methods: {
    toggleBackgroundImage(e) {
      this.image === null && (this.image = new Ge()), this.$emit("update", "toggle", e);
    },
    openImageUploader() {
      var e, t;
      (t = (e = this.image) == null ? void 0 : e.content) != null && t.assetId ? this.editImage() : this.$refs.fileInput.click();
    },
    openUploadModal() {
      this.$refs.fileInput && (this.$refs.fileInput.value = ""), this.showImageUploader = !0;
    },
    uploadFile(e) {
      var s, l, c, u;
      const t = ((s = e.dataTransfer) == null ? void 0 : s.files) || ((l = e.target) == null ? void 0 : l.files);
      if (!t || ((c = e.dataTransfer) == null ? void 0 : c.files.length) === 0 || ((u = e.dataTransfer) == null ? void 0 : u.files.length) > 1)
        return;
      const n = Array.from(t), o = n.every((d) => d.name.includes(".")), a = n.some((d) => d.type === ""), r = n.some(
        (d) => pi(d, this.acceptedFileTypes)
      );
      if (Ko(n[0])) {
        this.emitToastError();
        return;
      }
      if (!o || a || r)
        return;
      const i = Array.from(n).map(
        (d) => new Ge({
          content: {
            imageFile: d
          },
          properties: {
            isDecorative: !0
          }
        })
      );
      this.preloadedImage = i[0], this.openUploadModal();
    },
    updateImage(e) {
      const t = e[0];
      t.assetUrl && this.$emit("asset-entry", zf(t)), this.image = t, this.showImageUploader = !1, this.preloadedImage = null;
    },
    editImage() {
      this.showImageUploader = !0;
    },
    removeImage() {
      this.image = new Ge(), this.preloadedImage = null;
    },
    cancelChanges() {
      this.preloadedImage = null, this.showImageUploader = !1;
    },
    emitToastError() {
      this.state.emitToConsumingApp("toast-message", {
        message: `10 ${this.$t("builder.content.image.limitExceeded")}`,
        type: "error"
      });
    }
  }
}, f_ = { class: "inline-control gap-5" }, g_ = ["accept"], v_ = { class: "inline-control position-radio-group" };
function m_(e, t, n, o, a, r) {
  var h;
  const i = L("a-toggle"), s = L("a-button"), l = L("ImageUploader"), c = L("portal"), u = L("a-form-input"), d = L("a-form-radio-group"), p = L("NodeControl");
  return y(), W(p, null, Mo({
    title: P(() => [
      w("h4", null, K(e.$t("builder.backgroundImage.title")), 1)
    ]),
    control: P(() => [
      E(i, {
        "model-value": r.backgroundImage.toggle,
        "onUpdate:modelValue": t[0] || (t[0] = (C) => r.toggleBackgroundImage(C))
      }, null, 8, ["model-value"])
    ]),
    _: 2
  }, [
    (h = r.backgroundImage) != null && h.toggle ? {
      name: "content",
      fn: P(() => {
        var C;
        return [
          w("div", f_, [
            w("input", {
              ref: "fileInput",
              type: "file",
              hidden: "",
              accept: a.acceptedFileTypes,
              onChange: t[1] || (t[1] = (...f) => r.uploadFile && r.uploadFile(...f)),
              onClick: t[2] || (t[2] = (f) => f.target.value = null)
            }, null, 40, g_),
            w("div", {
              class: "image-thumbnail",
              style: Ie(r.imagePreviewStyles),
              onClick: t[3] || (t[3] = (...f) => r.openImageUploader && r.openImageUploader(...f))
            }, null, 4),
            E(s, {
              variant: "tertiary",
              onClick: r.openImageUploader
            }, {
              default: P(() => [
                fe(K(r.imageUploaderLabel), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            a.showImageUploader ? (y(), W(c, {
              key: 0,
              to: "root-dialog-container"
            }, {
              default: P(() => [
                E(l, {
                  "is-bg": "",
                  "max-files": 1,
                  images: r.workingImage,
                  "local-uploader": r.state.builder.api.localUploader,
                  "upload-api": n.uploadApi,
                  "project-parent": r.state.builder.api.projectParent,
                  onExceedsUploadLimit: r.emitToastError,
                  onImagesChanged: r.updateImage,
                  onClose: r.cancelChanges
                }, null, 8, ["images", "local-uploader", "upload-api", "project-parent", "onExceedsUploadLimit", "onImagesChanged", "onClose"])
              ]),
              _: 1
            })) : q("", !0),
            (C = r.image.content) != null && C.assetId ? (y(), W(s, {
              key: 1,
              class: "clear-button",
              variant: "link",
              onClick: r.removeImage
            }, {
              default: P(() => [
                fe(K(e.$t("builder.clear")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : q("", !0)
          ]),
          w("div", v_, [
            E(d, {
              label: e.$t("builder.backgroundImage.position"),
              options: a.options,
              modelValue: r.backgroundPosition,
              "onUpdate:modelValue": t[5] || (t[5] = (f) => r.backgroundPosition = f)
            }, {
              "content-tile": P(() => [
                w("div", null, [
                  E(u, {
                    modelValue: r.tilePercentage,
                    "onUpdate:modelValue": t[4] || (t[4] = (f) => r.tilePercentage = f),
                    class: "tile-input",
                    type: "number",
                    width: "70px",
                    height: "40px",
                    label: `${e.$t("builder.backgroundImage.tile")} (%)`,
                    min: 1,
                    max: 100
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _: 1
            }, 8, ["label", "options", "modelValue"])
          ])
        ];
      }),
      key: "0"
    } : void 0
  ]), 1024);
}
const Ki = /* @__PURE__ */ X(h_, [["render", m_], ["__scopeId", "data-v-93a03cce"]]), b_ = {}, __ = {
  id: "backButtonIcon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y_(e, t) {
  return y(), M("svg", __, t[0] || (t[0] = [
    w("path", {
      id: "background",
      d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
      fill: "none"
    }, null, -1),
    w("path", {
      id: "arrow",
      d: "M25 17C25.5523 17 26 16.5523 26 16C26 15.4477 25.5523 15 25 15L25 17ZM7.29289 15.2929C6.90237 15.6834 6.90237 16.3166 7.29289 16.7071L13.6569 23.0711C14.0474 23.4616 14.6805 23.4616 15.0711 23.0711C15.4616 22.6805 15.4616 22.0474 15.0711 21.6569L9.41421 16L15.0711 10.3431C15.4616 9.95262 15.4616 9.31946 15.0711 8.92893C14.6805 8.53841 14.0474 8.53841 13.6569 8.92893L7.29289 15.2929ZM25 15L8 15L8 17L25 17L25 15Z",
      fill: "var(--purple)"
    }, null, -1)
  ]));
}
const qi = /* @__PURE__ */ X(b_, [["render", y_]]), WS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qi
}, Symbol.toStringTag, { value: "Module" })), C_ = {
  name: "SidebarHeader",
  components: {
    BackIcon: qi
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  }
}, w_ = { class: "header" };
function $_(e, t, n, o, a, r) {
  const i = L("BackIcon");
  return y(), M("div", w_, [
    w("div", {
      class: "sidebar-back-button",
      onClick: t[0] || (t[0] = (s) => e.$emit("close-sidebar"))
    }, [
      E(i)
    ]),
    w("h4", null, K(n.title), 1)
  ]);
}
const ir = /* @__PURE__ */ X(C_, [["render", $_], ["__scopeId", "data-v-fcc5486e"]]), S_ = {
  name: "GlobalSettings",
  components: {
    BackgroundColorControl: ui,
    BackgroundImageControl: Ki,
    NodeControl: ht,
    SidebarHeader: ir
  },
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    }
  },
  inject: ["state"],
  computed: {
    globalCustomProperties() {
      var e, t;
      return ((t = (e = this.builder) == null ? void 0 : e.customProperties) == null ? void 0 : t.global) || {};
    },
    structure() {
      return this.builder.structure;
    }
  }
};
function N_(e, t, n, o, a, r) {
  const i = L("SidebarHeader"), s = L("a-toggle"), l = L("NodeControl"), c = L("BackgroundColorControl"), u = L("BackgroundImageControl");
  return y(), M(ke, null, [
    E(i, {
      title: e.$t("builder.builderTabs.globalSettings"),
      onCloseSidebar: t[0] || (t[0] = (d) => e.$emit("close-sidebar"))
    }, null, 8, ["title"]),
    r.globalCustomProperties.headerSlotOptional ? (y(), W(l, { key: 0 }, {
      title: P(() => [
        w("h4", null, K(e.$t("builder.header")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showHeaderSlot,
          "onUpdate:modelValue": t[1] || (t[1] = (d) => r.globalCustomProperties.showHeaderSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    r.globalCustomProperties.footerSlotOptional ? (y(), W(l, { key: 1 }, {
      title: P(() => [
        w("h4", null, K(e.$t("builder.footer")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showFooterSlot,
          "onUpdate:modelValue": t[2] || (t[2] = (d) => r.globalCustomProperties.showFooterSlot = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    r.globalCustomProperties.backgroundColorAllowed ? (y(), W(c, {
      key: 2,
      node: r.structure,
      onUpdate: t[3] || (t[3] = (d, p) => r.structure.properties.backgroundColor[d] = p)
    }, null, 8, ["node"])) : q("", !0),
    r.globalCustomProperties.backgroundImageAllowed ? (y(), W(u, {
      key: 3,
      node: r.structure,
      assets: r.state.builder.assets,
      "upload-api": r.state.builder.api.images,
      onUpdate: t[4] || (t[4] = (d, p) => r.structure.properties.backgroundImage[d] = p),
      onAssetEntry: t[5] || (t[5] = (d) => r.state.addAsset(d))
    }, null, 8, ["node", "assets", "upload-api"])) : q("", !0),
    r.globalCustomProperties.confirmOnDeleteDialogAllowed ? (y(), W(l, { key: 4 }, {
      title: P(() => [
        w("h4", null, K(e.$t("builder.controls.global.showConfirmationDialog")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.showConfirmOnDeleteDialog,
          "onUpdate:modelValue": t[6] || (t[6] = (d) => r.globalCustomProperties.showConfirmOnDeleteDialog = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })) : q("", !0),
    E(l, null, {
      title: P(() => [
        w("h4", null, K(e.$t("builder.controls.global.focusNewNodeOnCreate")), 1)
      ]),
      control: P(() => [
        E(s, {
          modelValue: r.globalCustomProperties.focusNewNodeOnCreate,
          "onUpdate:modelValue": t[7] || (t[7] = (d) => r.globalCustomProperties.focusNewNodeOnCreate = d)
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64);
}
const A_ = /* @__PURE__ */ X(S_, [["render", N_], ["__scopeId", "data-v-c08ba7c5"]]), T_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, O_ = ["fill"], I_ = ["fill"], E_ = ["fill"], x_ = ["fill"], k_ = ["fill"], D_ = ["fill"], M_ = {
  __name: "AccordionIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", T_, [
      w("rect", {
        x: "5",
        y: "9",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, O_),
      w("rect", {
        x: "5",
        y: "21",
        width: "17",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, I_),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M21 13H6L6 18H21V13ZM6 12C5.44772 12 5 12.4477 5 13V18C5 18.5523 5.44772 19 6 19H21C21.5523 19 22 18.5523 22 18V13C22 12.4477 21.5523 12 21 12H6Z",
        fill: n.value
      }, null, 8, E_),
      w("rect", {
        x: "24",
        y: "15",
        width: "3",
        height: "1",
        rx: "0.5",
        fill: n.value
      }, null, 8, x_),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 9C26.1791 9 26 8.82091 26 8.6V8.4C26 8.17909 25.8209 8 25.6 8H25.4C25.1791 8 25 8.17909 25 8.4V8.6C25 8.82091 24.8209 9 24.6 9H24.4C24.1791 9 24 9.17909 24 9.4V9.6C24 9.82091 24.1791 10 24.4 10H24.6C24.8209 10 25 10.1791 25 10.4V10.6C25 10.8209 25.1791 11 25.4 11H25.6C25.8209 11 26 10.8209 26 10.6V10.4C26 10.1791 26.1791 10 26.4 10H26.6C26.8209 10 27 9.82091 27 9.6V9.4C27 9.17909 26.8209 9 26.6 9H26.4Z",
        fill: n.value
      }, null, 8, k_),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M26.4 21C26.1791 21 26 20.8209 26 20.6V20.4C26 20.1791 25.8209 20 25.6 20H25.4C25.1791 20 25 20.1791 25 20.4V20.6C25 20.8209 24.8209 21 24.6 21H24.4C24.1791 21 24 21.1791 24 21.4V21.6C24 21.8209 24.1791 22 24.4 22H24.6C24.8209 22 25 22.1791 25 22.4V22.6C25 22.8209 25.1791 23 25.4 23H25.6C25.8209 23 26 22.8209 26 22.6V22.4C26 22.1791 26.1791 22 26.4 22H26.6C26.8209 22 27 21.8209 27 21.6V21.4C27 21.1791 26.8209 21 26.6 21H26.4Z",
        fill: n.value
      }, null, 8, D_)
    ]));
  }
}, P_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: M_
}, Symbol.toStringTag, { value: "Module" })), L_ = {
  width: "30",
  height: "30",
  viewBox: "0 0 33 10",
  fill: "none"
}, R_ = ["stroke"], B_ = {
  __name: "ButtonIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", L_, [
      w("rect", {
        x: "0.5",
        y: "0.5",
        width: "32",
        height: "9",
        fill: "transparent",
        stroke: n.value
      }, null, 8, R_)
    ]));
  }
}, j_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: B_
}, Symbol.toStringTag, { value: "Module" })), U_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, H_ = ["stroke"], V_ = {
  __name: "CardIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", U_, [
      w("path", {
        id: "card",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        "fill-rule": "evenodd",
        d: "M938,1887h20a2,2,0,0,1,2,2v11a2,2,0,0,1-2,2H938a2,2,0,0,1-2-2v-11A2,2,0,0,1,938,1887Z",
        transform: "translate(-933 -1879.5)"
      }, null, 8, H_)
    ]));
  }
}, F_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: V_
}, Symbol.toStringTag, { value: "Module" })), z_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, W_ = ["fill"], G_ = {
  __name: "EmbedIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", z_, [
      w("path", {
        id: "embed",
        class: "cls-1",
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M934,1538.82l9.986-5.82v1.34l-9.155,5.17v0.04l9.155,6.13v1.33L934,1540.2v-1.38Zm25,0-9.986-5.82v1.34l9.155,5.17v0.04l-9.155,6.13v1.33L959,1540.2v-1.38Z",
        transform: "translate(-931.5 -1525)"
      }, null, 8, W_)
    ]));
  }
}, Y_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G_
}, Symbol.toStringTag, { value: "Module" })), Z_ = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}, X_ = ["fill"], K_ = ["fill"], q_ = ["fill"], Q_ = ["fill"], J_ = ["fill"], ey = ["fill"], ty = {
  __name: "FormIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", Z_, [
      w("path", {
        d: "M10 7.5C10 6.67157 10.6716 6 11.5 6H22.5C23.3284 6 24 6.67157 24 7.5V21.5C24 22.3284 23.3284 23 22.5 23H22V22H22.5C22.7761 22 23 21.7762 23 21.5V7.5C23 7.22385 22.7761 7 22.5 7H11.5C11.2239 7 11 7.22385 11 7.5V8H10V7.5Z",
        fill: n.value
      }, null, 8, X_),
      w("path", {
        d: "M10 12H18V13H10V12Z",
        fill: n.value
      }, null, 8, K_),
      w("path", {
        d: "M10 15H18V16H10V15Z",
        fill: n.value
      }, null, 8, q_),
      w("path", {
        d: "M18 18H10V19H18V18Z",
        fill: n.value
      }, null, 8, Q_),
      w("path", {
        d: "M10 21H18V22H10V21Z",
        fill: n.value
      }, null, 8, J_),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7 10.5C7 9.67157 7.67157 9 8.5 9H19.5C20.3284 9 21 9.67157 21 10.5V24.5C21 25.3284 20.3284 26 19.5 26H8.5C7.67157 26 7 25.3284 7 24.5V10.5ZM8.5 10C8.22385 10 8 10.2238 8 10.5V24.5C8 24.7762 8.22385 25 8.5 25H19.5C19.7761 25 20 24.7762 20 24.5V10.5C20 10.2238 19.7761 10 19.5 10H8.5Z",
        fill: n.value
      }, null, 8, ey)
    ]));
  }
}, ny = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ty
}, Symbol.toStringTag, { value: "Module" })), oy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "51",
  height: "17",
  viewBox: "0 0 51 17"
}, ry = ["stroke"], ay = ["stroke"], iy = ["stroke"], sy = ["stroke"], ly = {
  __name: "FourColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", oy, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ry),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "13.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, ay),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "26.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, iy),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "39.5",
        y: "0.5",
        width: "11",
        height: "16"
      }, null, 8, sy)
    ]));
  }
}, cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ly
}, Symbol.toStringTag, { value: "Module" })), dy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "17",
  viewBox: "0 0 56 17"
}, uy = ["stroke"], py = {
  __name: "FullWidthIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", dy, [
      w("rect", {
        id: "full-width",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "55",
        height: "16"
      }, null, 8, uy)
    ]));
  }
}, hy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: py
}, Symbol.toStringTag, { value: "Module" })), fy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, gy = ["fill"], vy = {
  __name: "GalleryIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", fy, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1052.53,1392a0.5,0.5,0,0,1-.5-0.5v-9.27a0.24,0.24,0,0,0-.23-0.23h-16.53a0.233,0.233,0,0,0-.23.23v0.27a0.5,0.5,0,0,1-.5.5,0.5,0.5,0,0,1-.5-0.5v-0.27a1.229,1.229,0,0,1,1.23-1.23h16.53a1.236,1.236,0,0,1,1.23,1.23v9.27A0.5,0.5,0,0,1,1052.53,1392Zm-1.5-7.74v12.48a1.249,1.249,0,0,1-1.23,1.26h-17.53a1.249,1.249,0,0,1-1.23-1.26v-3.38h0v-9.1a1.249,1.249,0,0,1,1.23-1.26h17.53A1.249,1.249,0,0,1,1051.03,1384.26Zm-18.99,12.48a0.254,0.254,0,0,0,.23.26h17.53a0.254,0.254,0,0,0,.23-0.26v-0.38a0.449,0.449,0,0,1-.13-0.1l-4.39-5.03-2.62,2.62a0.5,0.5,0,0,1-.38.15,0.5,0.5,0,0,1-.36-0.18l-4.65-5.58-5.46,5.34v3.16Zm0-12.48v7.92l5.15-5.04a0.468,0.468,0,0,1,.37-0.14,0.5,0.5,0,0,1,.36.18l4.65,5.58,2.61-2.61a0.463,0.463,0,0,1,.37-0.15,0.494,0.494,0,0,1,.36.17l4.12,4.72v-10.63a0.254,0.254,0,0,0-.23-0.26h-17.53A0.254,0.254,0,0,0,1032.04,1384.26Zm13.43,4.74a1.5,1.5,0,1,1,1.49-1.5A1.5,1.5,0,0,1,1045.47,1389Zm0-2a0.5,0.5,0,0,0-.5.5A0.5,0.5,0,1,0,1045.47,1387Z",
        transform: "translate(-1027.03 -1374.5)"
      }, null, 8, gy)
    ]));
  }
}, my = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vy
}, Symbol.toStringTag, { value: "Module" })), by = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, _y = ["fill"], yy = {
  __name: "HeadingIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", by, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M954,1322v-9h-2v-1a2.636,2.636,0,0,0,.546.18,2.124,2.124,0,0,0,.726-0.3,1.913,1.913,0,0,0,.529-0.57,4.728,4.728,0,0,0,.427-1.32H955v11.99Zm-6-6h-7v6l-1-.01v-11.98l1-.01v5h7v-5l0.923,0.01v11.98L948,1322v-6Z",
        transform: "translate(-932.5 -1301)"
      }, null, 8, _y)
    ]));
  }
}, Cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: yy
}, Symbol.toStringTag, { value: "Module" })), wy = {
  id: "left_sidebar",
  "data-name": "left sidebar",
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, $y = ["stroke"], Sy = ["stroke"], Ny = {
  __name: "LeftSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", wy, [
      w("rect", {
        id: "Rectangle_2133_copy_21",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, $y),
      w("rect", {
        id: "Rectangle_2133_copy_21-2",
        "data-name": "Rectangle 2133 copy 21",
        class: "cls-1",
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, Sy)
    ]));
  }
}, Ay = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ny
}, Symbol.toStringTag, { value: "Module" })), Ty = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Oy = ["fill"], Iy = ["fill"], Ey = ["fill"], xy = ["fill"], ky = ["fill"], Dy = ["fill"], My = ["fill"], Py = ["fill"], Ly = ["fill"], Ry = {
  __name: "NavigationIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", Ty, [
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M19 1H5C4.44771 1 4 1.44772 4 2V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V2C20 1.44772 19.5523 1 19 1ZM5 0C3.89543 0 3 0.89543 3 2V22C3 23.1046 3.89543 24 5 24H19C20.1046 24 21 23.1046 21 22V2C21 0.895431 20.1046 0 19 0H5Z",
        fill: n.value
      }, null, 8, Oy),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 4.5C8 4.22386 8.22386 4 8.5 4H16.5C16.7761 4 17 4.22386 17 4.5C17 4.77614 16.7761 5 16.5 5H8.5C8.22386 5 8 4.77614 8 4.5Z",
        fill: n.value
      }, null, 8, Iy),
      w("path", {
        d: "M7 4.5C7 4.77614 6.77614 5 6.5 5C6.22386 5 6 4.77614 6 4.5C6 4.22386 6.22386 4 6.5 4C6.77614 4 7 4.22386 7 4.5Z",
        fill: n.value
      }, null, 8, Ey),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 7.5C8 7.22386 8.22386 7 8.5 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H8.5C8.22386 8 8 7.77614 8 7.5Z",
        fill: n.value
      }, null, 8, xy),
      w("path", {
        d: "M7 7.5C7 7.77614 6.77614 8 6.5 8C6.22386 8 6 7.77614 6 7.5C6 7.22386 6.22386 7 6.5 7C6.77614 7 7 7.22386 7 7.5Z",
        fill: n.value
      }, null, 8, ky),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 10.5C8 10.2239 8.22386 10 8.5 10H16.5C16.7761 10 17 10.2239 17 10.5C17 10.7761 16.7761 11 16.5 11H8.5C8.22386 11 8 10.7761 8 10.5Z",
        fill: n.value
      }, null, 8, Dy),
      w("path", {
        d: "M7 10.5C7 10.7761 6.77614 11 6.5 11C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10C6.77614 10 7 10.2239 7 10.5Z",
        fill: n.value
      }, null, 8, My),
      w("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8 13.5C8 13.2239 8.22386 13 8.5 13H16.5C16.7761 13 17 13.2239 17 13.5C17 13.7761 16.7761 14 16.5 14H8.5C8.22386 14 8 13.7761 8 13.5Z",
        fill: n.value
      }, null, 8, Py),
      w("path", {
        d: "M7 13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5C6 13.2239 6.22386 13 6.5 13C6.77614 13 7 13.2239 7 13.5Z",
        fill: n.value
      }, null, 8, Ly)
    ]));
  }
}, By = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ry
}, Symbol.toStringTag, { value: "Module" })), jy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "17",
  viewBox: "0 0 39 17"
}, Uy = ["stroke"], Hy = {
  __name: "OneColumnIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", jy, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "38",
        height: "16"
      }, null, 8, Uy)
    ]));
  }
}, Vy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hy
}, Symbol.toStringTag, { value: "Module" })), Fy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, zy = ["stroke"], Wy = {
  __name: "QuoteIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", Fy, [
      w("path", {
        fill: "none",
        stroke: n.value,
        "fill-rule": "evenodd",
        d: "M1042.18,1981s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1051.97,1977.66,1042.18,1981,1042.18,1981Zm-13,0s5.76-7.92.4-9.76a5.466,5.466,0,1,1,9.42-3.76C1038.97,1977.66,1029.18,1981,1029.18,1981Z",
        transform: "translate(-1025.045 -1956.5)"
      }, null, 8, zy)
    ]));
  }
}, Gy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wy
}, Symbol.toStringTag, { value: "Module" })), Yy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, Zy = ["stroke"], Xy = ["stroke"], Ky = {
  __name: "RightSidebarIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", Yy, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, Zy),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "30",
        height: "16"
      }, null, 8, Xy)
    ]));
  }
}, qy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ky
}, Symbol.toStringTag, { value: "Module" })), Qy = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, Jy = ["fill"], e2 = {
  __name: "SeparatorIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", Qy, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1031,1680v-1h26v1h-26Z",
        transform: "translate(-1029 -1664.5)"
      }, null, 8, Jy)
    ]));
  }
}, t2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e2
}, Symbol.toStringTag, { value: "Module" })), n2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, o2 = ["fill"], r2 = {
  __name: "SliderIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", n2, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M959.5,1472a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,959.5,1472Zm-3,1a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,956.5,1473Zm-3,0h-12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,.5-0.5h12a0.5,0.5,0,0,1,.5.5v12A0.5,0.5,0,0,1,953.5,1473Zm-0.5-12H942v11h11v-11Zm-14.5,12a0.5,0.5,0,0,1-.5-0.5v-12a0.5,0.5,0,0,1,1,0v12A0.5,0.5,0,0,1,938.5,1473Zm-3-1a0.5,0.5,0,0,1-.5-0.5v-10a0.5,0.5,0,0,1,1,0v10A0.5,0.5,0,0,1,935.5,1472Z",
        transform: "translate(-932.5 -1451.5)"
      }, null, 8, o2)
    ]));
  }
}, a2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r2
}, Symbol.toStringTag, { value: "Module" })), i2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, s2 = ["stroke"], l2 = {
  __name: "SpacerIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", i2, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "2",
        y: "7.5",
        width: "26",
        height: "15"
      }, null, 8, s2)
    ]));
  }
}, c2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: l2
}, Symbol.toStringTag, { value: "Module" })), d2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, u2 = ["fill"], p2 = {
  __name: "TableIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", d2, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M957,1979H933v-15h25v15h-1Zm-21-14h-2v6h2v-6Zm0,7h-2v6h2v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Zm7-7h-6v6h6v-6Zm0,7h-6v6h6v-6Z",
        transform: "translate(-930.5 -1956.5)"
      }, null, 8, u2)
    ]));
  }
}, h2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: p2
}, Symbol.toStringTag, { value: "Module" })), f2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, g2 = ["fill"], v2 = {
  __name: "TextIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", f2, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1052.13,1313.42a2.093,2.093,0,0,0-1.41-.45,2.323,2.323,0,0,0-1.08.24,2.229,2.229,0,0,0-.78.65,2.777,2.777,0,0,0-.47.96,4.427,4.427,0,0,0-.16,1.18,4.485,4.485,0,0,0,.16,1.18,2.728,2.728,0,0,0,.47.95,2.279,2.279,0,0,0,1.86.88,2.1,2.1,0,0,0,1.48-.5,2.029,2.029,0,0,0,.62-1.39h1.19a3.024,3.024,0,0,1-.98,2.14,3.415,3.415,0,0,1-2.31.75,3.7,3.7,0,0,1-1.55-.32,3.487,3.487,0,0,1-1.17-.86,3.773,3.773,0,0,1-.74-1.28,4.388,4.388,0,0,1-.26-1.55,4.483,4.483,0,0,1,.26-1.56,3.825,3.825,0,0,1,.74-1.27,3.357,3.357,0,0,1,1.17-.86,3.554,3.554,0,0,1,1.55-.32,3.406,3.406,0,0,1,2.23.71,3.113,3.113,0,0,1,1.06,1.94h-1.22A1.957,1.957,0,0,0,1052.13,1313.42Zm-8.02,5.48a3,3,0,0,1-1.05.82,3.338,3.338,0,0,1-1.4.29,3.1,3.1,0,0,1-1.37-.29,2.933,2.933,0,0,1-1.06-.95h-0.03v1.03H1038v-10.81h1.2v4.08h0.03a3.43,3.43,0,0,1,1.03-.95,2.856,2.856,0,0,1,1.45-.35,3.079,3.079,0,0,1,1.33.28,3,3,0,0,1,1.04.8,3.889,3.889,0,0,1,.67,1.3,5.809,5.809,0,0,1,.24,1.74,5.975,5.975,0,0,1-.23,1.7A3.921,3.921,0,0,1,1044.11,1318.9Zm-0.5-4.22a2.971,2.971,0,0,0-.4-0.98,1.891,1.891,0,0,0-.67-0.65,1.812,1.812,0,0,0-.95-0.24,2.289,2.289,0,0,0-1.1.25,2.027,2.027,0,0,0-.76.66,3.1,3.1,0,0,0-.45.99,4.564,4.564,0,0,0-.15,1.19,4.71,4.71,0,0,0,.15,1.23,2.8,2.8,0,0,0,.45.97,2.306,2.306,0,0,0,.77.65,2.439,2.439,0,0,0,1.07.23,1.948,1.948,0,0,0,.96-0.23,2.013,2.013,0,0,0,.68-0.65,2.75,2.75,0,0,0,.4-0.97,5.2,5.2,0,0,0,.14-1.23A5.3,5.3,0,0,0,1043.61,1314.68Zm-8.26,5.12a1.19,1.19,0,0,1-1.29-1.13h-0.02a3.19,3.19,0,0,1-.4.43,2.659,2.659,0,0,1-.54.39,5.528,5.528,0,0,1-.69.35,2.128,2.128,0,0,1-.86.17,3.557,3.557,0,0,1-1-.13,2.2,2.2,0,0,1-.81-0.4,1.781,1.781,0,0,1-.54-0.67,2.193,2.193,0,0,1-.19-0.96,2.3,2.3,0,0,1,.24-1.12,2.01,2.01,0,0,1,.69-0.7,3.312,3.312,0,0,1,1.03-.41c0.41-.1.84-0.18,1.3-0.27,0.27-.03.51-0.08,0.73-0.12a3.2,3.2,0,0,0,.57-0.18,0.941,0.941,0,0,0,.37-0.3,0.845,0.845,0,0,0,.13-0.5,1.213,1.213,0,0,0-.43-1.01,1.919,1.919,0,0,0-1.25-.35,2.048,2.048,0,0,0-1.38.4,1.689,1.689,0,0,0-.49,1.27h-1.13a2.687,2.687,0,0,1,.2-1.02,2.108,2.108,0,0,1,.56-0.82,2.609,2.609,0,0,1,.93-0.53,3.9,3.9,0,0,1,1.3-.2,4.817,4.817,0,0,1,1.1.12,2.464,2.464,0,0,1,.88.41,1.882,1.882,0,0,1,.58.74,2.763,2.763,0,0,1,.21,1.14v3.61a1.172,1.172,0,0,0,.16.69,0.373,0.373,0,0,0,.35.16,1.112,1.112,0,0,0,.29-0.04h0.04v0.86c-0.08.03-.16,0.06-0.26,0.09A1.943,1.943,0,0,1,1035.35,1319.8Zm-1.26-4.04a3.667,3.667,0,0,1-.76.33,8.639,8.639,0,0,1-.95.22c-0.29.06-.57,0.12-0.83,0.18a2.471,2.471,0,0,0-.68.26,1.327,1.327,0,0,0-.45.43,1.292,1.292,0,0,0-.16.68,1.309,1.309,0,0,0,.13.63,1.065,1.065,0,0,0,.36.37,1.308,1.308,0,0,0,.49.18,2.76,2.76,0,0,0,.57.06,2.474,2.474,0,0,0,1.02-.2,2.373,2.373,0,0,0,.71-0.5,1.934,1.934,0,0,0,.41-0.65,1.983,1.983,0,0,0,.14-0.7v-1.29Z",
        transform: "translate(-1026.5 -1299.5)"
      }, null, 8, g2)
    ]));
  }
}, m2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v2
}, Symbol.toStringTag, { value: "Module" })), b2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "47",
  height: "17",
  viewBox: "0 0 47 17"
}, _2 = ["stroke"], y2 = ["stroke"], C2 = ["stroke"], w2 = {
  __name: "ThreeColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", b2, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, _2),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "32.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, y2),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "16.5",
        y: "0.5",
        width: "14",
        height: "16"
      }, null, 8, C2)
    ]));
  }
}, $2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: w2
}, Symbol.toStringTag, { value: "Module" })), S2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "17",
  viewBox: "0 0 43 17"
}, N2 = ["stroke"], A2 = ["stroke"], T2 = {
  __name: "TwoColumnsIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-layout)"
    );
    return (o, a) => (y(), M("svg", S2, [
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "0.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, N2),
      w("rect", {
        fill: "transparent",
        stroke: n.value,
        "stroke-width": "1px",
        x: "22.5",
        y: "0.5",
        width: "20",
        height: "16"
      }, null, 8, A2)
    ]));
  }
}, O2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: T2
}, Symbol.toStringTag, { value: "Module" })), I2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, E2 = ["fill"], x2 = {
  __name: "VideoIcon",
  props: {
    isHovering: Boolean
  },
  setup(e) {
    const t = e, n = _(
      () => t.isHovering ? "var(--primary-white)" : "var(--color-content)"
    );
    return (o, a) => (y(), M("svg", I2, [
      w("path", {
        fill: n.value,
        "fill-rule": "evenodd",
        d: "M1049.98,1474.5a1.5,1.5,0,0,1-1.49,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h8a0.142,0.142,0,0,1,.06.02,0.2,0.2,0,0,1,.07.01,0.477,0.477,0,0,1,.22.12l5,6a0.464,0.464,0,0,1,.12.23,0.127,0.127,0,0,1,.01.06c0,0.02.01,0.04,0.01,0.06v12Zm-13.99-17v17a0.508,0.508,0,0,0,.5.5h12a0.508,0.508,0,0,0,.5-0.5V1463h-4.5a0.5,0.5,0,0,1-.5-0.5V1457h-7.5A0.508,0.508,0,0,0,1035.99,1457.5Zm9,0.21V1462h3.29Zm0.72,10.24a0.532,0.532,0,0,1,.28.45,0.522,0.522,0,0,1-.27.45l-6,3.09a0.465,0.465,0,0,1-.23.06,0.484,0.484,0,0,1-.26-0.07,0.507,0.507,0,0,1-.24-0.43v-6a0.5,0.5,0,0,1,.23-0.42,0.531,0.531,0,0,1,.49-0.03Zm-5.72,2.73,4.38-2.26-4.38-2.12v4.38Z",
        transform: "translate(-1027.5 -1451)"
      }, null, 8, E2)
    ]));
  }
}, k2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: x2
}, Symbol.toStringTag, { value: "Module" }));
function Zn(e) {
  return Da() ? (Ma(e), !0) : !1;
}
const Qi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const D2 = (e) => e != null, M2 = Object.prototype.toString, P2 = (e) => M2.call(e) === "[object Object]", Ot = () => {
}, Io = /* @__PURE__ */ L2();
function L2() {
  var e, t;
  return Qi && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Eo(e) {
  return Array.isArray(e) ? e : [e];
}
function R2(...e) {
  if (e.length !== 1)
    return Pa(...e);
  const t = e[0];
  return typeof t == "function" ? kn(Hs(() => ({ get: t, set: Ot }))) : H(t);
}
const Rt = Qi ? window : void 0;
function tt(e) {
  var t;
  const n = Le(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function pt(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = Rt) : [t, n, o, a] = e, !t)
    return Ot;
  n = Eo(n), o = Eo(o);
  const r = [], i = () => {
    r.forEach((u) => u()), r.length = 0;
  }, s = (u, d, p, h) => (u.addEventListener(d, p, h), () => u.removeEventListener(d, p, h)), l = le(
    () => [tt(t), Le(a)],
    ([u, d]) => {
      if (i(), !u)
        return;
      const p = P2(d) ? { ...d } : d;
      r.push(
        ...n.flatMap((h) => o.map((C) => s(u, h, C, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), i();
  };
  return Zn(c), c;
}
let va = !1;
function ma(e, t, n = {}) {
  const { window: o = Rt, ignore: a = [], capture: r = !0, detectIframe: i = !1 } = n;
  if (!o)
    return Ot;
  Io && !va && (va = !0, Array.from(o.document.body.children).forEach((f) => f.addEventListener("click", Ot)), o.document.documentElement.addEventListener("click", Ot));
  let s = !0;
  const l = (f) => Le(a).some((v) => {
    if (typeof v == "string")
      return Array.from(o.document.querySelectorAll(v)).some((S) => S === f.target || f.composedPath().includes(S));
    {
      const S = tt(v);
      return S && (f.target === S || f.composedPath().includes(S));
    }
  });
  function c(f) {
    const v = Le(f);
    return v && v.$.subTree.shapeFlag === 16;
  }
  function u(f, v) {
    const S = Le(f), T = S.$.subTree && S.$.subTree.children;
    return T == null || !Array.isArray(T) ? !1 : T.some((m) => m.el === v.target || v.composedPath().includes(m.el));
  }
  const d = (f) => {
    const v = tt(e);
    if (f.target != null && !(!(v instanceof Element) && c(e) && u(e, f)) && !(!v || v === f.target || f.composedPath().includes(v))) {
      if (f.detail === 0 && (s = !l(f)), !s) {
        s = !0;
        return;
      }
      t(f);
    }
  };
  let p = !1;
  const h = [
    pt(o, "click", (f) => {
      p || (p = !0, setTimeout(() => {
        p = !1;
      }, 0), d(f));
    }, { passive: !0, capture: r }),
    pt(o, "pointerdown", (f) => {
      const v = tt(e);
      s = !l(f) && !!(v && !f.composedPath().includes(v));
    }, { passive: !0 }),
    i && pt(o, "blur", (f) => {
      setTimeout(() => {
        var v;
        const S = tt(e);
        ((v = o.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(S != null && S.contains(o.document.activeElement)) && t(f);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean);
  return () => h.forEach((f) => f());
}
const GS = {
  mounted(e, t) {
    const n = !t.modifiers.bubble;
    if (typeof t.value == "function")
      e.__onClickOutside_stop = ma(e, t.value, { capture: n });
    else {
      const [o, a] = t.value;
      e.__onClickOutside_stop = ma(e, o, Object.assign({ capture: n }, a));
    }
  },
  unmounted(e) {
    e.__onClickOutside_stop();
  }
};
function B2(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function ba(...e) {
  let t, n, o = {};
  e.length === 3 ? (t = e[0], n = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], o = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const {
    target: a = Rt,
    eventName: r = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = o, l = B2(t);
  return pt(a, r, (u) => {
    u.repeat && Le(s) || l(u) && n(u);
  }, i);
}
const YS = {
  mounted(e, t) {
    var n, o;
    const a = (o = (n = t.arg) == null ? void 0 : n.split(",")) != null ? o : !0;
    if (typeof t.value == "function")
      ba(a, t.value, {
        target: e
      });
    else {
      const [r, i] = t.value;
      ba(a, r, {
        target: e,
        ...i
      });
    }
  }
};
function j2() {
  const e = H(!1), t = Po();
  return t && Ue(() => {
    e.value = !0;
  }, t), e;
}
function U2(e) {
  const t = j2();
  return _(() => (t.value, !!e()));
}
function H2(e, t, n = {}) {
  const { window: o = Rt, ...a } = n;
  let r;
  const i = U2(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = _(() => {
    const p = Le(e), h = Eo(p).map(tt).filter(D2);
    return new Set(h);
  }), c = le(
    () => l.value,
    (p) => {
      s(), i.value && p.size && (r = new MutationObserver(t), p.forEach((h) => r.observe(h, a)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => r == null ? void 0 : r.takeRecords(), d = () => {
    c(), s();
  };
  return Zn(d), {
    isSupported: i,
    stop: d,
    takeRecords: u
  };
}
function V2(e, t, n = {}) {
  const {
    window: o = Rt,
    document: a = o == null ? void 0 : o.document,
    flush: r = "sync"
  } = n;
  if (!o || !a)
    return Ot;
  let i;
  const s = (u) => {
    i == null || i(), i = u;
  }, l = Vs(() => {
    const u = tt(e);
    if (u) {
      const { stop: d } = H2(
        a,
        (p) => {
          p.map((C) => [...C.removedNodes]).flat().some((C) => C === u || C.contains(u)) && t(p);
        },
        {
          window: o,
          childList: !0,
          subtree: !0
        }
      );
      s(d);
    }
  }, { flush: r }), c = () => {
    l(), s();
  };
  return Zn(c), c;
}
function _a(e, t = {}) {
  const {
    delayEnter: n = 0,
    delayLeave: o = 0,
    triggerOnRemoval: a = !1,
    window: r = Rt
  } = t, i = H(!1);
  let s;
  const l = (c) => {
    const u = c ? n : o;
    s && (clearTimeout(s), s = void 0), u ? s = setTimeout(() => i.value = c, u) : i.value = c;
  };
  return r && (pt(e, "mouseenter", () => l(!0), { passive: !0 }), pt(e, "mouseleave", () => l(!1), { passive: !0 }), a && V2(
    _(() => tt(e)),
    () => l(!1)
  )), i;
}
const xo = {
  mounted(e, t) {
    const n = t.value;
    if (typeof n == "function") {
      const o = _a(e);
      le(o, (a) => n(a));
    } else {
      const [o, a] = n, r = _a(e, a);
      le(r, (i) => o(i));
    }
  }
};
function eo(e) {
  return typeof Window < "u" && e instanceof Window ? e.document.documentElement : typeof Document < "u" && e instanceof Document ? e.documentElement : e;
}
function Ji(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const n = e.parentNode;
    return !n || n.tagName === "BODY" ? !1 : Ji(n);
  }
}
function F2(e) {
  const t = e || window.event, n = t.target;
  return Ji(n) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}
const to = /* @__PURE__ */ new WeakMap();
function z2(e, t = !1) {
  const n = H(t);
  let o = null, a = "";
  le(R2(e), (s) => {
    const l = eo(Le(s));
    if (l) {
      const c = l;
      if (to.get(c) || to.set(c, c.style.overflow), c.style.overflow !== "hidden" && (a = c.style.overflow), c.style.overflow === "hidden")
        return n.value = !0;
      if (n.value)
        return c.style.overflow = "hidden";
    }
  }, {
    immediate: !0
  });
  const r = () => {
    const s = eo(Le(e));
    !s || n.value || (Io && (o = pt(
      s,
      "touchmove",
      (l) => {
        F2(l);
      },
      { passive: !1 }
    )), s.style.overflow = "hidden", n.value = !0);
  }, i = () => {
    const s = eo(Le(e));
    !s || !n.value || (Io && (o == null || o()), s.style.overflow = a, to.delete(s), n.value = !1);
  };
  return Zn(i), _({
    get() {
      return n.value;
    },
    set(s) {
      s ? r() : i();
    }
  });
}
function W2() {
  let e = !1;
  const t = H(!1);
  return (n, o) => {
    if (t.value = o.value, e)
      return;
    e = !0;
    const a = z2(n, o.value);
    le(t, (r) => a.value = r);
  };
}
W2();
function G2(e, t, n) {
  var o = -1, a = e.length;
  t < 0 && (t = -t > a ? 0 : a + t), n = n > a ? a : n, n < 0 && (n += a), a = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var r = Array(a); ++o < a; )
    r[o] = e[o + t];
  return r;
}
var Y2 = G2, Z2 = Y2;
function X2(e, t, n) {
  var o = e.length;
  return n = n === void 0 ? o : n, !t && n >= o ? e : Z2(e, t, n);
}
var K2 = X2, q2 = "\\ud800-\\udfff", Q2 = "\\u0300-\\u036f", J2 = "\\ufe20-\\ufe2f", eC = "\\u20d0-\\u20ff", tC = Q2 + J2 + eC, nC = "\\ufe0e\\ufe0f", oC = "\\u200d", rC = RegExp("[" + oC + q2 + tC + nC + "]");
function aC(e) {
  return rC.test(e);
}
var es = aC;
function iC(e) {
  return e.split("");
}
var sC = iC, ts = "\\ud800-\\udfff", lC = "\\u0300-\\u036f", cC = "\\ufe20-\\ufe2f", dC = "\\u20d0-\\u20ff", uC = lC + cC + dC, pC = "\\ufe0e\\ufe0f", hC = "[" + ts + "]", ko = "[" + uC + "]", Do = "\\ud83c[\\udffb-\\udfff]", fC = "(?:" + ko + "|" + Do + ")", ns = "[^" + ts + "]", os = "(?:\\ud83c[\\udde6-\\uddff]){2}", rs = "[\\ud800-\\udbff][\\udc00-\\udfff]", gC = "\\u200d", as = fC + "?", is = "[" + pC + "]?", vC = "(?:" + gC + "(?:" + [ns, os, rs].join("|") + ")" + is + as + ")*", mC = is + as + vC, bC = "(?:" + [ns + ko + "?", ko, os, rs, hC].join("|") + ")", _C = RegExp(Do + "(?=" + Do + ")|" + bC + mC, "g");
function yC(e) {
  return e.match(_C) || [];
}
var CC = yC, wC = sC, $C = es, SC = CC;
function NC(e) {
  return $C(e) ? SC(e) : wC(e);
}
var AC = NC, TC = K2, OC = es, IC = AC, EC = cn;
function xC(e) {
  return function(t) {
    t = EC(t);
    var n = OC(t) ? IC(t) : void 0, o = n ? n[0] : t.charAt(0), a = n ? TC(n, 1).join("") : t.slice(1);
    return o[e]() + a;
  };
}
var kC = xC, DC = kC, MC = DC("toUpperCase"), PC = MC, LC = cn, RC = PC;
function BC(e) {
  return RC(LC(e).toLowerCase());
}
var ss = BC;
const jC = /* @__PURE__ */ Ze(ss);
function UC(e, t, n, o) {
  var a = -1, r = e == null ? 0 : e.length;
  for (o && r && (n = e[++a]); ++a < r; )
    n = t(n, e[a], a, e);
  return n;
}
var HC = UC;
function VC(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var FC = VC, zC = FC, WC = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, GC = zC(WC), YC = GC, ZC = YC, XC = cn, KC = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, qC = "\\u0300-\\u036f", QC = "\\ufe20-\\ufe2f", JC = "\\u20d0-\\u20ff", ew = qC + QC + JC, tw = "[" + ew + "]", nw = RegExp(tw, "g");
function ow(e) {
  return e = XC(e), e && e.replace(KC, ZC).replace(nw, "");
}
var rw = ow, aw = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function iw(e) {
  return e.match(aw) || [];
}
var sw = iw, lw = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function cw(e) {
  return lw.test(e);
}
var dw = cw, ls = "\\ud800-\\udfff", uw = "\\u0300-\\u036f", pw = "\\ufe20-\\ufe2f", hw = "\\u20d0-\\u20ff", fw = uw + pw + hw, cs = "\\u2700-\\u27bf", ds = "a-z\\xdf-\\xf6\\xf8-\\xff", gw = "\\xac\\xb1\\xd7\\xf7", vw = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", mw = "\\u2000-\\u206f", bw = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", us = "A-Z\\xc0-\\xd6\\xd8-\\xde", _w = "\\ufe0e\\ufe0f", ps = gw + vw + mw + bw, hs = "['’]", ya = "[" + ps + "]", yw = "[" + fw + "]", fs = "\\d+", Cw = "[" + cs + "]", gs = "[" + ds + "]", vs = "[^" + ls + ps + fs + cs + ds + us + "]", ww = "\\ud83c[\\udffb-\\udfff]", $w = "(?:" + yw + "|" + ww + ")", Sw = "[^" + ls + "]", ms = "(?:\\ud83c[\\udde6-\\uddff]){2}", bs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ct = "[" + us + "]", Nw = "\\u200d", Ca = "(?:" + gs + "|" + vs + ")", Aw = "(?:" + Ct + "|" + vs + ")", wa = "(?:" + hs + "(?:d|ll|m|re|s|t|ve))?", $a = "(?:" + hs + "(?:D|LL|M|RE|S|T|VE))?", _s = $w + "?", ys = "[" + _w + "]?", Tw = "(?:" + Nw + "(?:" + [Sw, ms, bs].join("|") + ")" + ys + _s + ")*", Ow = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Iw = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ew = ys + _s + Tw, xw = "(?:" + [Cw, ms, bs].join("|") + ")" + Ew, kw = RegExp([
  Ct + "?" + gs + "+" + wa + "(?=" + [ya, Ct, "$"].join("|") + ")",
  Aw + "+" + $a + "(?=" + [ya, Ct + Ca, "$"].join("|") + ")",
  Ct + "?" + Ca + "+" + wa,
  Ct + "+" + $a,
  Iw,
  Ow,
  fs,
  xw
].join("|"), "g");
function Dw(e) {
  return e.match(kw) || [];
}
var Mw = Dw, Pw = sw, Lw = dw, Rw = cn, Bw = Mw;
function jw(e, t, n) {
  return e = Rw(e), t = n ? void 0 : t, t === void 0 ? Lw(e) ? Bw(e) : Pw(e) : e.match(t) || [];
}
var Uw = jw, Hw = HC, Vw = rw, Fw = Uw, zw = "['’]", Ww = RegExp(zw, "g");
function Gw(e) {
  return function(t) {
    return Hw(Fw(Vw(t).replace(Ww, "")), e, "");
  };
}
var Yw = Gw, Zw = ss, Xw = Yw, Kw = Xw(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? Zw(t) : t);
}), qw = Kw;
const Qw = /* @__PURE__ */ Ze(qw), Jw = { class: "node-name" }, e$ = {
  __name: "DefaultNodeIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    groupType: {
      type: String,
      default: "",
      validator: (e) => ["layout", "content"].includes(e)
    }
  },
  setup(e) {
    const t = e, n = /* @__PURE__ */ Object.assign({
      "/src/assets/icons/nodes/AccordionIcon.vue": P_,
      "/src/assets/icons/nodes/ButtonIcon.vue": j_,
      "/src/assets/icons/nodes/CardIcon.vue": F_,
      "/src/assets/icons/nodes/EmbedIcon.vue": Y_,
      "/src/assets/icons/nodes/FormIcon.vue": ny,
      "/src/assets/icons/nodes/FourColumnsIcon.vue": cy,
      "/src/assets/icons/nodes/FullWidthIcon.vue": hy,
      "/src/assets/icons/nodes/GalleryIcon.vue": my,
      "/src/assets/icons/nodes/HeadingIcon.vue": Cy,
      "/src/assets/icons/nodes/ImageIcon.vue": n_,
      "/src/assets/icons/nodes/LeftSidebarIcon.vue": Ay,
      "/src/assets/icons/nodes/NavigationIcon.vue": By,
      "/src/assets/icons/nodes/OneColumnIcon.vue": Vy,
      "/src/assets/icons/nodes/QuoteIcon.vue": Gy,
      "/src/assets/icons/nodes/RightSidebarIcon.vue": qy,
      "/src/assets/icons/nodes/SeparatorIcon.vue": t2,
      "/src/assets/icons/nodes/SliderIcon.vue": a2,
      "/src/assets/icons/nodes/SpacerIcon.vue": c2,
      "/src/assets/icons/nodes/TableIcon.vue": h2,
      "/src/assets/icons/nodes/TextIcon.vue": m2,
      "/src/assets/icons/nodes/ThreeColumnsIcon.vue": $2,
      "/src/assets/icons/nodes/TwoColumnsIcon.vue": O2,
      "/src/assets/icons/nodes/VideoIcon.vue": k2
    }), o = _(() => {
      var l;
      const s = `/src/assets/icons/nodes/${t.node.icon}.vue`;
      return ((l = n[s]) == null ? void 0 : l.default) || null;
    }), a = _(
      () => `builder.${t.groupType}.${Qw(t.node.name)}.title`
    ), r = H(!1), i = (s) => r.value = s;
    return (s, l) => Zt((y(), M("div", {
      class: me(["block", e.groupType]),
      onDblclick: l[0] || (l[0] = (c) => s.$emit("add-node"))
    }, [
      (y(), W(yn(o.value), {
        class: "icon",
        "is-hovering": r.value
      }, null, 8, ["is-hovering"])),
      w("p", Jw, K(s.$t(a.value)), 1)
    ], 34)), [
      [V(xo), i]
    ]);
  }
}, t$ = /* @__PURE__ */ X(e$, [["__scopeId", "data-v-00b6ed94"]]);
function dn(e) {
  return Da() ? (Ma(e), !0) : !1;
}
function Cs(e) {
  let t = 0, n, o;
  const a = () => {
    t -= 1, o && t <= 0 && (o.stop(), n = void 0, o = void 0);
  };
  return (...r) => (t += 1, o || (o = Fs(!0), n = o.run(() => e(...r))), dn(a), n);
}
function Ee(e) {
  return typeof e == "function" ? e() : V(e);
}
const sr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const n$ = (e) => e != null, o$ = Object.prototype.toString, r$ = (e) => o$.call(e) === "[object Object]", a$ = () => +Date.now(), En = () => {
};
function i$(e, t) {
  function n(...o) {
    return new Promise((a, r) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(a).catch(r);
    });
  }
  return n;
}
const ws = (e) => e();
function s$(e, t = {}) {
  let n, o, a = En;
  const r = (s) => {
    clearTimeout(s), a(), a = En;
  };
  return (s) => {
    const l = Ee(e), c = Ee(t.maxWait);
    return n && r(n), l <= 0 || c !== void 0 && c <= 0 ? (o && (r(o), o = null), Promise.resolve(s())) : new Promise((u, d) => {
      a = t.rejectOnCancel ? d : u, c && !o && (o = setTimeout(() => {
        n && r(n), o = null, u(s());
      }, c)), n = setTimeout(() => {
        o && r(o), o = null, u(s());
      }, l);
    });
  };
}
function l$(e = ws) {
  const t = H(!0);
  function n() {
    t.value = !1;
  }
  function o() {
    t.value = !0;
  }
  const a = (...r) => {
    t.value && e(...r);
  };
  return { isActive: kn(t), pause: n, resume: o, eventFilter: a };
}
function c$(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const o = t;
    t = void 0, o && await o;
  }, n;
}
function d$(e) {
  return Po();
}
function u$(e, t = !0, n) {
  d$() ? Ue(e, n) : t ? e() : Pe(e);
}
function p$(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, a = H(!1);
  let r = null;
  function i() {
    r && (clearTimeout(r), r = null);
  }
  function s() {
    a.value = !1, i();
  }
  function l(...c) {
    i(), a.value = !0, r = setTimeout(() => {
      a.value = !1, r = null, e(...c);
    }, Ee(t));
  }
  return o && (a.value = !0, sr && l()), dn(s), {
    isPending: kn(a),
    start: l,
    stop: s
  };
}
function h$(e, t, n = {}) {
  const {
    eventFilter: o = ws,
    ...a
  } = n, r = i$(
    o,
    t
  );
  let i, s, l;
  if (a.flush === "sync") {
    const c = H(!1);
    s = () => {
    }, i = (u) => {
      c.value = !0, u(), c.value = !1;
    }, l = le(
      e,
      (...u) => {
        c.value || r(...u);
      },
      a
    );
  } else {
    const c = [], u = H(0), d = H(0);
    s = () => {
      u.value = d.value;
    }, c.push(
      le(
        e,
        () => {
          d.value++;
        },
        { ...a, flush: "sync" }
      )
    ), i = (p) => {
      const h = d.value;
      p(), u.value += d.value - h;
    }, c.push(
      le(
        e,
        (...p) => {
          const h = u.value > 0 && u.value === d.value;
          u.value = 0, d.value = 0, !h && r(...p);
        },
        a
      )
    ), l = () => {
      c.forEach((p) => p());
    };
  }
  return { stop: l, ignoreUpdates: i, ignorePrevAsyncUpdates: s };
}
function Fe(e, t, n) {
  return le(
    e,
    (a, r, i) => {
      a && t(a, r, i);
    },
    {
      ...n,
      once: !1
    }
  );
}
const Bt = sr ? window : void 0, $s = sr ? window.navigator : void 0;
function Et(e) {
  var t;
  const n = Ee(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function we(...e) {
  let t, n, o, a;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, a] = e, t = Bt) : [t, n, o, a] = e, !t)
    return En;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const r = [], i = () => {
    r.forEach((u) => u()), r.length = 0;
  }, s = (u, d, p, h) => (u.addEventListener(d, p, h), () => u.removeEventListener(d, p, h)), l = le(
    () => [Et(t), Ee(a)],
    ([u, d]) => {
      if (i(), !u)
        return;
      const p = r$(d) ? { ...d } : d;
      r.push(
        ...n.flatMap((h) => o.map((C) => s(u, h, C, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    l(), i();
  };
  return dn(c), c;
}
function f$() {
  const e = H(!1), t = Po();
  return t && Ue(() => {
    e.value = !0;
  }, t), e;
}
function Xn(e) {
  const t = f$();
  return _(() => (t.value, !!e()));
}
function Ss(e, t, n = {}) {
  const { window: o = Bt, ...a } = n;
  let r;
  const i = Xn(() => o && "MutationObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = _(() => {
    const p = Ee(e), h = (Array.isArray(p) ? p : [p]).map(Et).filter(n$);
    return new Set(h);
  }), c = le(
    () => l.value,
    (p) => {
      s(), i.value && p.size && (r = new MutationObserver(t), p.forEach((h) => r.observe(h, a)));
    },
    { immediate: !0, flush: "post" }
  ), u = () => r == null ? void 0 : r.takeRecords(), d = () => {
    c(), s();
  };
  return dn(d), {
    isSupported: i,
    stop: d,
    takeRecords: u
  };
}
function Sa(e = {}) {
  var t;
  const {
    window: n = Bt,
    deep: o = !0,
    triggerOnRemoval: a = !1
  } = e, r = (t = e.document) != null ? t : n == null ? void 0 : n.document, i = () => {
    var c;
    let u = r == null ? void 0 : r.activeElement;
    if (o)
      for (; u != null && u.shadowRoot; )
        u = (c = u == null ? void 0 : u.shadowRoot) == null ? void 0 : c.activeElement;
    return u;
  }, s = H(), l = () => {
    s.value = i();
  };
  return n && (we(n, "blur", (c) => {
    c.relatedTarget === null && l();
  }, !0), we(n, "focus", l, !0)), a && Ss(r, (c) => {
    c.filter((u) => u.removedNodes.length).map((u) => Array.from(u.removedNodes)).flat().forEach((u) => {
      u === s.value && l();
    });
  }, {
    childList: !0,
    subtree: !0
  }), l(), s;
}
function Na(e, t = {}) {
  const {
    controls: n = !1,
    navigator: o = $s
  } = t, a = Xn(() => o && "permissions" in o), r = hr(), i = typeof e == "string" ? { name: e } : e, s = hr(), l = () => {
    var u, d;
    s.value = (d = (u = r.value) == null ? void 0 : u.state) != null ? d : "prompt";
  };
  we(r, "change", l);
  const c = c$(async () => {
    if (a.value) {
      if (!r.value)
        try {
          r.value = await o.permissions.query(i);
        } catch {
          r.value = void 0;
        } finally {
          l();
        }
      if (n)
        return zs(r.value);
    }
  });
  return c(), n ? {
    state: s,
    isSupported: a,
    query: c
  } : s;
}
function g$(e = {}) {
  const {
    navigator: t = $s,
    read: n = !1,
    source: o,
    copiedDuring: a = 1500,
    legacy: r = !1
  } = e, i = Xn(() => t && "clipboard" in t), s = Na("clipboard-read"), l = Na("clipboard-write"), c = _(() => i.value || r), u = H(""), d = H(!1), p = p$(() => d.value = !1, a);
  function h() {
    i.value && S(s.value) ? t.clipboard.readText().then((T) => {
      u.value = T;
    }) : u.value = v();
  }
  c.value && n && we(["copy", "cut"], h);
  async function C(T = Ee(o)) {
    c.value && T != null && (i.value && S(l.value) ? await t.clipboard.writeText(T) : f(T), u.value = T, d.value = !0, p.start());
  }
  function f(T) {
    const m = document.createElement("textarea");
    m.value = T ?? "", m.style.position = "absolute", m.style.opacity = "0", document.body.appendChild(m), m.select(), document.execCommand("copy"), m.remove();
  }
  function v() {
    var T, m, O;
    return (O = (m = (T = document == null ? void 0 : document.getSelection) == null ? void 0 : T.call(document)) == null ? void 0 : m.toString()) != null ? O : "";
  }
  function S(T) {
    return T === "granted" || T === "prompt";
  }
  return {
    isSupported: c,
    text: u,
    copied: d,
    copy: C
  };
}
function Ns(e) {
  return JSON.parse(JSON.stringify(e));
}
function As(e) {
  return e;
}
function v$(e, t) {
  return e.value = t;
}
function m$(e) {
  return e ? typeof e == "function" ? e : Ns : As;
}
function b$(e) {
  return e ? typeof e == "function" ? e : Ns : As;
}
function _$(e, t = {}) {
  const {
    clone: n = !1,
    dump: o = m$(n),
    parse: a = b$(n),
    setSource: r = v$
  } = t;
  function i() {
    return Ws({
      snapshot: o(e.value),
      timestamp: a$()
    });
  }
  const s = H(i()), l = H([]), c = H([]), u = (m) => {
    r(e, a(m.snapshot)), s.value = m;
  }, d = () => {
    l.value.unshift(s.value), s.value = i(), t.capacity && l.value.length > t.capacity && l.value.splice(t.capacity, Number.POSITIVE_INFINITY), c.value.length && c.value.splice(0, c.value.length);
  }, p = () => {
    l.value.splice(0, l.value.length), c.value.splice(0, c.value.length);
  }, h = () => {
    const m = l.value.shift();
    m && (c.value.unshift(s.value), u(m));
  }, C = () => {
    const m = c.value.shift();
    m && (l.value.unshift(s.value), u(m));
  }, f = () => {
    u(s.value);
  }, v = _(() => [s.value, ...l.value]), S = _(() => l.value.length > 0), T = _(() => c.value.length > 0);
  return {
    source: e,
    undoStack: l,
    redoStack: c,
    last: s,
    history: v,
    canUndo: S,
    canRedo: T,
    clear: p,
    commit: d,
    reset: f,
    undo: h,
    redo: C
  };
}
function y$(e, t = {}) {
  const {
    deep: n = !1,
    flush: o = "pre",
    eventFilter: a
  } = t, {
    eventFilter: r,
    pause: i,
    resume: s,
    isActive: l
  } = l$(a), {
    ignoreUpdates: c,
    ignorePrevAsyncUpdates: u,
    stop: d
  } = h$(
    e,
    v,
    { deep: n, flush: o, eventFilter: r }
  );
  function p(O, I) {
    u(), c(() => {
      O.value = I;
    });
  }
  const h = _$(e, { ...t, clone: t.clone || n, setSource: p }), { clear: C, commit: f } = h;
  function v() {
    u(), f();
  }
  function S(O) {
    s(), O && v();
  }
  function T(O) {
    let I = !1;
    const g = () => I = !0;
    c(() => {
      O(g);
    }), I || v();
  }
  function m() {
    d(), C();
  }
  return {
    ...h,
    isTracking: l,
    pause: i,
    resume: S,
    commit: v,
    batch: T,
    dispose: m
  };
}
function Ts(e, t = {}) {
  const n = t.debounce ? s$(t.debounce) : void 0;
  return {
    ...y$(e, { ...t, eventFilter: n })
  };
}
function lr(e, t, n = {}) {
  const { window: o = Bt, ...a } = n;
  let r;
  const i = Xn(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = _(() => {
    const d = Ee(e);
    return Array.isArray(d) ? d.map((p) => Et(p)) : [Et(d)];
  }), c = le(
    l,
    (d) => {
      if (s(), i.value && o) {
        r = new ResizeObserver(t);
        for (const p of d)
          p && r.observe(p, a);
      }
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), c();
  };
  return dn(u), {
    isSupported: i,
    stop: u
  };
}
function Os(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: a = !0,
    immediate: r = !0,
    updateTiming: i = "sync"
  } = t, s = H(0), l = H(0), c = H(0), u = H(0), d = H(0), p = H(0), h = H(0), C = H(0);
  function f() {
    const S = Et(e);
    if (!S) {
      n && (s.value = 0, l.value = 0, c.value = 0, u.value = 0, d.value = 0, p.value = 0, h.value = 0, C.value = 0);
      return;
    }
    const T = S.getBoundingClientRect();
    s.value = T.height, l.value = T.bottom, c.value = T.left, u.value = T.right, d.value = T.top, p.value = T.width, h.value = T.x, C.value = T.y;
  }
  function v() {
    i === "sync" ? f() : i === "next-frame" && requestAnimationFrame(() => f());
  }
  return lr(e, v), le(() => Et(e), (S) => !S && v()), Ss(e, v, {
    attributeFilter: ["style", "class"]
  }), a && we("scroll", v, { capture: !0, passive: !0 }), o && we("resize", v, { passive: !0 }), u$(() => {
    r && v();
  }), {
    height: s,
    bottom: l,
    left: c,
    right: u,
    top: d,
    width: p,
    x: h,
    y: C,
    update: v
  };
}
const C$ = {
  ctrl: "control",
  command: "meta",
  cmd: "meta",
  option: "alt",
  up: "arrowup",
  down: "arrowdown",
  left: "arrowleft",
  right: "arrowright"
};
function w$(e = {}) {
  const {
    reactive: t = !1,
    target: n = Bt,
    aliasMap: o = C$,
    passive: a = !0,
    onEventFired: r = En
  } = e, i = _n(/* @__PURE__ */ new Set()), s = {
    toJSON() {
      return {};
    },
    current: i
  }, l = t ? _n(s) : s, c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
  function d(f, v) {
    f in l && (t ? l[f] = v : l[f].value = v);
  }
  function p() {
    i.clear();
    for (const f of u)
      d(f, !1);
  }
  function h(f, v) {
    var S, T;
    const m = (S = f.key) == null ? void 0 : S.toLowerCase(), I = [(T = f.code) == null ? void 0 : T.toLowerCase(), m].filter(Boolean);
    m && (v ? i.add(m) : i.delete(m));
    for (const g of I)
      u.add(g), d(g, v);
    m === "meta" && !v ? (c.forEach((g) => {
      i.delete(g), d(g, !1);
    }), c.clear()) : typeof f.getModifierState == "function" && f.getModifierState("Meta") && v && [...i, ...I].forEach((g) => c.add(g));
  }
  we(n, "keydown", (f) => (h(f, !0), r(f)), { passive: a }), we(n, "keyup", (f) => (h(f, !1), r(f)), { passive: a }), we("blur", p, { passive: !0 }), we("focus", p, { passive: !0 });
  const C = new Proxy(
    l,
    {
      get(f, v, S) {
        if (typeof v != "string")
          return Reflect.get(f, v, S);
        if (v = v.toLowerCase(), v in o && (v = o[v]), !(v in l))
          if (/[+_-]/.test(v)) {
            const m = v.split(/[+_-]/g).map((O) => O.trim());
            l[v] = _(() => m.every((O) => Ee(C[O])));
          } else
            l[v] = H(!1);
        const T = Reflect.get(f, v, S);
        return t ? Ee(T) : T;
      }
    }
  );
  return C;
}
function $$(e) {
  var t;
  const n = (t = e.rangeCount) != null ? t : 0;
  return Array.from({ length: n }, (o, a) => e.getRangeAt(a));
}
function S$(e = {}) {
  const {
    window: t = Bt
  } = e, n = H(null), o = _(() => {
    var s, l;
    return (l = (s = n.value) == null ? void 0 : s.toString()) != null ? l : "";
  }), a = _(() => n.value ? $$(n.value) : []), r = _(() => a.value.map((s) => s.getBoundingClientRect()));
  function i() {
    n.value = null, t && (n.value = t.getSelection());
  }
  return t && we(t.document, "selectionchange", i), {
    text: o,
    rects: r,
    ranges: a,
    selection: n
  };
}
function ZS(e) {
  var t;
  const n = H(e == null ? void 0 : e.element), o = H(e == null ? void 0 : e.input), a = (t = e == null ? void 0 : e.styleProp) != null ? t : "height", r = H(1), i = H(0);
  function s() {
    var l;
    if (!n.value)
      return;
    let c = "";
    n.value.style[a] = "1px", r.value = (l = n.value) == null ? void 0 : l.scrollHeight;
    const u = Ee(e == null ? void 0 : e.styleTarget);
    u ? u.style[a] = `${r.value}px` : c = `${r.value}px`, n.value.style[a] = c;
  }
  return le([o, n], () => Pe(s), { immediate: !0 }), le(r, () => {
    var l;
    return (l = e == null ? void 0 : e.onResize) == null ? void 0 : l.call(e);
  }), lr(n, ([{ contentRect: l }]) => {
    i.value !== l.width && (i.value = l.width, s());
  }), e != null && e.watch && le(e.watch, s, { immediate: !0, deep: !0 }), {
    textarea: n,
    input: o,
    triggerResize: s
  };
}
const N$ = {}, A$ = { class: "pb-overlay" };
function T$(e, t) {
  return y(), M("div", A$);
}
const O$ = /* @__PURE__ */ X(N$, [["render", T$], ["__scopeId", "data-v-f6f53f85"]]), I$ = {
  __name: "ContentNode",
  props: {
    modelValue: { type: Object, default: () => ({}) },
    level: { type: Number, default: 0 },
    inAccordion: Boolean,
    isEditable: Boolean,
    isActiveNode: Boolean
  },
  setup(e) {
    const t = e, n = ue("state"), o = Pa(t, "modelValue"), a = {
      EditableAccordionNode: G(
        () => import("./EditableAccordionNode-D3EqV2J3.js")
      ),
      EditableAccordionPanelNode: G(
        () => import("./EditableAccordionPanelNode-BnPKpJ66.js")
      ),
      EditableButtonNode: G(
        () => import("./EditableButtonNode-CfO3xjJU.js")
      ),
      EditableCardNode: G(
        () => import("./EditableCardNode-s3k0jO36.js")
      ),
      EditableCodeNode: G(
        () => import("./EditableCodeNode-CfRnkfEy.js")
      ),
      EditableFormNode: G(
        () => import("./EditableFormNode-DdkpxQEU.js")
      ),
      EditableGalleryNode: G(
        () => import("./EditableGalleryNode-BWLhk2Ff.js")
      ),
      EditableHeadingNode: G(
        () => import("./EditableHeadingNode-M8u23qBe.js")
      ),
      EditableImageNode: G(
        () => import("./EditableImageNode-Doz0ELdM.js")
      ),
      EditableListNode: G(
        () => import("./EditableListNode-CouTEAwr.js")
      ),
      EditableQuoteNode: G(
        () => import("./EditableQuoteNode-UUHnBOOb.js")
      ),
      EditableSeparatorNode: G(
        () => import("./EditableSeparatorNode-DSMGwXf2.js")
      ),
      EditableSpacerNode: G(
        () => import("./EditableSpacerNode-CRzqwJ39.js")
      ),
      EditableTableNode: G(
        () => import("./EditableTableNode-DZd09Yx5.js")
      ),
      EditableTextNode: G(
        () => import("./EditableTextNode-DRZ0Mu0P.js")
      ),
      EditableVideoNode: G(
        () => import("./EditableVideoNode-6XN1ibFB.js")
      ),
      EditableSliderNode: G(
        () => import("./EditableSliderNode-B_UGYBbK.js")
      ),
      EditableNavigationNode: G(
        () => import("./EditableNavigationNode-CYq5CQAc.js")
      ),
      EditableSharedContentErrorNode: G(
        () => import("./EditableSharedContentErrorNode-DBSBIyjx.js")
      ),
      AccordionNode: G(
        () => import("./AccordionNode-CcTkr4f-.js")
      ),
      AccordionPanelNode: G(
        () => import("./AccordionPanelNode-B3iyPwTF.js")
      ),
      ButtonNode: G(() => import("./ButtonNode-6SvutFTe.js").then((f) => f.b)),
      CardNode: G(() => import("./CardNode-WaJcwRVS.js")),
      CodeNode: G(() => import("./CodeNode-BIY8zT-G.js")),
      FormNode: G(() => import("./FormNode-B8aWRNG1.js").then((f) => f.a)),
      GalleryNode: G(() => import("./GalleryNode-CCYul-tn.js").then((f) => f.b)),
      HeadingNode: G(() => import("./HeadingNode-DM4nfe_X.js")),
      ImageNode: G(() => import("./ImageNode-ukeDXsPD.js").then((f) => f.a)),
      ListNode: G(() => import("./ListNode-BxF69F-f.js")),
      NavigationNode: G(
        () => import("./NavigationNode-DmvvQl8k.js")
      ),
      QuoteNode: G(() => import("./QuoteNode-BsbKx_yq.js")),
      SeparatorNode: G(
        () => import("./SeparatorNode-CROAaUz3.js")
      ),
      SliderNode: G(() => import("./SliderNode-foWbQulr.js")),
      SpacerNode: G(() => import("./SpacerNode-BoROhzbm.js")),
      TableNode: G(() => import("./TableNode-BCVmo_0j.js")),
      TextNode: G(() => import("./TextNode-BGWezxf0.js")),
      VideoNode: G(() => import("./VideoNode-ML4_-fsF.js").then((f) => f.a)),
      SharedContentErrorNode: G(
        () => import("./SharedContentErrorNode-Yt5TcaXb.js")
      )
    }, r = ue("insideSharedContentLayout"), i = _(
      () => t.isEditable && r.value
    ), s = _(
      () => t.isEditable && !r.value
    ), l = _(() => {
      const v = [...Mn, ...Fa].find(
        (T) => T.type === o.value.type
      );
      return (s.value ? `Editable${v.component}` : v.component) || "div";
    }), c = _(() => [
      `content-level-${t.level}`,
      { "in-accordion": t.inAccordion },
      { "is-active": t.isActiveNode && s.value },
      { "is-editable": s.value }
    ]), u = _(
      () => {
        var f, v, S, T, m;
        return ((v = (f = n == null ? void 0 : n.value) == null ? void 0 : f.nodeDragging) == null ? void 0 : v.type) === Ye && ((T = (S = n == null ? void 0 : n.value) == null ? void 0 : S.nodeDragging) == null ? void 0 : T.id) !== ((m = o.value) == null ? void 0 : m.id);
      }
    ), d = _(
      () => {
        var f, v, S;
        return ((S = (v = (f = n == null ? void 0 : n.value) == null ? void 0 : f.builder) == null ? void 0 : v.customProperties) == null ? void 0 : S[o.value.type]) || {};
      }
    );
    function p() {
      var f;
      (f = n == null ? void 0 : n.value) == null || f.setActiveNode(o.value);
    }
    function h(f, v) {
      var S;
      v && ((S = n == null ? void 0 : n.value) == null || S.setActiveNode(o.value)), n.value.editor = f;
    }
    const C = _(() => {
      var f, v, S, T, m, O, I, g;
      return {
        "--root-elements-width": ((T = (S = (v = (f = n == null ? void 0 : n.value) == null ? void 0 : f.builder) == null ? void 0 : v.customProperties) == null ? void 0 : S.global) == null ? void 0 : T.rootElementsWidth) || "100%",
        "--root-elements-max-width": ((g = (I = (O = (m = n == null ? void 0 : n.value) == null ? void 0 : m.builder) == null ? void 0 : O.customProperties) == null ? void 0 : I.global) == null ? void 0 : g.rootElementsMaxWidth) || "100%"
      };
    });
    return (f, v) => (y(), W(Gs, null, {
      default: P(() => [
        (y(), W(yn(a[l.value]), {
          modelValue: o.value,
          "onUpdate:modelValue": [
            v[0] || (v[0] = (S) => o.value = S),
            v[1] || (v[1] = (S) => o.value = S)
          ],
          class: me(["content-node", c.value]),
          "is-editable": s.value,
          assets: V(n).builder.assets,
          "is-active-node": e.isActiveNode && s.value,
          "is-accordion-dragging": u.value,
          level: e.level,
          "in-accordion": e.inAccordion,
          "custom-properties": d.value,
          style: Ie(C.value),
          "is-editable-shared-content-layout": i.value,
          onSetActive: p,
          onFocusEditor: h,
          onAssetEntry: v[2] || (v[2] = (S) => V(n).addAsset(S)),
          onCloseSidebar: v[3] || (v[3] = (S) => V(n).clearActiveNode())
        }, null, 40, ["modelValue", "class", "is-editable", "assets", "is-active-node", "is-accordion-dragging", "level", "in-accordion", "custom-properties", "style", "is-editable-shared-content-layout"]))
      ]),
      _: 1
    }));
  }
}, E$ = /* @__PURE__ */ X(I$, [["__scopeId", "data-v-f7d24f00"]]), x$ = (e) => {
  var t, n, o, a;
  return (n = (t = e == null ? void 0 : e.properties) == null ? void 0 : t.backgroundColor) != null && n.toggle ? (a = (o = e == null ? void 0 : e.properties) == null ? void 0 : o.backgroundColor) == null ? void 0 : a.value : null;
}, k$ = (e, t) => {
  var a, r;
  const n = Math.min(t.width, t.height) / 2;
  return `${((r = (a = e == null ? void 0 : e.properties) == null ? void 0 : a.borderRadius) == null ? void 0 : r.value) / 100 * n}px`;
}, D$ = (e, t) => {
  var o, a, r, i, s, l, c, u, d, p, h;
  return !((a = (o = e == null ? void 0 : e.properties) == null ? void 0 : o.backgroundImage) != null && a.toggle) || !((l = (s = (i = (r = e == null ? void 0 : e.properties) == null ? void 0 : r.backgroundImage) == null ? void 0 : i.image) == null ? void 0 : s.content) != null && l.assetId) ? null : `url(${((h = t[(p = (d = (u = (c = e == null ? void 0 : e.properties) == null ? void 0 : c.backgroundImage) == null ? void 0 : u.image) == null ? void 0 : d.content) == null ? void 0 : p.assetId]) == null ? void 0 : h.url) || ""})`;
}, M$ = (e) => {
  var n, o, a, r, i;
  const t = ((a = (o = (n = e == null ? void 0 : e.properties) == null ? void 0 : n.backgroundImage) == null ? void 0 : o.image) == null ? void 0 : a.properties) || {};
  switch (t == null ? void 0 : t.backgroundPosition) {
    case "center":
      return {
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "contain",
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    case "fill":
      return {
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-position": `${((r = t == null ? void 0 : t.focalPointPosition) == null ? void 0 : r.x) || 50}% ${((i = t == null ? void 0 : t.focalPointPosition) == null ? void 0 : i.y) || 50}%`,
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    case "tile":
      return {
        "background-position": "center",
        "background-repeat": "repeat",
        "background-size": `${(t == null ? void 0 : t.tilePercentage) || 100}%`,
        transform: `rotate(${(t == null ? void 0 : t.rotation) || 0}deg)`
      };
    default:
      return {};
  }
}, Aa = (e, t, n) => ["top", "bottom", "left", "right"].reduce((o, a) => {
  var r, i, s;
  return {
    ...o,
    [`${t}${jC(a)}`]: ((r = e == null ? void 0 : e.properties[t]) != null && r.linked ? (i = e == null ? void 0 : e.properties[t]) == null ? void 0 : i.value : ((s = e == null ? void 0 : e.properties[t]) == null ? void 0 : s[a]) || 0) / n + "px"
  };
}, {}), P$ = (e, t, n, o) => {
  var v, S, T, m, O;
  const { customProperties: a, assets: r } = e, i = t.id === "root";
  if (Ai(t) && !i)
    return {};
  const s = 1, l = i ? !!((v = a == null ? void 0 : a.global) != null && v.backgroundColorAllowed) : !!((S = a == null ? void 0 : a[t.type]) != null && S.backgroundColorAllowed), c = i ? !!((T = a == null ? void 0 : a.global) != null && T.backgroundImageAllowed) : !!((m = a == null ? void 0 : a[t.type]) != null && m.backgroundImageAllowed), u = l && x$(t), d = c && D$(t, r), p = !!((O = a == null ? void 0 : a.experimentalFeatures) != null && O.roundedLayouts) && k$(t, o), h = M$(t), C = Aa(t, "margin", s), f = Aa(t, "padding", s);
  return {
    backgroundImage: d,
    backgroundColor: u,
    borderRadius: p,
    ...h,
    ...C,
    ...f
  };
}, L$ = { class: "node-action-icon" }, R$ = {
  __name: "ActiveNodeAction",
  props: {
    tooltipText: {
      type: String,
      default: ""
    },
    position: {
      type: String,
      default: "top"
    },
    icon: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = () => {
      o("click");
    };
    return (r, i) => {
      const s = L("a-icon"), l = L("a-button"), c = L("a-tooltip");
      return y(), W(c, {
        label: n.tooltipText,
        position: n.position
      }, {
        default: P(() => [
          E(l, {
            class: "node-action",
            variant: "none",
            onClick: a
          }, {
            default: P(() => [
              Ne(r.$slots, "default", {}, () => [
                w("p", L$, [
                  E(s, {
                    icon: n.icon
                  }, null, 8, ["icon"])
                ])
              ], !0)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["label", "position"]);
    };
  }
}, gn = /* @__PURE__ */ X(R$, [["__scopeId", "data-v-2aeb3fd3"]]), B$ = {}, j$ = {
  width: "12",
  height: "24",
  viewBox: "0 0 12 24",
  fill: "none"
};
function U$(e, t) {
  return y(), M("svg", j$, t[0] || (t[0] = [
    ka('<circle cx="4" cy="6" r="1" fill="white"></circle><circle cx="4" cy="10" r="1" fill="white"></circle><circle cx="4" cy="14" r="1" fill="white"></circle><circle cx="8" cy="6" r="1" fill="white"></circle><circle cx="8" cy="10" r="1" fill="white"></circle><circle cx="8" cy="14" r="1" fill="white"></circle><circle cx="4" cy="18" r="1" fill="white"></circle><circle cx="8" cy="18" r="1" fill="white"></circle>', 8)
  ]));
}
const Is = /* @__PURE__ */ X(B$, [["render", U$]]), XS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Is
}, Symbol.toStringTag, { value: "Module" }));
var H$ = hi, V$ = Wn, F$ = Wo, z$ = at, W$ = an, G$ = Fn, Y$ = Vn, Z$ = Zo, X$ = "[object Map]", K$ = "[object Set]", q$ = Object.prototype, Q$ = q$.hasOwnProperty;
function J$(e) {
  if (e == null)
    return !0;
  if (W$(e) && (z$(e) || typeof e == "string" || typeof e.splice == "function" || G$(e) || Z$(e) || F$(e)))
    return !e.length;
  var t = V$(e);
  if (t == X$ || t == K$)
    return !e.size;
  if (Y$(e))
    return !H$(e).length;
  for (var n in e)
    if (Q$.call(e, n))
      return !1;
  return !0;
}
var e3 = J$;
const t3 = /* @__PURE__ */ Ze(e3);
var n3 = "__lodash_hash_undefined__";
function o3(e) {
  return this.__data__.set(e, n3), this;
}
var r3 = o3;
function a3(e) {
  return this.__data__.has(e);
}
var i3 = a3, s3 = Ho, l3 = r3, c3 = i3;
function xn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new s3(); ++t < n; )
    this.add(e[t]);
}
xn.prototype.add = xn.prototype.push = l3;
xn.prototype.has = c3;
var d3 = xn;
function u3(e, t, n, o) {
  for (var a = e.length, r = n + (o ? 1 : -1); o ? r-- : ++r < a; )
    if (t(e[r], r, e))
      return r;
  return -1;
}
var p3 = u3;
function h3(e) {
  return e !== e;
}
var f3 = h3;
function g3(e, t, n) {
  for (var o = n - 1, a = e.length; ++o < a; )
    if (e[o] === t)
      return o;
  return -1;
}
var v3 = g3, m3 = p3, b3 = f3, _3 = v3;
function y3(e, t, n) {
  return t === t ? _3(e, t, n) : m3(e, b3, n);
}
var C3 = y3, w3 = C3;
function $3(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && w3(e, t, 0) > -1;
}
var S3 = $3;
function N3(e, t, n) {
  for (var o = -1, a = e == null ? 0 : e.length; ++o < a; )
    if (n(t, e[o]))
      return !0;
  return !1;
}
var A3 = N3;
function T3(e, t) {
  return e.has(t);
}
var O3 = T3;
function I3() {
}
var E3 = I3;
function x3(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var Es = x3, no = bi, k3 = E3, D3 = Es, M3 = 1 / 0, P3 = no && 1 / D3(new no([, -0]))[1] == M3 ? function(e) {
  return new no(e);
} : k3, L3 = P3, R3 = d3, B3 = S3, j3 = A3, U3 = O3, H3 = L3, V3 = Es, F3 = 200;
function z3(e, t, n) {
  var o = -1, a = B3, r = e.length, i = !0, s = [], l = s;
  if (n)
    i = !1, a = j3;
  else if (r >= F3) {
    var c = t ? null : H3(e);
    if (c)
      return V3(c);
    i = !1, a = U3, l = new R3();
  } else
    l = t ? [] : s;
  e:
    for (; ++o < r; ) {
      var u = e[o], d = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, i && d === d) {
        for (var p = l.length; p--; )
          if (l[p] === d)
            continue e;
        t && l.push(d), s.push(u);
      } else
        a(l, d, n) || (l !== s && l.push(d), s.push(u));
    }
  return s;
}
var W3 = z3, G3 = W3;
function Y3(e) {
  return e && e.length ? G3(e) : [];
}
var Z3 = Y3;
const X3 = /* @__PURE__ */ Ze(Z3);
function De({ state: e = {} }) {
  var Y;
  const t = ((Y = e == null ? void 0 : e.value) == null ? void 0 : Y.builder) || {}, n = t.sharedContent || {}, o = n.onContentCreated, a = n.onOpenSettings, r = n.onSaveContentEdited, i = n.onCancelContentEdited, s = n.onContentDetached, l = n.onSharedContentDeleted, c = _(
    () => {
      var b, k, j, Z;
      return !!((Z = (j = (k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.builder) == null ? void 0 : k.customProperties) == null ? void 0 : j.global) != null && Z.sharedContentAllowed);
    }
  ), u = _(
    () => {
      var b, k, j;
      return !!c.value && !!((j = (k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.builder) == null ? void 0 : k.sharedContent) != null && j.createSharedContentAllowed);
    }
  ), d = _(
    () => {
      var b, k, j;
      return !!c.value && !!((j = (k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.builder) == null ? void 0 : k.sharedContent) != null && j.editSharedContentAllowed);
    }
  ), p = _(
    () => {
      var b, k, j;
      return !!c.value && !!((j = (k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.builder) == null ? void 0 : k.sharedContent) != null && j.detachSharedContentAllowed);
    }
  ), h = _(
    () => {
      var b, k, j;
      return !t3(((j = (k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.builder) == null ? void 0 : k.sharedContent) == null ? void 0 : j.content) || {});
    }
  ), C = _(
    () => Object.keys(n.content || {}).length
  ), f = (b) => (b == null ? void 0 : b.type) === Se, v = _(
    () => {
      var b, k;
      return u.value && !f((b = e == null ? void 0 : e.value) == null ? void 0 : b.activeNode) && !U((k = e == null ? void 0 : e.value) == null ? void 0 : k.activeNode);
    }
  ), S = _(
    () => {
      var b;
      return d.value && f((b = e == null ? void 0 : e.value) == null ? void 0 : b.activeNode);
    }
  ), T = _(
    () => {
      var b;
      return p.value && f((b = e == null ? void 0 : e.value) == null ? void 0 : b.activeNode);
    }
  ), m = async ({
    node: b = null,
    name: k = "New shared content",
    icon: j = "16:paper-plane",
    accordionId: Z = null,
    preventNodeTypes: ee = []
  } = {}) => {
    var Ut, ge, mt, ur;
    if (!b && !((Ut = e == null ? void 0 : e.value) != null && Ut.activeNode))
      return;
    Z && (b = We(t.structure, Z)), ((mt = (ge = e == null ? void 0 : e.value) == null ? void 0 : ge.activeNode) == null ? void 0 : mt.type) === Re && (b = We(t.structure, e.value.activeNode.parentAccordionId));
    let se = te();
    const be = b || ((ur = e == null ? void 0 : e.value) == null ? void 0 : ur.activeNode);
    let Ve = nn(be);
    if (Ve = Ke(Ve), !(ee.length > 0 && ee.some(
      (js) => !!Ii(be, js)
    ))) {
      if (typeof o == "function") {
        const un = await o([Ve]);
        if (!un)
          return;
        se = un.id || se, k = un.name || k;
      }
      z({
        id: se,
        name: k,
        icon: j,
        content: Ve
      }), J({
        sharedContentId: se,
        idToReplace: be.id
      });
    }
  }, O = async (b) => {
    typeof a == "function" && a(b);
  }, I = (b, k, j, Z) => {
    var ee, se;
    e.value && (e.value.editingSharedContent.node = (ee = e == null ? void 0 : e.value) == null ? void 0 : ee.activeNode, e.value.editingSharedContent.boundingRect = {
      top: b,
      left: k,
      width: j,
      height: Z
    }, e.value.editingSharedContent.originalContent = ft(
      n.content[(se = e == null ? void 0 : e.value) == null ? void 0 : se.activeNode.sharedContentId].content
    ));
  }, g = (b) => {
    var k;
    n.content[(k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId].content.push(b);
  }, N = _(
    () => {
      var b, k;
      return ((k = (b = e == null ? void 0 : e.value) == null ? void 0 : b.editingSharedContent) == null ? void 0 : k.node) || null;
    }
  ), D = _({
    get: () => {
      var b, k;
      return ((k = n == null ? void 0 : n.content) == null ? void 0 : k[(b = N.value) == null ? void 0 : b.sharedContentId]) || {};
    },
    set: (b) => {
      var k;
      return n.content[(k = N.value) == null ? void 0 : k.sharedContentId] = b;
    }
  }), U = (b) => !!We(N.value, b.id), F = (b) => {
    var k;
    return ((k = N.value) == null ? void 0 : k.id) === b.id;
  }, A = _(() => N.value ? {
    isBlocked: !1,
    message: ""
  } : {
    isBlocked: !0,
    message: "builder.cannotNestSharedContent"
  }), $ = _(() => (b) => F(b)), x = async () => {
    var k;
    const b = (k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId;
    if (b) {
      if (typeof r == "function") {
        const j = n.content[b].content || [];
        if (!await r(
          b,
          j
        ))
          return;
      }
      Me();
    }
  }, B = async () => {
    var k, j, Z;
    const b = (k = e == null ? void 0 : e.value) == null ? void 0 : k.editingSharedContent.node.sharedContentId;
    b && (typeof i == "function" && !await i(b) || (n.content[(j = e == null ? void 0 : e.value) == null ? void 0 : j.editingSharedContent.node.sharedContentId].content = (Z = e == null ? void 0 : e.value) == null ? void 0 : Z.editingSharedContent.originalContent, Me()));
  }, R = (b) => {
    var j, Z;
    const k = (Z = n == null ? void 0 : n.content[(j = b == null ? void 0 : b.value) == null ? void 0 : j.sharedContentId]) == null ? void 0 : Z.content;
    return k ? b.value.nodes[0].nodes = k : (n.content[b.value.sharedContentId] = {
      content: [
        {
          id: b.value.sharedContentId,
          name: "Shared Component Error",
          type: tn
        }
      ]
    }, b.value.nodes[0].nodes = n.content[b.value.sharedContentId].content);
  };
  function z({ id: b, name: k, icon: j, content: Z }) {
    n.content[b] = { name: k, icon: j, content: [Z] };
  }
  function J({ sharedContentId: b, idToReplace: k }) {
    var se;
    const j = ye({
      sharedContentId: b,
      type: Se
    }), { parent: Z, index: ee } = ze(
      t.structure,
      k
    );
    Z.nodes.splice(ee, 1, j), (se = e == null ? void 0 : e.value) == null || se.setActiveNode(j);
  }
  const ne = async () => {
    var ee, se, be, Ve;
    const b = (se = (ee = e == null ? void 0 : e.value) == null ? void 0 : ee.activeNode) == null ? void 0 : se.sharedContentId;
    if (!p.value || !b || typeof s == "function" && !await s(b))
      return;
    const k = nn({
      ...n.content[b].content[0]
    }), { parent: j, index: Z } = ze(
      t.structure,
      (Ve = (be = e == null ? void 0 : e.value) == null ? void 0 : be.activeNode) == null ? void 0 : Ve.id
    );
    j.nodes.splice(Z, 1, k);
  }, ce = _(() => Object.entries(n.content || {}).map(([b, k]) => ({
    name: k.name,
    icon: k.icon,
    sharedContentId: b,
    type: Se
  }))), Ae = (b) => {
    const { sharedContentId: k, name: j, type: Z } = b;
    return ye({ sharedContentId: k, name: j, type: Z });
  }, Te = (b) => {
    var Z;
    const k = ye({
      type: Xt
    }), j = {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    return k.properties = {
      ...k.properties,
      margin: { ...j },
      padding: { ...j }
    }, k.nodes[0].nodes = ((Z = n.content[b]) == null ? void 0 : Z.content) || [], k;
  }, $e = (b) => n.content[b] || {};
  function Me() {
    var b;
    (b = e == null ? void 0 : e.value) == null || b.clearActiveNode(), e.value.editingSharedContent.node = null, e.value.editingSharedContent.boundingRect = null, e.value.editingSharedContent.originalContent = null;
  }
  function Ke(b) {
    var k, j;
    switch (b.type) {
      case Dn: {
        b.content.assetUrl = ((k = e == null ? void 0 : e.value) == null ? void 0 : k.builder.assets[b.content.assetId].url) || "";
        break;
      }
      case Cn:
      case wn: {
        b.content.images = b.content.images.map((Z) => {
          var ee;
          return Z.content.assetUrl = ((ee = e == null ? void 0 : e.value) == null ? void 0 : ee.builder.assets[Z.content.assetId].url) || "", Z;
        });
        break;
      }
      case $n: {
        b.content.image.content.assetUrl = ((j = e == null ? void 0 : e.value) == null ? void 0 : j.builder.assets[b.content.image.content.assetId].url) || "";
        break;
      }
    }
    return b;
  }
  const jt = ({ allowDuplicates: b = !1 } = {}) => {
    var k, j;
    return (j = (k = e == null ? void 0 : e.value) == null ? void 0 : k.builder) != null && j.structure ? Kn(e.value.builder.structure, b) : [];
  };
  function Kn(b, k = !1) {
    const j = [], Z = (ee) => {
      (ee == null ? void 0 : ee.type) === Se && j.push(ee == null ? void 0 : ee.sharedContentId);
      let se = (ee == null ? void 0 : ee.nodes) || {};
      Gn(se, (be) => {
        jn(be) && Z(be);
      });
    };
    return Z(b), k ? j : X3(j);
  }
  return {
    amountOfSharedContent: C,
    isSharedContentAllowed: c,
    canCreateSharedContent: u,
    canEditSharedContent: d,
    canDetachSharedContent: p,
    showCreateSharedContentButton: v,
    showEditSharedContentButton: S,
    showDetachSharedContentButton: T,
    hasSharedContent: h,
    isSharedContentLayout: f,
    createSharedContent: m,
    openSharedContentSettings: O,
    isolateSharedContent: I,
    applyContentToSharedContentLayout: R,
    getSharedContentSidebarNodes: ce,
    onSidebarCloneSharedContent: Ae,
    generateDialogPreview: Te,
    getSharedContentById: $e,
    editingSharedContent: N,
    editingSharedContentNodes: D,
    isNodeInsideEditingSharedContentLayout: U,
    isCurrentSharedContentBeingEdited: F,
    showEditingSharedContentActions: $,
    blockSharedContentLayout: A,
    detachSharedContent: ne,
    saveEditingSharedContent: x,
    cancelEditingSharedContent: B,
    addNodeToEditingSharedContent: g,
    extractSharedContentIds: jt,
    deleteSharedContent: async (b) => {
      typeof l != "function" || !await l(b) || delete n.content[b];
    }
  };
}
let It = null;
const K3 = Cs((e) => (It || (It = Ts(e, {
  deep: !0,
  debounce: 500,
  flush: "post",
  clone: ft
})), It)), q3 = () => {
  It && (It.clear(), It = null);
};
function cr(e) {
  return {
    ...K3(e),
    clearSharedHistory: q3
  };
}
const Q3 = {
  __name: "VerticalScrollText",
  props: {
    text: {
      type: String,
      default: ""
    },
    colorOnHover: {
      type: String,
      default: null
    },
    isHovering: Boolean,
    strikethrough: Boolean,
    activateScroll: Boolean
  },
  setup(e) {
    const t = e, n = H(null), o = H(null), a = H(3), r = H(0), i = () => {
      !n.value || !o.value || Pe(() => {
        const s = n.value, l = o.value, c = s.scrollWidth, u = l.clientWidth;
        r.value = Math.max(0, c - u), a.value = c > u ? Math.ceil(r.value / 50) : 0;
      });
    };
    return Ue(() => {
      i();
    }), (s, l) => (y(), M("div", {
      ref_key: "containerRef",
      ref: o,
      class: "text-container"
    }, [
      w("p", {
        ref_key: "textRef",
        ref: n,
        class: me(["scrollable-text", { "scroll-active": !!t.activateScroll }]),
        style: Ie({
          color: t.colorOnHover && t.isHovering ? t.colorOnHover : "inherit",
          textDecoration: t.strikethrough ? "line-through" : "none",
          "--scroll-duration": `${a.value}s`,
          "--scroll-distance": `${r.value}px`
        })
      }, [
        Ne(s.$slots, "default", {}, () => [
          fe(K(t.text), 1)
        ], !0)
      ], 6)
    ], 512));
  }
}, xs = /* @__PURE__ */ X(Q3, [["__scopeId", "data-v-98180b20"]]), J3 = { class: "elements-container" }, e5 = { class: "elements" }, t5 = {
  key: 1,
  class: "actions-group"
}, n5 = {
  key: 2,
  class: "actions-group"
}, o5 = { class: "action-icon" }, r5 = { class: "dropdown-item" }, a5 = { class: "dropdown-item-label" }, i5 = { class: "dropdown-item-shortkey" }, s5 = {
  __name: "ActiveNodeToolbar",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    activeAccordionId: {
      type: String,
      default: null
    }
  },
  emits: ["delete", "edit-shared-content"],
  setup(e, { emit: t }) {
    La((Y) => ({
      ff206aac: S.value
    }));
    const n = H(!1), o = e, a = t, r = ue("state"), i = H(!1), s = _(() => {
      var Y, b, k, j, Z, ee, se, be;
      return ((j = (k = (b = (Y = r == null ? void 0 : r.value) == null ? void 0 : Y.builder) == null ? void 0 : b.customProperties) == null ? void 0 : k.global) == null ? void 0 : j.confirmOnDeleteDialogAllowed) && ((be = (se = (ee = (Z = r == null ? void 0 : r.value) == null ? void 0 : Z.builder) == null ? void 0 : ee.customProperties) == null ? void 0 : se.global) == null ? void 0 : be.showConfirmOnDeleteDialog);
    }), l = _(() => {
      var Y;
      return x(o.node) && ((Y = R(o.node.sharedContentId)) == null ? void 0 : Y.name) || o.node.name;
    }), c = _(() => `${o.node.name.toLowerCase().replace(" ", "-")}-toolbar`), u = _(() => {
      var b, k, j, Z, ee, se;
      const Y = ((Z = (j = (k = (b = o.node) == null ? void 0 : b.nodes) == null ? void 0 : k[0]) == null ? void 0 : j.nodes) == null ? void 0 : Z[0]) || {};
      return !!We(Y, (se = (ee = r == null ? void 0 : r.value) == null ? void 0 : ee.activeNode) == null ? void 0 : se.id);
    }), d = _(() => {
      var b, k, j;
      const Y = !!((b = r == null ? void 0 : r.value) != null && b.activeNode) && ne(o.node) && !ne((k = r == null ? void 0 : r.value) == null ? void 0 : k.activeNode) && Te((j = r == null ? void 0 : r.value) == null ? void 0 : j.activeNode);
      return !!z.value && Y;
    }), p = _(() => o.node.type.includes(Ye)), h = _(() => o.node.type === Re), C = _(() => p.value ? u.value : !1), f = _(() => {
      var b, k;
      const Y = We(
        (b = r == null ? void 0 : r.value) == null ? void 0 : b.builder.structure,
        o.node.parentAccordionId
      );
      return h.value && ((k = Y == null ? void 0 : Y.nodes[0]) == null ? void 0 : k.nodes.length) === 1;
    }), v = _(() => f.value ? "builder.content.accordion.accordionMustHavePanels" : "builder.toolbar.deleteElement"), S = _(() => {
      var k, j;
      let b = ot(o.node) ? 10 : 0;
      return (j = (k = o.node) == null ? void 0 : k.properties) != null && j.margin && (b = o.node.properties.margin.linked ? o.node.properties.margin.value : o.node.properties.margin.top), `${-15 + b}px`;
    }), T = _(() => {
      var Y;
      return ((Y = r == null ? void 0 : r.value) == null ? void 0 : Y.userAgent) === "mac" ? "⌘" : "Ctrl";
    }), m = (Y) => {
      if (Y === "add-custom-code") {
        D();
        return;
      }
      a(Y);
    }, O = _(() => [
      {
        id: "copy-node",
        label: "Copy element",
        shortkey: `${T.value} + C`,
        icon: "CopyIcon"
      },
      {
        id: "cut-node",
        label: "Cut element",
        shortkey: `${T.value} + X`,
        icon: "CutIcon"
      },
      {
        id: "paste-node",
        label: "Paste element",
        shortkey: `${T.value} + V`,
        icon: "PasteIcon"
      },
      {
        id: "add-custom-code",
        label: "Add custom attributes",
        shortkey: "",
        icon: "AddCustomCodeIcon"
      }
    ]), I = _(() => {
      var Y, b, k, j;
      return !!((j = (k = (b = (Y = r == null ? void 0 : r.value) == null ? void 0 : Y.builder) == null ? void 0 : b.customProperties) == null ? void 0 : k.global) != null && j.customAttributesAllowed) && !x(o.node);
    }), g = () => {
      f.value || (s.value ? i.value = !0 : a("delete-node"));
    }, N = () => {
      var Y;
      (Y = r == null ? void 0 : r.value) == null || Y.setActiveNode(o.node);
    }, D = () => {
      r.value.showCustomAttributesSidebar = !0;
    }, {
      showCreateSharedContentButton: U,
      showDetachSharedContentButton: F,
      createSharedContent: A,
      detachSharedContent: $,
      isSharedContentLayout: x,
      showEditSharedContentButton: B,
      getSharedContentById: R,
      editingSharedContent: z,
      showEditingSharedContentActions: J,
      isCurrentSharedContentBeingEdited: ne,
      saveEditingSharedContent: ce,
      cancelEditingSharedContent: Ae,
      isNodeInsideEditingSharedContentLayout: Te
    } = De({
      state: r
    }), { resume: $e } = cr(r.value.builder), Me = () => {
      $e(), ce();
    }, Ke = () => {
      $e(), Ae();
    }, jt = [
      {
        id: "create-shared-content",
        showAction: U.value && !h.value,
        tooltipText: "builder.toolbar.createSharedContent",
        icon: G(
          () => import("./CreateSharedContentIcon-CIuVYzq2.js")
        ),
        onClick: () => {
          A({
            accordionId: o.activeAccordionId
          });
        }
      },
      {
        id: "edit-shared-content",
        showAction: B.value && !h.value,
        tooltipText: "builder.toolbar.editSharedContent",
        icon: G(
          () => import("./EditSharedContentIcon-CU-8ZjsP.js")
        ),
        onClick: () => a("edit-shared-content")
      },
      {
        id: "detach-shared-content",
        showAction: F.value && !h.value,
        tooltipText: "builder.toolbar.detachSharedContent",
        icon: G(
          () => import("./DetachSharedContentIcon-Bg0R3tsV.js")
        ),
        onClick: $
      },
      {
        id: "add-custom-code",
        showAction: I.value,
        tooltipText: "builder.toolbar.addCustomAttributes",
        icon: G(
          () => import("./AddCustomCodeIcon-zr9vsi7c.js")
        ),
        onClick: D
      },
      {
        id: "duplicate-node",
        showAction: !0,
        tooltipText: "builder.toolbar.duplicateElement",
        icon: G(
          () => import("./DuplicateIcon-2ZqjskFf.js")
        ),
        onClick: () => a("duplicate-node")
      },
      {
        id: "delete-node",
        showAction: !0,
        tooltipText: v.value,
        icon: G(
          () => import("./DeleteIcon-BLUk0Ynf.js")
        ),
        onClick: g
      }
    ], Kn = [
      "create-shared-content",
      "edit-shared-content",
      "detach-shared-content",
      "duplicate-node",
      "delete-node"
    ], dr = _(
      () => jt.filter(({ id: Y }) => Kn.includes(Y))
    );
    return (Y, b) => {
      const k = L("a-text"), j = L("a-button"), Z = L("a-dropdown"), ee = L("a-alert-header"), se = L("a-alert-content"), be = L("a-alert-footer"), Ve = L("a-dialog"), Ut = L("portal");
      return y(), M("div", {
        class: me([
          "toolbar",
          c.value,
          {
            "is-first-accordion-panel-active": C.value,
            "is-editing-shared-content": !!V(z),
            "shared-content-first-child-active": d.value
          }
        ]),
        style: Ie({ zIndex: n.value ? 3 : 2 }),
        onClick: b[6] || (b[6] = oo(() => {
        }, ["stop"]))
      }, [
        w("div", J3, [
          w("div", e5, [
            V(J)(o.node) ? q("", !0) : (y(), W(Is, {
              key: 0,
              class: "handler"
            })),
            E(j, {
              class: "node-name",
              variant: "link",
              onClick: oo(N, ["stop"]),
              disabled: !p.value
            }, {
              default: P(() => [
                E(xs, { style: { maxWidth: "200px" } }, {
                  default: P(() => [
                    E(k, { variant: "h4" }, {
                      default: P(() => [
                        fe(K(l.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"]),
            V(J)(o.node) ? (y(), M("div", t5, [
              E(gn, {
                "tooltip-text": Y.$t("builder.toolbar.saveEditingSharedContent"),
                icon: "16:checkmark",
                onClick: Me
              }, null, 8, ["tooltip-text"]),
              E(gn, {
                "tooltip-text": Y.$t("builder.toolbar.cancelEditingSharedContent"),
                icon: "16:close",
                onClick: Ke
              }, null, 8, ["tooltip-text"])
            ])) : (y(), M("div", n5, [
              (y(!0), M(ke, null, nt(dr.value, (ge) => (y(), M("div", o5, [
                ge.showAction ? (y(), W(gn, {
                  key: ge.id,
                  "tooltip-text": Y.$t(ge.tooltipText),
                  onClick: ge.onClick
                }, {
                  default: P(() => [
                    (y(), W(yn(ge.icon)))
                  ]),
                  _: 2
                }, 1032, ["tooltip-text", "onClick"])) : q("", !0)
              ]))), 256)),
              E(Z, {
                align: "right",
                class: "moreOptions",
                items: O.value,
                onItemClick: m,
                onOpen: b[1] || (b[1] = (ge) => n.value = !0),
                onClose: b[2] || (b[2] = (ge) => n.value = !1)
              }, Mo({
                dropdownTrigger: P(() => [
                  E(gn, {
                    "tooltip-text": Y.$t("builder.toolbar.moreOptions"),
                    icon: "16:shishkebab",
                    onClick: b[0] || (b[0] = (ge) => Y.showSettings = !0)
                  }, null, 8, ["tooltip-text"])
                ]),
                _: 2
              }, [
                nt(O.value, (ge) => ({
                  name: `dropdown_item_${ge.id}`,
                  fn: P(({ item: mt }) => [
                    w("div", r5, [
                      (y(), W(yn(mt.icon))),
                      w("p", a5, K(mt.label), 1),
                      w("p", i5, K(mt.shortkey), 1)
                    ])
                  ])
                }))
              ]), 1032, ["items"])
            ]))
          ])
        ]),
        i.value ? (y(), W(Ut, {
          key: 0,
          to: "root-dialog-container"
        }, {
          default: P(() => [
            E(Ve, {
              show: i.value,
              "no-close-on-overlay": "",
              size: "l",
              onClose: b[5] || (b[5] = (ge) => i.value = !1)
            }, {
              default: P(() => [
                E(ee, { alertMode: "warning" }, {
                  default: P(() => [
                    fe(K(Y.$t("builder.deleteNodeConfirmation")), 1)
                  ]),
                  _: 1
                }),
                E(se, null, {
                  default: P(() => b[7] || (b[7] = [
                    w("span", null, null, -1)
                  ])),
                  _: 1
                }),
                E(be, null, {
                  default: P(() => [
                    E(j, {
                      autofocus: "",
                      variant: "primary",
                      mode: "error",
                      onClick: b[3] || (b[3] = (ge) => Y.$emit("delete-node"))
                    }, {
                      default: P(() => [
                        fe(K(Y.$t("builder.delete")), 1)
                      ]),
                      _: 1
                    }),
                    E(j, {
                      variant: "default",
                      mode: "error",
                      onClick: b[4] || (b[4] = (ge) => i.value = !1)
                    }, {
                      default: P(() => [
                        fe(K(Y.$t("builder.cancel")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })) : q("", !0)
      ], 6);
    };
  }
}, l5 = /* @__PURE__ */ X(s5, [["__scopeId", "data-v-56038b4d"]]), yt = H(/* @__PURE__ */ new Map()), ks = Cs(() => {
  function e(o, a) {
    if (!a)
      return null;
    if (yt.value.has(o))
      return yt.value.get(o);
    const r = Ts(a, {
      deep: !0,
      debounce: 500,
      clone: ft
    });
    return yt.value.set(o, r), r;
  }
  function t(o) {
    return yt.value.get(o);
  }
  function n(o) {
    yt.value.has(o) && yt.value.delete(o);
  }
  return {
    createHistory: e,
    getHistory: t,
    deleteHistory: n
  };
}), c5 = {
  __name: "ActiveNodeWrapper",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean
  },
  setup(e) {
    const t = ue("state"), n = e, { node: o, isEditable: a } = Lo(n), r = _(() => N1(o.value)), i = ue("insideSharedContentLayout"), s = _(() => {
      var I, g, N, D;
      if (!a.value)
        return !1;
      if (C.value) {
        if (!h(o.value) && i.value)
          return !1;
        const U = ((g = (I = t == null ? void 0 : t.value) == null ? void 0 : I.activeNode) == null ? void 0 : g.id) === o.value.id && v(o.value);
        return h(o.value) || U;
      }
      return ((D = (N = t == null ? void 0 : t.value) == null ? void 0 : N.activeNode) == null ? void 0 : D.id) === o.value.id || c.value;
    }), l = (I) => {
      var g;
      return (g = I.nodes) != null && g.length ? I.nodes.some(
        (N) => {
          var D, U;
          return N.id === ((U = (D = t == null ? void 0 : t.value) == null ? void 0 : D.activeNode) == null ? void 0 : U.id) || l(N);
        }
      ) : !1;
    }, c = _(() => {
      var g, N;
      return [
        Ye,
        Re
      ].includes(o.value.type) && ((N = (g = t == null ? void 0 : t.value) == null ? void 0 : g.activeNode) == null ? void 0 : N.id) && l(o.value);
    }), u = H(null), {
      isSharedContentLayout: d,
      isolateSharedContent: p,
      isCurrentSharedContentBeingEdited: h,
      editingSharedContent: C,
      editingSharedContentNodes: f,
      isNodeInsideEditingSharedContentLayout: v
    } = De({
      state: t
    }), { pause: S } = cr(t.value.builder), { createHistory: T } = ks(t), m = () => {
      S();
      const { top: I, left: g, width: N, height: D } = Os(u);
      p(I, g, N, D), T(
        C.value.sharedContentId,
        f
      );
    }, O = _(() => {
      let I = "var(--pb-black)", g = "var(--primary-white)";
      switch (r.value) {
        case ct:
          I = "var(--color-layout)";
          break;
        case dt:
          I = "var(--color-content)";
          break;
        case Ro:
          I = "var(--color-sub-content)", g = "var(--purple)";
          break;
      }
      return d(o.value) && (I = "var(--color-shared-content)"), {
        "--node-group-toolbar-bg-color": I,
        "--node-group-toolbar-color": g
      };
    });
    return (I, g) => {
      var N;
      return y(), M("div", {
        ref_key: "activeNodeRef",
        ref: u,
        class: me([
          `${r.value}-active-wrapper`,
          { "is-editing-shared-content": V(h)(V(o)) }
        ]),
        style: Ie(O.value)
      }, [
        s.value ? (y(), W(l5, {
          key: 0,
          node: V(o),
          "active-accordion-id": c.value && ((N = V(o)) == null ? void 0 : N.id),
          onAddCustomAttributes: g[0] || (g[0] = (D) => I.$emit("add-custom-attributes")),
          onCopyNode: g[1] || (g[1] = (D) => I.$emit("copy-node")),
          onCutNode: g[2] || (g[2] = (D) => I.$emit("cut-node")),
          onPasteNode: g[3] || (g[3] = (D) => I.$emit("paste-node")),
          onDuplicateNode: g[4] || (g[4] = (D) => I.$emit("duplicate-node")),
          onFavorite: g[5] || (g[5] = (D) => I.$emit("favorite")),
          onDeleteNode: g[6] || (g[6] = (D) => I.$emit("delete-node")),
          onEditSharedContent: m
        }, null, 8, ["node", "active-accordion-id"])) : q("", !0),
        Ne(I.$slots, "default", {}, void 0, !0)
      ], 6);
    };
  }
}, d5 = /* @__PURE__ */ X(c5, [["__scopeId", "data-v-cd4af42f"]]);
function Ds({ node: e, state: t, maxNestingLevelsAllowed: n, isDraggableEditable: o, parentNodeId: a, isInsideSharedContentLayout: r = !1 }) {
  const i = ({ draggedContext: d, to: p }) => {
    const h = Number(p.getAttribute("data-level")) + 1;
    if (ot(d.element) && h >= n.value)
      return !1;
    const f = p.getAttribute("data-in-accordion") === "true";
    if (d.element.type === Ye && f)
      return !1;
  }, s = (d) => {
    t.nodeDragging = d.item._underlying_vm_;
  }, l = () => {
    t.nodeDragging = null;
  }, c = (d) => {
    var h;
    const p = (h = d.added) == null ? void 0 : h.element;
    if (d.added && p.type === Re) {
      const C = p.parentAccordionId, { parentAccordionId: f } = e.nodes.find(
        (v) => v.parentAccordionId !== C
      );
      f && (p.parentAccordionId = f);
    }
  }, u = _(() => {
    var p;
    const d = (p = t == null ? void 0 : t.editingSharedContent) == null ? void 0 : p.node;
    return r ? !!d : d && a ? d.id === a || !!We(d, a) : o.value;
  });
  return {
    handleDraggableNodeMoved: i,
    handleNodeDraggingStarted: s,
    handleNodeDraggingEnded: l,
    handleDraggableNodeChanged: c,
    isDraggableEnabled: u
  };
}
function Ms({
  state: e = {}
}) {
  const { copy: t, isSupported: n } = g$(), o = (u, d, p) => {
    if (e.isLinkModalOpen)
      return;
    const h = nn(u);
    Jr(u) && (h.parentAccordionId = u.parentAccordionId), d.nodes.splice(p + 1, 0, h), e == null || e.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "added",
      attributes: {
        method: "duplicate",
        component: h.type
      }
    });
  }, a = (u, d, p = !1) => {
    if (e.isLinkModalOpen)
      return;
    const h = u.nodes[d];
    u.nodes.splice(d, 1), e == null || e.emitToConsumingApp("amplitude-event", {
      type: h.name,
      action: "removed",
      attributes: {
        method: p ? "cut" : "delete",
        component: h.type
      }
    });
  }, r = () => {
    var p, h;
    if (!e.activeNode || !n || e.isLinkModalOpen)
      return;
    i();
    const { parent: u, index: d } = ze((p = e.builder) == null ? void 0 : p.structure, (h = e.activeNode) == null ? void 0 : h.id);
    a(u, d, !0), e.clearActiveNode(), e.clearEditor();
  }, i = () => {
    !e.activeNode || !n || e.isLinkModalOpen || t(JSON.stringify(e.activeNode));
  }, s = async () => {
    const u = await navigator.clipboard.readText();
    let d = !1;
    try {
      const p = JSON.parse(u), h = Array.isArray(p) ? [...p] : [p];
      return d = h.some((C) => (C.component || "").includes("ts-")), {
        clipboardData: h,
        isValidNode: !0,
        isLegacyNode: d
      };
    } catch {
      return {
        clipboardData: [u],
        isValidNode: !1,
        isLegacyNode: d
      };
    }
  }, l = async (u = null) => {
    if (!u) {
      const { clipboardData: v = [], isLegacyNode: S } = await s();
      u = v, S && (u = c(u));
    }
    const d = !(e != null && e.activeNode), p = !!(e != null && e.activeNode) && ot(e == null ? void 0 : e.activeNode), h = !!(e != null && e.activeNode) && Ni(e == null ? void 0 : e.activeNode), C = !!(e != null && e.activeNode) && Jr(e == null ? void 0 : e.activeNode);
    (Array.isArray(u) ? u : [u]).forEach((v, S) => {
      var O, I, g, N, D;
      const T = nn(v), m = S;
      if (e == null || e.emitToConsumingApp("amplitude-event", {
        type: T.name,
        action: "added",
        attributes: {
          method: "paste",
          component: T.type
        }
      }), d) {
        (g = (I = (O = e == null ? void 0 : e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null || g.push(T);
        return;
      }
      if (p) {
        e.activeNode.nodes[0].nodes.push(T);
        return;
      }
      if (h) {
        const { parent: U, index: F } = ze((N = e.builder) == null ? void 0 : N.structure, (D = e.activeNode) == null ? void 0 : D.id), A = F + m + 1;
        U.nodes.splice(A, 0, T);
        return;
      }
      if (C) {
        if (Oi(T))
          return;
        e.activeNode.nodes[0].nodes.push(T);
        return;
      }
    });
  }, c = (u = [{}]) => {
    var p, h;
    if (!e)
      return;
    let d = null;
    if (typeof ((h = (p = e == null ? void 0 : e.builder) == null ? void 0 : p.legacyAdapters) == null ? void 0 : h.pageToBuilder) == "function") {
      const { structure: C, assets: f } = e.builder.legacyAdapters.pageToBuilder(u);
      f && e.addAsset(f), C.id && C.id === "root" ? d = C.nodes || [{}] : d = C || [{}];
    }
    return d;
  };
  return {
    duplicateNode: o,
    deleteNode: a,
    cutSelectedNode: r,
    copySelectedNode: i,
    isClipboardSupported: n,
    dataInClipboard: s,
    pasteNode: l,
    convertLegacyStructureToBuilderStructure: c
  };
}
const u5 = {
  key: 0,
  class: "draggable-node-list-container"
}, p5 = {
  key: 1,
  style: { "pointer-events": "auto" },
  class: "accordion-panel-placeholder"
}, h5 = {
  __name: "DraggableNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    parentNodeId: {
      type: String,
      default: ""
    },
    inAccordion: Boolean,
    isEditable: Boolean
  },
  setup(e) {
    const t = G(() => Promise.resolve().then(() => Ls)), n = ue("state"), o = ue("maxNestingLevelsAllowed"), a = e, r = _(() => a.modelValue), i = _(() => a.isEditable);
    function s() {
      var N, D, U, F, A, $;
      (N = n == null ? void 0 : n.value) != null && N.nodeDragging && (($ = n == null ? void 0 : n.value) == null || $.emitToConsumingApp("amplitude-event", {
        type: (U = (D = n == null ? void 0 : n.value) == null ? void 0 : D.nodeDragging) == null ? void 0 : U.name,
        action: "added",
        attributes: {
          method: "drag-and-drop",
          component: (A = (F = n == null ? void 0 : n.value) == null ? void 0 : F.nodeDragging) == null ? void 0 : A.type
        }
      }), n.value.nodeDragging = null);
    }
    function l(N) {
      var D, U;
      (D = n == null ? void 0 : n.value) == null || D.clearEditor(), (U = n == null ? void 0 : n.value) == null || U.clearActiveNode(), m(r.value, N);
    }
    const c = ue("insideSharedContentLayout");
    function u(N, D) {
      var U, F;
      if (g.value) {
        I(D) && (N.stopPropagation(), (U = n == null ? void 0 : n.value) == null || U.setActiveNode(D));
        return;
      }
      c.value || i.value && (N.stopPropagation(), (F = n == null ? void 0 : n.value) == null || F.setActiveNode(D));
    }
    const {
      handleDraggableNodeMoved: d,
      handleNodeDraggingStarted: p,
      handleNodeDraggingEnded: h,
      handleDraggableNodeChanged: C,
      isDraggableEnabled: f
    } = Ds({
      node: r,
      state: n.value,
      maxNestingLevelsAllowed: o,
      isDraggableEditable: i,
      parentNodeId: a.parentNodeId,
      isInsideSharedContentLayout: c.value
    }), {
      copySelectedNode: v,
      cutSelectedNode: S,
      pasteNode: T,
      deleteNode: m,
      duplicateNode: O
    } = Ms({ state: n.value }), { isNodeInsideEditingSharedContentLayout: I, editingSharedContent: g } = De({
      state: n
    });
    return (N, D) => r.value.nodes ? (y(), M("div", u5, [
      E(V(ja), {
        ref: "builder-draggable",
        list: r.value.nodes,
        "ghost-class": "ghost-class",
        handle: ".handler",
        class: me([
          "draggable-node-list",
          { "empty-node": !r.value.nodes.length },
          `draggable-level-${e.level}`
        ]),
        group: e.draggableGroup,
        "swap-threshold": 0.5,
        "data-level": e.level,
        disabled: !V(f),
        "item-key": "id",
        "data-in-accordion": e.inAccordion,
        move: V(d),
        onStart: V(p),
        onEnd: V(h),
        onChange: V(C),
        onDrop: s
      }, {
        item: P(({ element: U, index: F }) => [
          r.value.nodes.length ? (y(), W(d5, {
            class: me({ "accordion-panel-active-wrapper": e.inAccordion }),
            key: U.id,
            node: U,
            "is-editable": i.value,
            "in-accordion": e.inAccordion,
            onCopyNode: V(v),
            onCutNode: V(S),
            onPasteNode: V(T),
            onDuplicateNode: (A) => V(O)(U, r.value, F),
            onDeleteNode: (A) => l(F)
          }, {
            default: P(() => [
              E(V(t), {
                modelValue: r.value.nodes[F],
                "onUpdate:modelValue": (A) => r.value.nodes[F] = A,
                level: e.level + 1,
                "in-accordion": e.inAccordion,
                "is-editable": i.value,
                onClick: (A) => u(A, U)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "level", "in-accordion", "is-editable", "onClick"])
            ]),
            _: 2
          }, 1032, ["class", "node", "is-editable", "in-accordion", "onCopyNode", "onCutNode", "onPasteNode", "onDuplicateNode", "onDeleteNode"])) : e.inAccordion ? (y(), M("div", p5, K(N.$t("builder.content.accordion.emptyAccordionMessage")), 1)) : q("", !0)
        ]),
        _: 1
      }, 8, ["list", "class", "group", "data-level", "disabled", "data-in-accordion", "move", "onStart", "onEnd", "onChange"])
    ])) : q("", !0);
  }
}, f5 = /* @__PURE__ */ X(h5, [["__scopeId", "data-v-add59926"]]), g5 = {
  name: "DraggableBlocker",
  props: {
    message: {
      type: String,
      required: !0
    }
  }
}, v5 = ["blocked-layout-message"];
function m5(e, t, n, o, a, r) {
  return y(), M("div", {
    class: "blockage-mask",
    "blocked-layout-message": n.message
  }, null, 8, v5);
}
const b5 = /* @__PURE__ */ X(g5, [["render", m5], ["__scopeId", "data-v-a3ecc03c"]]), _5 = {
  __name: "BorderRadiusControl",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const n = e, o = t, a = _({
      get: () => {
        var r, i, s;
        return ((s = (i = (r = n.node) == null ? void 0 : r.properties) == null ? void 0 : i.borderRadius) == null ? void 0 : s.value) || 0;
      },
      set: (r) => {
        o("update", r);
      }
    });
    return (r, i) => {
      const s = L("a-form-input");
      return y(), W(ht, null, {
        title: P(() => [
          w("h4", null, K(r.$t("builder.borderStyles.borderRadius")), 1)
        ]),
        control: P(() => [
          E(s, {
            modelValue: a.value,
            "onUpdate:modelValue": i[0] || (i[0] = (l) => a.value = l),
            width: "70px",
            type: "number",
            min: 0,
            max: 100
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      });
    };
  }
}, y5 = /* @__PURE__ */ X(_5, [["__scopeId", "data-v-36b970f3"]]), C5 = {
  name: "MarginControl",
  components: {
    NodeControl: ht
  },
  props: {
    node: {
      type: Object,
      default: () => {
      }
    },
    property: {
      type: String,
      default: "margin"
    }
  },
  computed: {
    toggleLinked: {
      get() {
        var e, t, n;
        return (n = (t = (e = this.node) == null ? void 0 : e.properties) == null ? void 0 : t[this.property]) == null ? void 0 : n.linked;
      },
      set(e) {
        this.$emit("toggle", e);
      }
    }
  },
  methods: {
    updateLinkedValue(e) {
      var t, n;
      this.$emit("update", {
        ...((n = (t = this.node) == null ? void 0 : t.properties) == null ? void 0 : n[this.property]) || {},
        value: Number(e)
      });
    },
    updateMarginPadding(e, t) {
      var n, o;
      this.$emit("update", {
        ...((o = (n = this.node) == null ? void 0 : n.properties) == null ? void 0 : o[this.property]) || {},
        [e]: Number(t)
      });
    }
  }
}, w5 = { class: "inline-control" }, $5 = { class: "more-options-toggle" }, S5 = {
  key: 0,
  class: "more-options-row"
};
function N5(e, t, n, o, a, r) {
  const i = L("a-form-input"), s = L("a-text"), l = L("a-tooltip"), c = L("a-toggle"), u = L("NodeControl");
  return y(), W(u, null, {
    title: P(() => [
      w("h4", null, K(e.$t(`builder.borderStyles.${n.property}`)), 1)
    ]),
    content: P(() => {
      var d, p, h, C, f, v, S, T, m;
      return [
        w("div", w5, [
          E(i, {
            type: "number",
            width: "70px",
            label: "",
            min: 0,
            step: 2,
            disabled: !((h = (p = (d = n.node) == null ? void 0 : d.properties) == null ? void 0 : p[n.property]) != null && h.linked),
            "model-value": ((v = (f = (C = n.node) == null ? void 0 : C.properties) == null ? void 0 : f[n.property]) == null ? void 0 : v.value) || 0,
            "onUpdate:modelValue": r.updateLinkedValue
          }, null, 8, ["disabled", "model-value", "onUpdate:modelValue"]),
          w("div", $5, [
            E(l, {
              label: e.$t("builder.linkedTooltip"),
              position: "left",
              size: "small"
            }, {
              default: P(() => [
                E(s, null, {
                  default: P(() => [
                    fe(K(e.$t("builder.linked")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            E(c, {
              modelValue: r.toggleLinked,
              "onUpdate:modelValue": t[0] || (t[0] = (O) => r.toggleLinked = O)
            }, null, 8, ["modelValue"])
          ])
        ]),
        (m = (T = (S = n.node) == null ? void 0 : S.properties) == null ? void 0 : T[n.property]) != null && m.linked ? q("", !0) : (y(), M("div", S5, [
          (y(), M(ke, null, nt(["top", "right", "bottom", "left"], (O) => {
            var I, g, N;
            return w("div", {
              key: O,
              class: "more-options-input-wrapper"
            }, [
              E(i, {
                class: "more-options-input",
                type: "number",
                width: "70px",
                label: O,
                min: 0,
                step: 2,
                modelValue: ((N = (g = (I = n.node) == null ? void 0 : I.properties) == null ? void 0 : g[n.property]) == null ? void 0 : N[O]) || 0,
                "onUpdate:modelValue": (D) => r.updateMarginPadding(O, D)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]);
          }), 64))
        ]))
      ];
    }),
    _: 1
  });
}
const A5 = /* @__PURE__ */ X(C5, [["render", N5], ["__scopeId", "data-v-88077f9b"]]), T5 = {
  name: "LayoutNodeControl",
  components: {
    BackgroundColorControl: ui,
    BackgroundImageControl: Ki,
    BorderRadiusControl: y5,
    MarginPaddingControl: A5,
    SidebarHeader: ir
  },
  inject: ["state"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    layoutCustomProperties() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n[this.node.type]) || {};
    },
    node() {
      return this.modelValue;
    },
    experimentalFeatures() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.experimentalFeatures) || {};
    }
  }
};
function O5(e, t, n, o, a, r) {
  const i = L("SidebarHeader"), s = L("BackgroundColorControl"), l = L("BackgroundImageControl"), c = L("BorderRadiusControl"), u = L("MarginPaddingControl"), d = L("portal");
  return y(), W(d, {
    to: r.node.id
  }, {
    default: P(() => [
      E(i, {
        title: r.node.name,
        onCloseSidebar: t[0] || (t[0] = (p) => e.$emit("close-sidebar"))
      }, null, 8, ["title"]),
      w("div", null, [
        r.layoutCustomProperties.backgroundColorAllowed ? (y(), W(s, {
          key: 0,
          node: r.node,
          onUpdate: t[1] || (t[1] = (p, h) => r.node.properties.backgroundColor[p] = h)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.backgroundImageAllowed ? (y(), W(l, {
          key: 1,
          node: r.node,
          assets: r.state.builder.assets,
          "upload-api": r.state.builder.api.images,
          onUpdate: t[2] || (t[2] = (p, h) => r.node.properties.backgroundImage[p] = h),
          onAssetEntry: t[3] || (t[3] = (p) => r.state.addAsset(p))
        }, null, 8, ["node", "assets", "upload-api"])) : q("", !0),
        r.experimentalFeatures.roundedLayouts ? (y(), W(c, {
          key: 2,
          node: r.node,
          onUpdate: t[4] || (t[4] = (p) => r.node.properties.borderRadius.value = p)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.marginAllowed ? (y(), W(u, {
          key: 3,
          node: r.node,
          property: "margin",
          onUpdate: t[5] || (t[5] = (p) => r.node.properties.margin = p),
          onToggle: t[6] || (t[6] = (p) => r.node.properties.margin.linked = p)
        }, null, 8, ["node"])) : q("", !0),
        r.layoutCustomProperties.paddingAllowed ? (y(), W(u, {
          key: 4,
          node: r.node,
          property: "padding",
          onUpdate: t[7] || (t[7] = (p) => r.node.properties.padding = p),
          onToggle: t[8] || (t[8] = (p) => r.node.properties.padding.linked = p)
        }, null, 8, ["node"])) : q("", !0)
      ])
    ]),
    _: 1
  }, 8, ["to"]);
}
const I5 = /* @__PURE__ */ X(T5, [["render", O5]]);
function E5(e) {
  const t = _(() => {
    var a;
    return ((a = e.value) == null ? void 0 : a.properties) || {};
  }), n = _(() => t.value.customClasses || []), o = _(() => t.value.anchorTag || "");
  return {
    nodeProperties: t,
    customClasses: n,
    anchorTag: o
  };
}
const x5 = ["data-builder-label", "data-anchor-tag"], k5 = {
  __name: "LayoutNode",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    inAccordion: Boolean,
    isActiveNode: Boolean,
    isEditable: Boolean,
    isEmptyBuilder: Boolean
  },
  setup(e) {
    La((x) => ({
      "3ef0f526": S.value
    }));
    const t = ue("state"), n = ue("maxNestingLevelsAllowed"), o = e, {
      modelValue: a,
      level: r,
      draggableGroup: i,
      inAccordion: s,
      isActiveNode: l,
      isEditable: c,
      isEmptyBuilder: u
    } = Lo(o), d = H({ width: 700, height: 70 }), p = H(null);
    Ue(() => {
      p.value && (d.value.width = p.value.clientWidth || 0, d.value.height = p.value.clientHeight || 0);
    }), lr(p, (x) => {
      var J;
      const B = x[0], { inlineSize: R, blockSize: z } = ((J = B.borderBoxSize) == null ? void 0 : J[0]) || {};
      d.value.width = R || p.value.clientWidth, d.value.height = z || p.value.clientHeight;
    });
    const h = _(() => {
      var x;
      return {
        ...P$(
          (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder,
          a.value,
          !1,
          d.value
        ),
        "--root-level-width": `calc(${T.value} - ${N.value})`,
        "--root-level-max-width": `calc(${m.value} - ${N.value})`
      };
    }), C = _(() => a.value.type.replace(/_/g, "-").toLowerCase().replace("layout-node-", "")), f = _(() => {
      var J, ne, ce, Ae, Te, $e;
      const x = ((ne = (J = t == null ? void 0 : t.value) == null ? void 0 : J.nodeDragging) == null ? void 0 : ne.id) === ((ce = a.value) == null ? void 0 : ce.id);
      if (!((Ae = t == null ? void 0 : t.value) != null && Ae.nodeDragging) || x)
        return {
          isBlocked: !1,
          message: ""
        };
      if (U(a.value))
        return F.value;
      const B = r.value + 1 >= n.value, R = ot((Te = t == null ? void 0 : t.value) == null ? void 0 : Te.nodeDragging), z = !!We(
        ($e = t == null ? void 0 : t.value) == null ? void 0 : $e.nodeDragging,
        a.value.id
      );
      return {
        isBlocked: B && R && !z,
        message: "builder.cannotNestMoreLayouts"
      };
    }), v = (x) => ot(a.value) || U(a.value) ? a.value.nodes[x] : a.value, S = _(() => {
      switch (a.value.type) {
        case ve:
        case Xt:
        case St:
        case Se:
          return 1;
        case Kt:
        case Jt:
        case en:
          return 2;
        case qt:
          return 3;
        case Qt:
          return 4;
        default:
          return 0;
      }
    }), T = _(() => {
      var x, B, R, z;
      return a.value.type === St || s.value ? "100%" : ((z = (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R.global) == null ? void 0 : z.rootElementsWidth) || "100%";
    }), m = _(() => {
      var x, B, R, z;
      return a.value.type === St || s.value ? "100%" : ((z = (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R.global) == null ? void 0 : z.rootElementsMaxWidth) || "100%";
    }), { nodeProperties: O, customClasses: I, anchorTag: g } = E5(a), N = _(() => {
      var J, ne, ce, Ae, Te, $e, Me, Ke;
      const x = !!((ne = (J = O.value) == null ? void 0 : J.margin) != null && ne.linked), B = ((Ae = (ce = O.value) == null ? void 0 : ce.margin) == null ? void 0 : Ae.left) || 0, R = (($e = (Te = O.value) == null ? void 0 : Te.margin) == null ? void 0 : $e.right) || 0, z = ((Ke = (Me = O.value) == null ? void 0 : Me.margin) == null ? void 0 : Ke.value) || 0;
      return x ? `${z * 2}px` : `${B + R}px`;
    }), D = _(() => {
      var x, B, R;
      return !!l.value && I1(
        (R = (B = (x = t == null ? void 0 : t.value) == null ? void 0 : x.builder) == null ? void 0 : B.customProperties) == null ? void 0 : R[a.value.type]
      );
    }), {
      isSharedContentLayout: U,
      blockSharedContentLayout: F,
      editingSharedContent: A
    } = De({
      state: t
    }), $ = _(() => {
      var x, B;
      return !!((x = A.value) != null && x.id) && ((B = A.value) == null ? void 0 : B.id) === a.value.id;
    });
    return (x, B) => (y(), M("div", {
      class: me(["pb-layout-container", [
        `row-level-${V(r)}`,
        { "in-accordion": V(s) },
        { "is-empty-builder": V(u) }
      ]])
    }, [
      w("div", {
        ref_key: "layoutNodeContainer",
        ref: p,
        class: me(["layout-node-container", [
          { "is-active": V(l) || $.value },
          C.value + "-row",
          V(I)
        ]]),
        style: Ie(h.value),
        "data-builder-label": x.$t("builder.emptyBuilderLabel"),
        "data-anchor-tag": V(g)
      }, [
        f.value.isBlocked ? (y(), W(b5, {
          key: 0,
          message: x.$t(f.value.message)
        }, null, 8, ["message"])) : q("", !0),
        (y(!0), M(ke, null, nt(S.value, (R, z) => (y(), M("div", {
          key: z,
          class: me(["column", [C.value, { "is-editable": V(c) }]])
        }, [
          E(f5, {
            "model-value": v(z),
            level: V(r),
            "draggable-group": V(i),
            "is-editable": V(c),
            "in-accordion": V(s),
            "parent-node-id": V(a).id || ""
          }, null, 8, ["model-value", "level", "draggable-group", "is-editable", "in-accordion", "parent-node-id"])
        ], 2))), 128))
      ], 14, x5),
      D.value ? (y(), W(I5, {
        key: 0,
        modelValue: V(a),
        "onUpdate:modelValue": B[0] || (B[0] = (R) => Ys(a) ? a.value = R : null),
        onCloseSidebar: B[1] || (B[1] = (R) => V(t).clearActiveNode())
      }, null, 8, ["modelValue"])) : q("", !0)
    ], 2));
  }
}, D5 = /* @__PURE__ */ X(k5, [["__scopeId", "data-v-225f5e84"]]), M5 = {
  __name: "NodeManager",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    level: {
      type: Number,
      default: 0
    },
    draggableGroup: {
      type: String,
      default: "structure"
    },
    isEditable: Boolean,
    inAccordion: Boolean
  },
  setup(e) {
    const t = ue("state"), n = e, { modelValue: o, isEditable: a, inAccordion: r, level: i } = Lo(n), s = _(() => (l(o.value) && c(o), o.value)), {
      isSharedContentLayout: l,
      applyContentToSharedContentLayout: c,
      isCurrentSharedContentBeingEdited: u
    } = De({ state: t }), d = ue("insideSharedContentLayout"), p = _(
      () => !u(s.value) && (!!(d != null && d.value) || l(s.value))
    );
    vn("insideSharedContentLayout", p);
    const h = _(
      () => ot(s.value) || Ai(s.value) || l(s.value)
    ), C = _(
      () => s.value.id === "root" && i.value === 0
    ), f = _(() => {
      var N;
      return a.value ? C.value && ((N = s.value.nodes) == null ? void 0 : N.length) === 0 || S1(s.value, r.value) : !1;
    }), v = _(() => {
      var N, D;
      return a.value && ((N = t == null ? void 0 : t.value) == null ? void 0 : N.activeNode) && ((D = t == null ? void 0 : t.value) == null ? void 0 : D.activeNode.id) === s.value.id;
    }), S = _(() => ({
      "empty-builder": f.value,
      "is-editable": a.value,
      root: C.value
    })), T = _(() => {
      var N, D;
      return C.value && !!((D = (N = t == null ? void 0 : t.value) == null ? void 0 : N.editingSharedContent) != null && D.node);
    }), m = H(null), { top: O, left: I } = Os(m), g = _(() => {
      var R, z, J;
      if (!((z = (R = t == null ? void 0 : t.value) == null ? void 0 : R.editingSharedContent) != null && z.node))
        return {};
      const {
        top: N,
        left: D,
        width: U,
        height: F
      } = (J = t == null ? void 0 : t.value) == null ? void 0 : J.editingSharedContent.boundingRect, A = N - O.value - 40, $ = D - I.value, x = U, B = F;
      return {
        clipPath: `polygon(0% 0%, 0% 100%, ${$}px 100%, ${$}px ${A}px, ${$ + x}px ${A}px, ${$ + x}px ${A + B}px, ${$}px ${A + B}px, ${$}px 100%, 100% 100%, 100% 0%)`
      };
    });
    return (N, D) => (y(), M("div", {
      ref_key: "nodeManagerContainer",
      ref: m,
      class: me(["node-manager-container", S.value])
    }, [
      h.value ? (y(), W(D5, {
        key: 0,
        modelValue: s.value,
        "onUpdate:modelValue": D[0] || (D[0] = (U) => s.value = U),
        level: V(i),
        "is-editable": V(a),
        "in-accordion": V(r),
        "draggable-group": e.draggableGroup,
        "is-active-node": v.value,
        "is-empty-builder": f.value
      }, null, 8, ["modelValue", "level", "is-editable", "in-accordion", "draggable-group", "is-active-node", "is-empty-builder"])) : (y(), W(E$, {
        key: 1,
        modelValue: s.value,
        "onUpdate:modelValue": D[1] || (D[1] = (U) => s.value = U),
        "is-editable": V(a),
        "in-accordion": V(r),
        level: V(i),
        isActiveNode: v.value
      }, null, 8, ["modelValue", "is-editable", "in-accordion", "level", "isActiveNode"])),
      T.value ? (y(), W(O$, {
        key: 2,
        style: Ie(g.value)
      }, null, 8, ["style"])) : q("", !0)
    ], 2));
  }
}, Ps = /* @__PURE__ */ X(M5, [["__scopeId", "data-v-eff29325"]]), Ls = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ps
}, Symbol.toStringTag, { value: "Module" })), P5 = { class: "shared-content-dialog no-drag" }, L5 = { class: "preview-section" }, R5 = { class: "info-section" }, B5 = { class: "node-name" }, j5 = { class: "info-actions" }, U5 = {
  __name: "SharedContentDialog",
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    contentPreview: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e;
    return (n, o) => {
      const a = L("a-icon"), r = L("a-button");
      return y(), M("div", P5, [
        w("div", L5, [
          E(Ps, {
            "model-value": e.contentPreview,
            "is-editable": !1
          }, null, 8, ["model-value"])
        ]),
        w("div", R5, [
          w("p", B5, K(t.node.name), 1),
          w("div", j5, [
            E(r, {
              class: "settings-button",
              variant: "none",
              onClick: o[0] || (o[0] = (i) => n.$emit("open-settings"))
            }, {
              default: P(() => [
                E(a, { icon: "24:settings-1" })
              ]),
              _: 1
            }),
            q("", !0)
          ])
        ])
      ]);
    };
  }
}, H5 = /* @__PURE__ */ X(U5, [["__scopeId", "data-v-27da9484"]]), V5 = { class: "shared-content-block" }, F5 = { class: "node-name" }, z5 = { class: "triangle" }, W5 = {
  __name: "SharedContentIcon",
  props: {
    node: {
      type: Object,
      default: () => ({})
    }
  },
  setup(e) {
    const t = ue("state"), n = e, o = H(!1), a = H(!1), r = (d) => a.value = d, i = (d) => o.value = d, {
      generateDialogPreview: s,
      openSharedContentSettings: l,
      deleteSharedContent: c
    } = De({
      state: t
    }), u = _(
      () => s(n.node.sharedContentId)
    );
    return (d, p) => {
      const h = L("a-icon");
      return y(), M("div", V5, [
        Zt((y(), M("div", {
          class: "block",
          onDblclick: p[0] || (p[0] = (C) => d.$emit("add-node"))
        }, [
          E(h, {
            class: "icon",
            icon: "32:paper-plane"
          }),
          E(xs, {
            style: { width: "75px" },
            "color-on-hover": "white",
            "is-hovering": o.value,
            "activate-scroll": o.value
          }, {
            default: P(() => [
              w("span", F5, K(n.node.name), 1)
            ]),
            _: 1
          }, 8, ["is-hovering", "activate-scroll"])
        ], 32)), [
          [V(xo), [i]]
        ]),
        Zt((y(), M("div", null, [
          w("div", z5, [
            E(h, {
              class: "eye-icon",
              icon: "24:eye-open",
              color: "white"
            })
          ]),
          a.value && !o.value ? (y(), W(H5, {
            key: 0,
            node: n.node,
            "content-preview": u.value,
            onOpenSettings: p[1] || (p[1] = (C) => V(l)(n.node.sharedContentId)),
            onDelete: p[2] || (p[2] = (C) => V(c)(n.node.sharedContentId))
          }, null, 8, ["node", "content-preview"])) : q("", !0)
        ])), [
          [V(xo), [r, { delayLeave: 150 }]]
        ])
      ]);
    };
  }
}, G5 = /* @__PURE__ */ X(W5, [["__scopeId", "data-v-4036c559"]]), Y5 = { class: "sidebar-nodes" }, Z5 = { class: "group-title" }, X5 = {
  __name: "SidebarNodes",
  props: {
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    },
    isSharedContentSidebar: Boolean
  },
  setup(e) {
    const t = e, n = ue("state"), o = _n({
      nodes: [
        ...Bo,
        ...Mn.filter(
          (A) => ![...nl, ...ol].includes(A.type)
        )
      ]
    }), a = _(
      () => {
        var A, $;
        return (($ = (A = n == null ? void 0 : n.value) == null ? void 0 : A.builder) == null ? void 0 : $.customProperties) || {};
      }
    ), {
      isSharedContentLayout: r,
      getSharedContentSidebarNodes: i,
      onSidebarCloneSharedContent: s,
      amountOfSharedContent: l,
      editingSharedContent: c,
      addNodeToEditingSharedContent: u
    } = De({ state: n }), d = H(""), p = _(
      () => t.isSharedContentSidebar ? [Se] : [ct, dt]
    ), h = _(() => {
      let A = t.nodesIncluded.length ? o.nodes.filter(($) => t.nodesIncluded.includes($.type)) : o.nodes;
      return A = A.filter(($) => {
        var R, z, J;
        const x = !!((J = (z = (R = a.value) == null ? void 0 : R.CONTENT_NODE_NAVIGATION) == null ? void 0 : z.siteMenu) != null && J.length);
        return !($.type === Nn && !x);
      }), A.filter(
        ($) => !t.nodesExcluded.includes($.type)
      );
    }), C = _(() => {
      var A;
      return ((A = a.value) == null ? void 0 : A.experimentalFeatures) || {};
    }), f = _(() => {
      var A, $;
      return ($ = (A = a.value) == null ? void 0 : A.global) == null ? void 0 : $.focusNewNodeOnCreate;
    }), v = (A) => {
      var x, B, R;
      const $ = O(A);
      if (c.value) {
        u($);
        return;
      }
      (B = (x = n == null ? void 0 : n.value) == null ? void 0 : x.builder) == null || B.structure.nodes.push($), (R = n == null ? void 0 : n.value) == null || R.emitToConsumingApp("amplitude-event", {
        type: $.name,
        action: "added",
        attributes: {
          method: "double-click",
          component: $.type
        }
      });
    }, S = (A) => {
      switch (A) {
        case ct:
          return "Layouts";
        case dt:
          return "Contents";
        case Se:
          return "Shared Content";
      }
    }, T = (A) => ({
      "blocks-container": !0,
      "shared-blocks-container": A === Se,
      "layout-blocks-container": A === ct,
      "content-blocks-container": A === dt
    }), m = (A) => A === Se ? i.value.filter(
      ({ name: x, sharedContentId: B }) => {
        var R;
        return x.toLowerCase().includes(d.value.toLowerCase().trim()) && B !== ((R = c == null ? void 0 : c.value) == null ? void 0 : R.sharedContentId);
      }
    ) : h.value.filter(($) => $.group === A), O = (A) => r(A) ? g(A) : I(A), I = (A) => {
      var x, B;
      let $ = null;
      switch (A.group) {
        case ct:
          $ = ye(A, C.value);
          break;
        case dt:
          $ = ut(A, (x = n == null ? void 0 : n.value) == null ? void 0 : x.builder.theme);
          break;
      }
      return f.value && ((B = n == null ? void 0 : n.value) == null || B.setActiveNode($)), $;
    }, g = (A) => {
      var x;
      const $ = s(A);
      return f.value && ((x = n == null ? void 0 : n.value) == null || x.setActiveNode($)), $;
    }, N = ue("maxNestingLevelsAllowed"), {
      handleDraggableNodeMoved: D,
      handleNodeDraggingStarted: U,
      handleNodeDraggingEnded: F
    } = Ds({
      state: n.value,
      maxNestingLevelsAllowed: N
    });
    return (A, $) => {
      const x = L("a-form-input");
      return y(), M("div", Y5, [
        (y(!0), M(ke, null, nt(p.value, (B) => (y(), M("div", {
          key: B,
          class: "group-block"
        }, [
          w("h4", Z5, K(S(B)), 1),
          B === V(Se) && V(l) > 6 ? (y(), W(x, {
            key: 0,
            type: "search",
            placeholder: A.$t("builder.builderTabs.searchSharedContentPlaceholder"),
            modelValue: d.value,
            "onUpdate:modelValue": $[0] || ($[0] = (R) => d.value = R)
          }, null, 8, ["placeholder", "modelValue"])) : q("", !0),
          E(V(ja), {
            ref_for: !0,
            ref: "sidebar-draggable",
            list: m(B),
            class: me(T(B)),
            filter: ".no-drag",
            group: { name: "structure", pull: "clone", put: !1 },
            clone: O,
            sort: !1,
            "item-key": "id",
            move: V(D),
            onStart: V(U),
            onEnd: V(F)
          }, {
            item: P(({ element: R, index: z }) => [
              B !== V(Se) ? (y(), W(t$, {
                node: R,
                "group-type": B,
                key: `${R.type}-${z}`,
                onAddNode: (J) => v(R)
              }, null, 8, ["node", "group-type", "onAddNode"])) : (y(), W(G5, {
                node: R,
                key: `sc-${R.type}-${z}`,
                onAddNode: (J) => v(R)
              }, null, 8, ["node", "onAddNode"]))
            ]),
            _: 2
          }, 1032, ["list", "class", "move", "onStart", "onEnd"])
        ]))), 128))
      ]);
    };
  }
}, Ta = /* @__PURE__ */ X(X5, [["__scopeId", "data-v-e2aa8f9a"]]), K5 = { key: 1 }, q5 = { class: "tabs-section" }, Q5 = {
  key: 1,
  class: "sidebar-title"
}, J5 = { key: 0 }, eS = { key: 1 }, tS = {
  __name: "ContentToolbar",
  props: {
    builder: {
      type: Object,
      default: () => ({})
    },
    nodesIncluded: {
      type: Array,
      default: () => []
    },
    nodesExcluded: {
      type: Array,
      default: () => []
    }
  },
  emits: ["switch-tab"],
  setup(e, { emit: t }) {
    const n = ue("state"), o = H("content"), a = H(!1), { isSharedContentAllowed: r, hasSharedContent: i } = De({
      state: n
    }), s = _(
      () => r.value && i.value
    );
    le(s, (d) => {
      d || (o.value = "content", c("switch-tab", o.value));
    });
    const l = H([
      {
        value: "content",
        label: "Content",
        ariaControls: "Content"
      },
      {
        value: "shared",
        label: "Shared",
        ariaControls: "Shared"
      }
    ]), c = t, u = (d) => {
      o.value = d.target.value, c("switch-tab", o.value);
    };
    return (d, p) => {
      const h = L("a-tabs"), C = L("a-icon"), f = L("a-button");
      return a.value ? (y(), W(A_, {
        key: 0,
        builder: e.builder,
        onCloseSidebar: p[0] || (p[0] = (v) => a.value = !1)
      }, null, 8, ["builder"])) : (y(), M("div", K5, [
        w("div", q5, [
          s.value ? (y(), W(h, {
            key: 0,
            selected: o.value,
            tabs: l.value,
            class: "sidebar-tabs",
            onSwitchTabs: u
          }, null, 8, ["selected", "tabs"])) : (y(), M("h3", Q5, K(d.$t("builder.builderTabs.dragAndDropElements")), 1)),
          E(f, {
            class: "settings-button",
            variant: "none",
            onClick: p[1] || (p[1] = (v) => a.value = !0)
          }, {
            default: P(() => [
              E(C, { icon: "24:settings-2" })
            ]),
            _: 1
          })
        ]),
        o.value === "content" ? (y(), M("div", J5, [
          E(Ta, {
            "nodes-included": e.nodesIncluded,
            "nodes-excluded": e.nodesExcluded
          }, null, 8, ["nodes-included", "nodes-excluded"])
        ])) : q("", !0),
        o.value === "shared" ? (y(), M("div", eS, [
          E(Ta, { "is-shared-content-sidebar": "" })
        ])) : q("", !0)
      ]));
    };
  }
}, nS = /* @__PURE__ */ X(tS, [["__scopeId", "data-v-a1077ba7"]]), oS = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
}, rS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aS = ["opacity"];
function iS(e, t, n, o, a, r) {
  return y(), M("svg", rS, [
    w("g", { opacity: r.isDisabled }, t[0] || (t[0] = [
      w("path", {
        d: "M4 11.5823H14.92C17.7256 11.5823 20 13.8567 20 16.6623V18.3333M4 11.5823L9.65217 5M4 11.5823L9.65217 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, aS)
  ]);
}
const Rs = /* @__PURE__ */ X(oS, [["render", iS]]), KS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rs
}, Symbol.toStringTag, { value: "Module" })), sS = {
  props: {
    disabled: Boolean
  },
  computed: {
    isDisabled() {
      return this.disabled ? "0.4" : "1";
    }
  }
}, lS = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cS = ["opacity"];
function dS(e, t, n, o, a, r) {
  return y(), M("svg", lS, [
    w("g", { opacity: r.isDisabled }, t[0] || (t[0] = [
      w("path", {
        d: "M20 11.5823H9.08C6.27439 11.5823 4 13.8567 4 16.6623V18.3333M20 11.5823L14.3478 5M20 11.5823L14.3478 18.1646",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]), 8, cS)
  ]);
}
const Bs = /* @__PURE__ */ X(sS, [["render", dS]]), qS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bs
}, Symbol.toStringTag, { value: "Module" })), uS = {
  name: "BuilderToolbar",
  components: {
    // BreakpointPreview,
    UndoIcon: Rs,
    RedoIcon: Bs
  },
  inject: ["state"],
  props: {
    builder: {
      type: Object,
      default: () => {
      }
    },
    redoDisabled: Boolean,
    undoDisabled: Boolean
  },
  computed: {
    editor() {
      var e;
      return ((e = this.state) == null ? void 0 : e.editor) || {
        editor: {},
        editorKey: "",
        enabledOptions: [],
        removeOptions: [],
        colorPalette: {}
      };
    },
    linkModalOptions() {
      return this.customRTEProperties.linkModalOptions || {};
    },
    colorPalette() {
      var t, n, o;
      return {
        enabled: O1(
          ((t = this.state) == null ? void 0 : t.builder) || {}
        ),
        colors: ((o = (n = this.editor) == null ? void 0 : n.colorPalette) == null ? void 0 : o.colors) || ["*"]
      };
    },
    customRTEProperties() {
      var e, t, n;
      return ((n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.RTEBar) || {};
    },
    aiEnabled() {
      var e, t, n, o, a;
      return ((a = (o = (n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n.global) == null ? void 0 : o.aiOptions) == null ? void 0 : a.enabled) || !1;
    },
    getRemoveOptions() {
      const e = this.customRTEProperties.removeOptions || [], t = this.editor.removeOptions || [];
      return [...e, ...t];
    }
  },
  methods: {
    toggleModal(e) {
      this.state.isLinkModalOpen = e, this.$emit("toggle-modal", e);
    }
  }
}, pS = { class: "sticky-header" }, hS = { class: "history-buttons" };
function fS(e, t, n, o, a, r) {
  const i = L("UndoIcon"), s = L("a-button"), l = L("a-tooltip"), c = L("RedoIcon"), u = L("a-static-rte");
  return y(), M("div", pS, [
    (y(), W(u, {
      key: r.editor.editorKey,
      class: "editor",
      disabled: !!r.customRTEProperties.disabled,
      "remove-default-actions": r.customRTEProperties.removeDefaultActions,
      "remove-options": r.getRemoveOptions,
      "editor-instance": r.editor.editor,
      "enabled-options": r.editor.enabledOptions,
      "link-modal-options": r.linkModalOptions,
      "color-palette": r.colorPalette,
      "font-sizes": r.customRTEProperties.fontSizes,
      "ai-enabled": r.aiEnabled,
      onToggleModal: r.toggleModal,
      onClick: t[2] || (t[2] = oo(() => {
      }, ["prevent", "stop"]))
    }, {
      "custom-actions": P(() => [
        w("div", hS, [
          E(l, {
            label: e.$t("builder.toolbar.undo"),
            position: "bottom"
          }, {
            default: P(() => [
              E(s, {
                variant: "none",
                disabled: n.undoDisabled,
                onClick: t[0] || (t[0] = (d) => e.$emit("undo"))
              }, {
                default: P(() => [
                  E(i, { disabled: n.undoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          E(l, {
            label: e.$t("builder.toolbar.redo"),
            position: "bottom"
          }, {
            default: P(() => [
              E(s, {
                variant: "none",
                disabled: n.redoDisabled,
                onClick: t[1] || (t[1] = (d) => e.$emit("redo"))
              }, {
                default: P(() => [
                  E(c, { disabled: n.redoDisabled }, null, 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["disabled", "remove-default-actions", "remove-options", "editor-instance", "enabled-options", "link-modal-options", "color-palette", "font-sizes", "ai-enabled", "onToggleModal"]))
  ]);
}
const gS = /* @__PURE__ */ X(uS, [["render", fS], ["__scopeId", "data-v-114cea93"]]);
function Oa(...e) {
  return _(() => e.some((t) => Ee(t)));
}
function vS({
  state: e = null,
  undo: t = null,
  redo: n = null,
  duplicateNode: o = null,
  deleteNode: a = null,
  allowArrowNavigation: r = !1,
  copySelectedNode: i = null,
  cutSelectedNode: s = null,
  dataInClipboard: l = null,
  pasteNode: c = null
}) {
  const { text: u } = S$(), { editingSharedContent: d } = De({ state: e }), p = Sa(), h = _(() => {
    var m, O, I, g;
    return ((m = p.value) == null ? void 0 : m.tagName) === "INPUT" || ((O = p.value) == null ? void 0 : O.tagName) === "TEXTAREA" || ((g = (I = e == null ? void 0 : e.editor) == null ? void 0 : I.editor) == null ? void 0 : g.isFocused);
  }), C = _(() => !!u.value), f = _(() => {
    var m, O;
    return (O = (m = e == null ? void 0 : e.editor) == null ? void 0 : m.editor) == null ? void 0 : O.isFocused;
  });
  Ue(() => {
    s && we(document, "cut", (m) => {
      if (f.value || e.isCodeModalOpen)
        return !0;
      if (!e || C.value)
        return !1;
      s();
    }), i && we(document, "copy", (m) => {
      !e || C.value || e.isCodeModalOpen || i();
    }), c && we(document, "paste", (m) => {
      S(m);
    });
  });
  const v = w$({
    passive: !1,
    async onEventFired(m) {
      const O = m.type === "keydown", I = {
        ctrlZ: !!t && (m.ctrlKey || m.metaKey) && m.key.toLowerCase() === "z",
        shiftCtrlZ: !!n && m.shiftKey && (m.ctrlKey || m.metaKey) && m.key.toLowerCase() === "z",
        ctrlD: !!o && m.ctrlKey && m.key.toLowerCase() === "d",
        ctrlBackspace: !!a && m.ctrlKey && m.key === "Backspace",
        arrowUp: !h.value && !!r && m.key === "ArrowUp",
        arrowDown: !h.value && !!r && m.key === "ArrowDown",
        arrowLeft: !h.value && !!r && m.key === "ArrowLeft",
        arrowRight: !h.value && !!r && m.key === "ArrowRight",
        escape: m.key === "Escape"
      };
      O && Object.values(I).some((g) => !!g) && m.preventDefault();
    }
  });
  t && Fe(Oa(v.ctrl_z, v.meta_z), () => {
    e.isCodeModalOpen || t();
  }), n && Fe(Oa(v.shift_ctrl_z, v.meta_shift_z), () => {
    e.isCodeModalOpen || n();
  }), o && Fe(v.ctrl_d, () => {
    var I, g;
    if (!(e != null && e.activeNode) || e.isCodeModalOpen)
      return;
    const { parent: m, index: O } = ze(
      (I = e.builder) == null ? void 0 : I.structure,
      (g = e.activeNode) == null ? void 0 : g.id
    );
    return o(e.activeNode, m, O);
  }), a && Fe(v.ctrl_backspace, () => {
    var I, g;
    if (!(e != null && e.activeNode) || e.isCodeModalOpen)
      return;
    const { parent: m, index: O } = ze(
      (I = e.builder) == null ? void 0 : I.structure,
      (g = e.activeNode) == null ? void 0 : g.id
    );
    e.clearActiveNode(), e.clearEditor(), a(m, O);
  }), r && e && Fe(v.arrowUp, () => {
    var O, I, g, N, D, U, F;
    if (!r || h.value || e.isCodeModalOpen || d.value)
      return;
    if (!(e != null && e.activeNode)) {
      e.setActiveNode(((g = (I = (O = e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null ? void 0 : g[0]) || null);
      return;
    }
    const m = ze(
      (N = e.builder) == null ? void 0 : N.structure,
      (D = e.activeNode) == null ? void 0 : D.id
    );
    m.index - 1 >= 0 && e.setActiveNode(((F = (U = m.parent) == null ? void 0 : U.nodes) == null ? void 0 : F[(m == null ? void 0 : m.index) - 1]) || null);
  }), r && e && Fe(v.arrowDown, () => {
    var O, I, g, N, D, U, F, A;
    if (!r || h.value || e.isCodeModalOpen || d.value)
      return;
    if (!(e != null && e.activeNode)) {
      e.setActiveNode(((g = (I = (O = e.builder) == null ? void 0 : O.structure) == null ? void 0 : I.nodes) == null ? void 0 : g[0]) || null);
      return;
    }
    const m = ze(
      (N = e.builder) == null ? void 0 : N.structure,
      (D = e.activeNode) == null ? void 0 : D.id
    );
    (((U = m.parent) == null ? void 0 : U.nodes) || []).length - 1 >= m.index + 1 && e.setActiveNode(((A = (F = m.parent) == null ? void 0 : F.nodes) == null ? void 0 : A[m.index + 1]) || null);
  }), r && e && Fe(v.arrowLeft, () => {
    var O, I;
    if (!r || h.value || !e.activeNode || e.isCodeModalOpen || d.value)
      return;
    const m = Ti(
      (O = e.builder) == null ? void 0 : O.structure,
      (I = e.activeNode) == null ? void 0 : I.id
    );
    m.grandparent && e.setActiveNode(m.grandparent);
  }), r && e && Fe(v.arrowRight, () => {
    var O, I, g, N, D, U, F, A, $, x;
    if (!r || h.value || !e.activeNode || e.isCodeModalOpen || d.value)
      return;
    const m = ((I = (O = e.activeNode) == null ? void 0 : O.nodes) == null ? void 0 : I.length) > 0 && ((U = (D = (N = (g = e.activeNode) == null ? void 0 : g.nodes) == null ? void 0 : N[0]) == null ? void 0 : D.nodes) == null ? void 0 : U.length) > 0;
    ot(e.activeNode) && m && e.setActiveNode(((x = ($ = (A = (F = e.activeNode) == null ? void 0 : F.nodes) == null ? void 0 : A[0]) == null ? void 0 : $.nodes) == null ? void 0 : x[0]) || null);
  }), e && Fe(v.escape, async () => {
    e.clearActiveNode(), e.clearEditor();
  });
  async function S(m) {
    var A, $;
    if (e.isCodeModalOpen)
      return;
    const { value: O = {} } = Sa(), I = !!O.editor, g = O.type;
    if (I || h.value && g !== "text")
      return;
    m.preventDefault();
    const { clipboardData: N, isValidNode: D, isLegacyNode: U } = await l();
    let F = N;
    if (U && typeof (($ = (A = e == null ? void 0 : e.builder) == null ? void 0 : A.legacyAdapters) == null ? void 0 : $.pageToBuilder) == "function") {
      const { structure: x, assets: B } = e.builder.legacyAdapters.pageToBuilder(F);
      B && e.addAsset(B), x.id && x.id === "root" ? F = x.nodes || [{}] : F = x || [{}];
    }
    if (!D) {
      h.value && T(N[0], O);
      return;
    }
    c && c(F);
  }
  function T(m, O) {
    const I = O.selectionStart, g = O.selectionEnd, N = O.value, D = N.slice(0, I) + m + N.slice(g);
    O.value = D, O.selectionStart = O.selectionEnd = I + m.length, O.dispatchEvent(new Event("input"));
  }
}
const mS = { class: "builder-manager-container" }, bS = { class: "builder-toolbar-section" }, _S = {
  __name: "BuilderManager",
  props: {
    isEditable: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, o = ue("state"), a = G(() => Promise.resolve().then(() => Ls)), r = _({
      get() {
        var A;
        return (A = o == null ? void 0 : o.value) == null ? void 0 : A.builder;
      },
      set(A) {
        o.value.builder = A, n("update:modelValue", A);
      }
    });
    le(r, (A) => n("update:modelValue", A), {
      deep: !0
    });
    const { undo: i, redo: s, canUndo: l, canRedo: c, pause: u, resume: d, clearSharedHistory: p } = cr(r), { editingSharedContent: h } = De({
      state: o
    }), { getHistory: C } = ks(o);
    Ra(() => {
      p();
    });
    const f = _(() => {
      if (h.value) {
        const { canUndo: A } = C(
          h.value.sharedContentId
        );
        return !A;
      }
      return !l.value;
    }), v = () => {
      if (u(), h.value) {
        const { undo: A } = C(
          h.value.sharedContentId
        );
        A();
        return;
      }
      i(), Pe(() => {
        d();
      });
    }, S = _(() => {
      if (h.value) {
        const { canRedo: A } = C(
          h.value.sharedContentId
        );
        return !A;
      }
      return !c.value;
    }), T = () => {
      if (u(), h.value) {
        const { redo: A } = C(
          h.value.sharedContentId
        );
        A();
        return;
      }
      s(), Pe(() => {
        d();
      });
    }, {
      duplicateNode: m,
      deleteNode: O,
      copySelectedNode: I,
      cutSelectedNode: g,
      dataInClipboard: N,
      pasteNode: D
    } = Ms({
      state: o.value
    });
    vS({
      state: o.value,
      duplicateNode: m,
      deleteNode: O,
      copySelectedNode: I,
      cutSelectedNode: g,
      dataInClipboard: N,
      pasteNode: D,
      allowArrowNavigation: !0,
      undo: v,
      redo: T
    }), Ba();
    function U(A = "header") {
      var $;
      ($ = o == null ? void 0 : o.value) == null || $.setActiveNode({ id: A });
    }
    function F() {
      var A;
      (A = o == null ? void 0 : o.value) == null || A.clearActiveNode();
    }
    return (A, $) => {
      var x, B, R, z, J, ne;
      return y(), M("div", mS, [
        w("section", bS, [
          e.isEditable ? (y(), W(gS, {
            key: 0,
            builder: r.value,
            "redo-disabled": S.value,
            "undo-disabled": f.value,
            onRedo: T,
            onUndo: v,
            onToggleModal: $[0] || ($[0] = (ce) => A.$emit("toggle-modal", ce))
          }, {
            "header-preview": P(() => [
              Ne(A.$slots, "header-preview", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["builder", "redo-disabled", "undo-disabled"])) : q("", !0)
        ]),
        w("section", {
          class: me(["builder-draggable-section", { "is-editable": e.isEditable }])
        }, [
          (R = (B = (x = r.value) == null ? void 0 : x.customProperties) == null ? void 0 : B.global) != null && R.showHeaderSlot ? Ne(A.$slots, "header", {
            key: 0,
            openSidebar: U,
            closeSidebar: F
          }, void 0, !0) : q("", !0),
          E(V(a), {
            modelValue: r.value.structure,
            "onUpdate:modelValue": $[1] || ($[1] = (ce) => r.value.structure = ce),
            "is-editable": e.isEditable
          }, null, 8, ["modelValue", "is-editable"]),
          (ne = (J = (z = r.value) == null ? void 0 : z.customProperties) == null ? void 0 : J.global) != null && ne.showFooterSlot ? Ne(A.$slots, "footer", { key: 1 }, void 0, !0) : q("", !0)
        ], 2)
      ]);
    };
  }
}, yS = /* @__PURE__ */ X(_S, [["__scopeId", "data-v-19275ca3"]]), CS = {
  key: 1,
  class: "non-editable-entry"
}, wS = { class: "icons-container" }, $S = {
  key: 1,
  class: "non-editable-entry"
}, SS = { class: "icons-container" }, NS = { class: "button-container" }, AS = {
  __name: "CustomAttributesSidebar",
  setup(e) {
    const t = ue("state"), n = H(-1), o = H(null), a = H(null), r = H(null), i = H(!0), s = H(!0), l = _({
      get: () => {
        var $, x;
        return ((x = ($ = t == null ? void 0 : t.value) == null ? void 0 : $.activeNode.properties) == null ? void 0 : x.anchorTag) || "";
      },
      set: ($) => {
        t.value.activeNode.properties.anchorTag = $;
      }
    }), c = _({
      get: () => {
        var $, x;
        return ((x = ($ = t == null ? void 0 : t.value) == null ? void 0 : $.activeNode.properties) == null ? void 0 : x.customClasses) || [];
      },
      set: ($) => t.value.activeNode.properties.customClasses = $
    }), u = _(
      () => c.value[n.value]
    ), d = _(() => D(l.value)), p = _(
      () => D(u.value)
    ), h = _(
      () => p.value || d.value
    );
    Ue(() => {
      var $;
      o.value = ($ = t == null ? void 0 : t.value) == null ? void 0 : $.activeNode.id, !(c.value.length > 0) && (n.value = 0, c.value.push(""));
    }), Ra(() => {
      C(o.value);
    });
    const C = ($) => {
      var B, R;
      const x = We((B = t == null ? void 0 : t.value) == null ? void 0 : B.builder.structure, $);
      !x || !((R = x == null ? void 0 : x.properties) != null && R.customClasses) || (x.properties.customClasses = x.properties.customClasses.filter(
        (z) => !!(z != null && z.trim())
      ));
    }, f = ($) => {
      var R, z;
      if (!$.value)
        return;
      const x = ((R = $.value) == null ? void 0 : R.$el) || ((z = $.value[0]) == null ? void 0 : z.$el);
      if (!x)
        return;
      const B = x.querySelector("input");
      B && B.focus();
    }, v = () => {
      s.value = !0, Pe(() => f(r));
    }, S = ($) => {
      p.value || (i.value = !0, n.value = $, Pe(() => f(a)));
    }, T = _(() => {
      const $ = c.value[c.value.length - 1];
      return !p.value && $ !== "";
    }), m = () => {
      var $, x;
      ($ = t == null ? void 0 : t.value) == null || $.activeNode.properties.customClasses.push(""), i.value = !0, n.value = ((x = t == null ? void 0 : t.value) == null ? void 0 : x.activeNode.properties.customClasses.length) - 1, Pe(() => f(a));
    }, O = () => {
      t.value.activeNode.properties.anchorTag = "", s.value = !0, Pe(() => f(r));
    }, I = _(() => c.value.length > 1), g = ($) => {
      var x;
      (x = t == null ? void 0 : t.value) == null || x.activeNode.properties.customClasses.splice($, 1), $ <= n.value && (n.value -= 1), a.value && Pe(() => f(a));
    }, N = /^(?!-\d)[a-zA-Z_-](?:[a-zA-Z0-9_-]|\\[^\n\r])*$/, D = ($) => $ !== "" && !N.test($), U = () => {
      !l.value || d.value || (s.value = !1);
    }, F = () => {
      !u.value || p.value || (i.value = !1);
    }, A = () => {
      h.value || (t.value.showCustomAttributesSidebar = !1);
    };
    return ($, x) => {
      const B = L("a-form-input"), R = L("a-icon"), z = L("a-button");
      return y(), M(ke, null, [
        E(ir, {
          title: $.$t("builder.controls.customAttributes.title"),
          onCloseSidebar: A
        }, null, 8, ["title"]),
        E(ht, null, {
          title: P(() => [
            w("h4", null, K($.$t("builder.controls.customAttributes.anchorTagLabel")), 1)
          ]),
          content: P(() => [
            s.value ? (y(), W(B, {
              key: 0,
              modelValue: l.value,
              "onUpdate:modelValue": x[0] || (x[0] = (J) => l.value = J),
              id: "anchor-tag-input",
              ref_key: "anchorInput",
              ref: r,
              placeholder: $.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              label: $.$t("builder.controls.customAttributes.anchorTagPlaceholder"),
              "sr-only": "",
              "label-for": "anchor-tag-input",
              "show-error": d.value,
              "error-message": $.$t("builder.controls.customAttributes.invalidAttributeError", {
                attribute: $.$t("builder.controls.customAttributes.anchorTagLabel")
              }),
              onKeydown: fr(U, ["enter"]),
              onBlur: U
            }, null, 8, ["modelValue", "placeholder", "label", "show-error", "error-message"])) : (y(), M("div", CS, [
              w("p", null, K(l.value), 1),
              w("div", wS, [
                E(z, {
                  variant: "default",
                  size: "small",
                  onClick: v
                }, {
                  default: P(() => [
                    E(R, { icon: "16:edit" })
                  ]),
                  _: 1
                }),
                E(z, {
                  variant: "default",
                  size: "small",
                  onClick: O
                }, {
                  default: P(() => [
                    E(R, { icon: "16:trashcan" })
                  ]),
                  _: 1
                })
              ])
            ]))
          ]),
          _: 1
        }),
        E(ht, null, {
          title: P(() => [
            w("h4", null, K($.$t("builder.controls.customAttributes.customClassLabel")), 1)
          ]),
          content: P(() => [
            (y(!0), M(ke, null, nt(c.value, (J, ne) => (y(), M("div", {
              key: ne,
              class: "custom-class-container"
            }, [
              i.value && ne === n.value ? (y(), W(B, {
                key: 0,
                modelValue: c.value[ne],
                "onUpdate:modelValue": (ce) => c.value[ne] = ce,
                id: `custom-class-input-${ne}`,
                ref_for: !0,
                ref_key: "classInput",
                ref: a,
                placeholder: $.$t("builder.controls.customAttributes.customClassPlaceholder"),
                label: $.$t("builder.controls.customAttributes.customClassPlaceholder"),
                "sr-only": "",
                "label-for": `custom-class-input-${ne}`,
                "show-error": p.value,
                "error-message": $.$t("builder.controls.customAttributes.invalidAttributeError", {
                  attribute: $.$t(
                    "builder.controls.customAttributes.customClassLabel"
                  )
                }),
                onKeydown: fr(F, ["enter"]),
                onBlur: F
              }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "placeholder", "label", "label-for", "show-error", "error-message"])) : (y(), M("div", $S, [
                w("p", null, K(J), 1),
                w("div", SS, [
                  E(z, {
                    variant: "default",
                    size: "small",
                    onClick: (ce) => S(ne)
                  }, {
                    default: P(() => [
                      E(R, { icon: "16:edit" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  I.value ? (y(), W(z, {
                    key: 0,
                    variant: "default",
                    size: "small",
                    onClick: (ce) => g(ne)
                  }, {
                    default: P(() => [
                      E(R, { icon: "16:trashcan" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : q("", !0)
                ])
              ]))
            ]))), 128)),
            w("div", NS, [
              E(z, {
                variant: "link",
                disabled: !T.value,
                onClick: m
              }, {
                default: P(() => [
                  E(R, { icon: "16:plus" }),
                  fe(" " + K($.$t("builder.controls.customAttributes.addAnotherClass")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ], 64);
    };
  }
};
function TS(e, t, n = { childList: !0, subtree: !0 }, o = 50) {
  const a = H(null), r = H(!1);
  let i = null, s = null;
  const l = () => {
    s && clearTimeout(s), s = setTimeout(() => {
      r.value = !!document.querySelector(t);
    }, o);
  }, c = () => {
    i = new MutationObserver(() => {
      l();
    }), a.value && i.observe(a.value, n);
  };
  return Ue(() => {
    if (document) {
      if (a.value = document.querySelector(e), !a.value) {
        console.error(
          `Target element with selector "${e}" not found`
        );
        return;
      }
      r.value = !!document.querySelector(t), c();
    }
  }), Ea(() => {
    i && i.disconnect(), s && clearTimeout(s);
  }), { elementExists: r };
}
const OS = { class: "sidebar-container" }, IS = { class: "root-dialog-container" }, ES = {
  __name: "PageBuilder",
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    isRenderMode: Boolean
  },
  emits: [
    "toggle-modal",
    "update:modelValue",
    "ai-on-success",
    "ai-on-loading",
    "ai-on-error",
    "amplitude-event",
    "toast-message"
  ],
  setup(e, { emit: t }) {
    const n = t, o = H(!1), a = (m) => {
      o.value = m, n("toggle-modal", m);
    }, { elementExists: r } = TS(
      ".root-dialog-container",
      ".a-dialog"
    );
    le(r, (m) => {
      n("toggle-modal", m);
    });
    const i = e, s = H(Ef(n));
    vn("state", s), vn("isRenderMode", i.isRenderMode), Ue(() => {
      var m;
      (m = navigator == null ? void 0 : navigator.userAgentData) != null && m.platform && (s.value.userAgent = navigator.userAgentData.platform.toLowerCase().includes("mac") ? "mac" : "windows");
    });
    const l = _(() => {
      var m;
      return (m = s == null ? void 0 : s.value) == null ? void 0 : m.builder.customProperties;
    }), c = _(
      () => l.value.global.maxNestingLevelsAllowed
    );
    vn("maxNestingLevelsAllowed", c);
    const u = _(() => i.modelValue);
    s.value.builder = u.value instanceof Pr ? u.value : new Pr(u.value);
    const d = _(
      () => {
        var m;
        return xf((m = s == null ? void 0 : s.value) == null ? void 0 : m.builder);
      }
    ), { extractSharedContentIds: p } = De({
      state: s
    });
    u.value.extractSharedContentIds = p;
    const h = _(
      () => {
        var m, O, I;
        return (m = s == null ? void 0 : s.value) != null && m.showCustomAttributesSidebar ? "" : ((I = (O = s == null ? void 0 : s.value) == null ? void 0 : O.activeNode) == null ? void 0 : I.id) || "";
      }
    ), C = _(() => l.value.nodesIncluded), f = _(() => l.value.nodesExcluded), v = H("content"), S = (m) => {
      v.value = m;
    }, T = _(() => v.value === "content" ? { "overflow-y": "auto", "overflow-x": "hidden" } : {});
    return (m, O) => {
      var I;
      return y(), M("div", {
        style: Ie(d.value),
        class: "pb-main"
      }, [
        i.isRenderMode ? q("", !0) : (y(), M("section", {
          key: 0,
          class: "sidebar-section",
          style: Ie(T.value)
        }, [
          w("div", OS, [
            s.value.showCustomAttributesSidebar ? (y(), W(AS, {
              key: (I = s.value.activeNode) == null ? void 0 : I.id
            })) : (y(), W(V(ro), {
              key: 1,
              name: h.value
            }, {
              default: P(() => [
                E(nS, {
                  builder: s.value.builder,
                  "nodes-included": C.value,
                  "nodes-excluded": f.value,
                  onSwitchTab: S
                }, null, 8, ["builder", "nodes-included", "nodes-excluded"])
              ]),
              _: 1
            }, 8, ["name"]))
          ])
        ], 4)),
        w("section", {
          class: "builder-section",
          style: Ie({ "z-index": o.value ? 1 : 0 })
        }, [
          E(yS, {
            "is-editable": !i.isRenderMode,
            "onUpdate:modelValue": O[0] || (O[0] = (g) => m.$emit("update:modelValue", g)),
            onToggleModal: a
          }, {
            header: P(({ openSidebar: g, closeSidebar: N }) => [
              Ne(m.$slots, "header", {
                openSidebar: g,
                closeSidebar: N
              }, void 0, !0)
            ]),
            "header-preview": P(() => [
              Ne(m.$slots, "header-preview", {}, void 0, !0)
            ]),
            footer: P(() => [
              Ne(m.$slots, "footer", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["is-editable"])
        ], 4),
        w("div", IS, [
          E(V(ro), { name: "root-dialog-container" })
        ])
      ], 4);
    };
  }
}, xS = /* @__PURE__ */ X(ES, [["__scopeId", "data-v-d2ec04ff"]]), QS = {
  install(e) {
    e.use(tl), e.component("ABuilder", xS);
  }
};
export {
  Qo as $,
  Wo as A,
  Ge as B,
  Re as C,
  b5 as D,
  at as E,
  gi as F,
  ff as G,
  Gt as H,
  p_ as I,
  Ze as J,
  Fu as K,
  LS as L,
  E5 as M,
  ht as N,
  J0 as O,
  si as P,
  oi as Q,
  o1 as R,
  ir as S,
  Ms as T,
  pn as U,
  xs as V,
  GS as W,
  YS as X,
  He as Y,
  Xe as Z,
  X as _,
  HS as a,
  QS as a0,
  ve as a1,
  Xt as a2,
  Kt as a3,
  qt as a4,
  Qt as a5,
  St as a6,
  Jt as a7,
  en as a8,
  Se as a9,
  Ls as aA,
  KS as aB,
  qS as aC,
  Nt as aa,
  mn as ab,
  Dn as ac,
  ao as ad,
  io as ae,
  Cn as af,
  so as ag,
  lo as ah,
  co as ai,
  uo as aj,
  po as ak,
  wn as al,
  $n as am,
  ho as an,
  Ye as ao,
  Sn as ap,
  Nn as aq,
  Pr as ar,
  ye as as,
  ot as at,
  jS as au,
  VS as av,
  FS as aw,
  zS as ax,
  WS as ay,
  XS as az,
  A1 as b,
  ft as c,
  Zi as d,
  Ko as e,
  We as f,
  ut as g,
  US as h,
  BS as i,
  T1 as j,
  Pf as k,
  vr as l,
  di as m,
  zf as n,
  RS as o,
  x2 as p,
  t3 as q,
  pi as r,
  d3 as s,
  U0 as t,
  ZS as u,
  S3 as v,
  A3 as w,
  O3 as x,
  Go as y,
  Bn as z
};
